/* AllFun Games — what every page shares (PREVIEW): the phone menu (☰), the header's coins and Sign in (Profile),
   the bottom dock (Games · Continue · Favorites · Search), and the Continue, Favorites, Search and Sign in
   sheets, with the favorites and the progress read from this device.
   Loaded by the home page and by Privacy, Terms and Contact, after their markup and before the page's own
   script. The home page's preview.js adds what only it has (the Continue row, the hearts on the tiles, the
   filters, …) through window.AllFun.
   The markup of the menu, the dock and the sheets lives here only. A page's HTML keeps just a plain fallback
   (the four links in #site-menu) and this script builds the rest. Links to the home page's sections are
   "#library" on the home page and "/#library" on the others.
   Every storage read is wrapped: a private window or blocked storage just hides the personal parts. */

/* No zooming the page by accident (owner, 19.10): double-tap zoom is turned off with touch-action. Pinch zoom is
   allowed again on the site's pages (owner approved, 21.10: accessibility; the games keep their own no-zoom). */
(function () {
  try {
    document.documentElement.style.touchAction = 'manipulation';
    if (document.body) document.body.style.touchAction = 'manipulation';
  } catch (e) { /* fine */ }
})();

(function () {
  'use strict';

  // ---- ads and consent (not live yet) --------------------------------------------------------------
  // The site-wide ads switch (games/shared/ads-config.ts, read through assets/wallet.js, which loads first). Off (22.10,
  // the AdSense review): no "video" offer anywhere (the nickname change is paid in coins only) and no "Coming soon".
  // In the pages: [data-ads-on] exists only while ads are live (the Coming soon section, tile, menu tile and links, the
  // Terms' "short videos"), [data-ads-off] only while they are off; scripts/build-site.mjs already keeps the right ones
  // in the built pages, and build() below does it for a page served without that step.
  var ADS_LIVE = !!(window.AllFunWallet && window.AllFunWallet.ADS_LIVE);
  // TODO(AdSense): once the AdSense account is approved, the consent message goes here: load Google's own consent
  // message (Privacy & messaging, a certified CMP with IAB TCF v2.2) before the AdSense script, so visitors in the EEA,
  // the UK and Switzerland choose before any personalised ad or ad cookie; elsewhere a small "Ads & privacy" link in the
  // footer reopens it. Add /ads.txt at the same time (it needs the publisher ID). privacy.html already describes both.

  // ---- AllFun's social accounts: paste each page's full address here (https://…). ---------------
  // Only the ones filled in are shown. While all five are empty, the menu and the footer show nothing at
  // all (owner, 15.10: social comes in the last stage), and leave no gap.
  var SOCIAL = { facebook: 'https://www.facebook.com/allfungames.official/', instagram: 'https://www.instagram.com/allfungames.official/', tiktok: 'https://www.tiktok.com/@allfungames.official', youtube: '', x: '' };

  // One entry per game (the menu's and the footer's order come from the footer's chips; the order of everything is
  // the home grid's: arcade first, owner 16.10). Adding a game (Brick Breaker, Four in a Row, Gin Rummy, Pyramid, Snake
  // and Chess were added this way, round 72; Racing, Basketball, Darts, Flags & Capitals and Pack the Suitcase, round 85;
  // Ladle Lane and Pinch & Plate, round 94; Lampwire Dash, round 98; Trivia, round 112; Lagoon Lineup, Ludo,
  // Lamplight Billiards, Tinker Tumble, Pinwheel Mini Golf and Pip Parlor, 17.10; Beamfall, 18.10; Dustup Ranch and Plush Pluck, 19.10; Crossword and Memory, 27.10; Cinderpoint, Bingo, Fizzwell and Strike District, 28.10):
  //  1. an entry here, a reader in READERS (the game's own save.ts) and its save keys in SAVE_KEYS;
  //  2. a .t-<slug> (tile) and .fg-<slug> (chip) colour in shared.css, in a colour no other game uses;
  //  3. a footer chip (24×24 icon) on all four pages, in the home grid's order (the Continue pictures borrow it), and
  //     its category in CATEGORY below (the menu's category cards count from it). Count the chips: the footer's Coming
  //     soon chip (.ft-wide / .ft-three / .ft-full) closes the grid;
  //  4. on the home page: a tile in #games-grid (an animated .lg-<x> logo, class "anim" so it rests off screen,
  //     data-cat for the filters, several allowed, e.g. "arcade sport"; its CSS in home.css with a still frame for
  //     reduced motion, or a self-animating SVG with class "smil" and data-still; a NEW badge moves to it if it is the
  //     newest), a mini picture (home.js miniArt) and the Game of the day list (home.js ORDER);
  //     "More games coming" closes the last row by itself (home.js sizeMore; its data-cat has every filter);
  //  5. nothing to count by hand: every number of games (the menu, the filters, the footer, About, the meta
  //     descriptions) comes from GAMES and CATEGORY (here at start-up and scripts/build-site.mjs at deploy).
  // The next games: arcade and puzzle near the top, card games towards the end (owner, 16.10).
  var GAMES = {
    backgammon: { name: 'Backgammon', full: 'AllFun Backgammon', kind: 'Board game', pitch: 'The classic, every rule included. Play the computer, or online players.' },
    solitaire: { name: 'Solitaire', full: 'AllFun Solitaire', kind: 'Card game', pitch: 'The card classic, every deal winnable. Draw 1 or 3, and a new daily deal.' },
    spider: { name: 'Spider', full: 'AllFun Spider', kind: 'Card game', pitch: 'Ten piles, two decks: build runs from King down to Ace. One, two or four suits, and a daily deal.' },
    freecell: { name: 'FreeCell', full: 'AllFun FreeCell', kind: 'Card game', pitch: 'Four free cells, eight columns, every deal winnable. A million numbered deals, a daily deal and unlimited undo.' },
    hearts: { name: 'Hearts', full: 'AllFun Hearts', kind: 'Card game', pitch: 'Pass three cards, duck the hearts and the Queen of spades, or shoot the moon. Three computer levels.' },
    spades: { name: 'Spades', full: 'AllFun Spades', kind: 'Card game', pitch: 'Bid your tricks with a computer partner, spades are trumps. Nil, bags and three computer levels.' },
    tripeaks: { name: 'TriPeaks', full: 'AllFun TriPeaks', kind: 'Card game', pitch: 'Clear three peaks one card up or down and build long streaks. 72 levels with stars, and a daily deal.' },
    domino: { name: 'Dominoes', full: 'AllFun Dominoes', kind: 'Tile game', pitch: 'Draw, Block or All Fives against up to three computer players.' },
    blocks: { name: 'Blocks', full: 'AllFun Blocks', kind: 'Puzzle', pitch: 'Fit the pieces, clear the lines, beat your best. Endless play, or 30 levels.' },
    sort: { name: 'Sort', full: 'AllFun Sort', kind: 'Puzzle', pitch: 'Pour the colours home, one tube at a time. Calm, clever, 500 levels deep.' },
    merge: { name: 'Merge', full: 'AllFun Merge', kind: 'Puzzle', pitch: 'Drop the numbers, join the twins, chase the big one.' },
    gems: { name: 'Gems', full: 'AllFun Gems', kind: 'Puzzle', pitch: 'Swap the jewels, line up three, set off blasters and bombs. 40 levels.' },
    bubbles: { name: 'Bubbles', full: 'AllFun Bubbles', kind: 'Arcade', pitch: 'Aim, bounce, pop. Match three to burst them and cut the rest loose.' },
    checkers: { name: 'Checkers', full: 'AllFun Checkers', kind: 'Board game', pitch: 'Jumps, kings and the must-capture rule. Three computer levels, one game or first to 3.' },
    sudoku: { name: 'Sudoku', full: 'AllFun Sudoku', kind: 'Puzzle', pitch: 'Four levels, every puzzle with one answer. Notes, hints that explain, and a daily puzzle.' },
    mines: { name: 'Mines', full: 'AllFun Mines', kind: 'Puzzle', pitch: 'Dig, flag, clear the board. The first tap is always safe, and no guessing on Easy and Medium.' },
    airhockey: { name: 'Air Hockey', full: 'AllFun Air Hockey', kind: 'Arcade', pitch: 'A neon table, a gold puck and a quick hand. Play the computer, or a friend on the same screen.' },
    fishing: { name: 'Fishing', full: 'AllFun Fishing', kind: 'Arcade', pitch: 'Time the swinging hook, catch glowing sea life and sunken treasure, and beat the target in 40 levels.' },
    tabletennis: { name: 'Table Tennis', full: 'AllFun Table Tennis', kind: 'Sport', pitch: 'Swipe to hit and curve it with spin. Real rules, three computer players, up to best of 5.' },
    pinball: { name: 'Pinball', full: 'AllFun Pinball', kind: 'Arcade', pitch: 'A neon galaxy table: bumpers, an orbit, multiball and missions. Chase the high score.' },
    snake: { name: 'Snake', full: 'AllFun Snake', kind: 'Arcade', pitch: 'Glide, eat, grow. Classic, a calm Zen mode and levels with mazes, portals and power-ups.' },
    bricks: { name: 'Brick Breaker', full: 'AllFun Brick Breaker', kind: 'Arcade', pitch: 'Bounce the ball and smash the bricks, with charge shots, prisms, warp gates and a boss every 10 levels. 100 levels and Endless.' },
    chess: { name: 'Chess', full: 'AllFun Chess', kind: 'Board game', pitch: 'Every rule, six computer levels and a rating, a friend on the same screen, and a daily puzzle.' },
    fourinarow: { name: 'Four in a Row', full: 'AllFun Four in a Row', kind: 'Board game', pitch: 'Drop your discs, line up four. Four computer levels, or a friend on the same screen.' },
    ginrummy: { name: 'Gin Rummy', full: 'AllFun Gin Rummy', kind: 'Card game', pitch: 'Build runs and sets, knock or go Gin. Three computer levels and a daily challenge.' },
    pyramid: { name: 'Pyramid', full: 'AllFun Pyramid', kind: 'Card game', pitch: 'Pair cards that make 13 and clear the pyramid. 72 levels with stars, and a daily deal.' },
    racing: { name: 'Racing', full: 'AllFun Racing', kind: 'Arcade', pitch: 'Drift through the corners, fill your boost and pass five rivals. Four cups, time trials and a daily race.' },
    basketball: { name: 'Basketball', full: 'AllFun Basketball', kind: 'Sport', pitch: 'Swipe to shoot, chain your makes and get Charged. A 60-second Arcade, 45 challenges and a daily one.' },
    darts: { name: 'Darts', full: 'AllFun Darts', kind: 'Sport', pitch: '501, 301, Cricket and Around the Clock. Four computer players, a friend on the same screen, and 36 challenges.' },
    flags: { name: 'Flags & Capitals', full: 'AllFun Flags & Capitals', kind: 'Quiz', pitch: 'Flags, capitals and map shapes of 195 countries. A daily quiz, and a Learn mode that brings back your misses.' },
    suitcase: { name: 'Pack the Suitcase', full: 'AllFun Pack the Suitcase', kind: 'Puzzle', pitch: 'Fit everything in and close the lid. 156 trips in six destinations, every one solvable, and a daily trip.' },
    chefpath: { name: 'Ladle Lane', full: 'AllFun Ladle Lane', kind: 'Puzzle', pitch: 'Swipe the ingredients in recipe order and serve every customer. 210 levels in six eateries, and a daily special.' },
    chefdeck: { name: 'Pinch & Plate', full: 'AllFun Pinch & Plate', kind: 'Puzzle', pitch: 'Plate lovingly drawn food to match each guest’s taste, find 50 hidden pairings and chase the Golden Pinch. A daily run too.' },
    runner: { name: 'Lampwire Dash', full: 'AllFun Lampwire Dash', kind: 'Arcade', pitch: 'Dash down the lantern bridges of a night market in the sky: swipe between three lanes, jump, slide and run parcels through the rings. A daily run too.' },
    trivia: { name: 'Trivia', full: 'AllFun Trivia', kind: 'Quiz', pitch: 'A quiz show in your pocket: quick 10-question rounds, 12 categories with levels and stars, Survival, duels and a new Daily Trivia every day.' },
    tiles: { name: 'Lagoon Lineup', full: 'AllFun Lagoon Lineup', kind: 'Puzzle', pitch: 'Tap the sea-treasure tiles into your tray and pop three of a kind to clear the lagoon. 160 levels in eight waters, a Daily puzzle and a Sea Album to fill.' },
    ludo: { name: 'Ludo', full: 'AllFun Ludo', kind: 'Board game', pitch: 'Roll the die, race your four tokens home and send rivals back to their yard. Two to four players against the computer, or friends on one device.' },
    billiards: { name: 'Billiards', full: 'AllFun Lamplight Billiards', kind: 'Sport', pitch: 'Pool under a brass lamp: 8-Ball and 9-Ball against four computer rivals, 100 Trick Shots to star, and a new Rack Run every day.' },
    bolts: { name: 'Tinker Tumble', full: 'AllFun Tinker Tumble', kind: 'Puzzle', pitch: 'Twist the screws out of a toymaker’s pegboard into tins of their colour and watch the plates tumble away. 160 levels in eight workshop corners, and a Daily puzzle.' },
    golf: { name: 'Mini Golf', full: 'AllFun Pinwheel Mini Golf', kind: 'Sport', pitch: 'Pull back, aim and putt round six little courses: 54 holes with slopes, sand, ice, ramps and paddle wheels, four computer rivals and a new daily hole.' },
    dice: { name: 'Pip Parlor', full: 'AllFun Pip Parlor', kind: 'Dice', pitch: 'Roll five dice up to three times, keep the ones you like and fill the thirteen boxes of your scorecard. Play solo, four computer rivals or friends, and the same Daily dice for everyone.' },
    royale: { name: 'Beamfall', full: 'AllFun Beamfall', kind: 'Arcade', pitch: 'Glide down onto a floating island in space with 29 rivals, grab laser blasters and shields, dash, tag them out and outlast the storm. The last beam standing wins.' },
    lasso: { name: 'Dustup Ranch', full: 'AllFun Dustup Ranch', kind: 'Arcade', pitch: 'Swipe to toss the lasso and rope the herd running down a Wild West street: Longhorns, two-loop Hotheads, zig-zag goats and the rare Golden Bull. 30 levels in three towns and a daily round.' },
    claw: { name: 'Plush Pluck', full: 'AllFun Plush Pluck', kind: 'Arcade', pitch: 'A claw machine with cute original plush: steer with the joystick, press DROP and grab them for your Prize Shelf. Four machines, 24 plush, 2 free tries a day.' },
    crossword: { name: 'Crossword', full: 'AllFun Crossword', kind: 'Puzzle', pitch: 'A new Daily Crossword every day and 150 puzzles from a quick 5×5 to a grand 13×13, Easy to Hard. Every clue written by us, with Check, Reveal and Pencil when you need them.' },
    memory: { name: 'Memory', full: 'AllFun Memory', kind: 'Puzzle', pitch: 'Flip two cards and find the pairs: 72 levels in six decks of original pictures, a Daily Memory, two players on one device and a computer opponent.' },
    cinderpoint: { name: 'Cinderpoint', full: 'AllFun Cinderpoint', kind: 'Arcade', pitch: 'A first-person 3D arena shooter: pick a runner and a weapon, then take on five computer runners in three arenas. First to 15 eliminations wins.' },
    bingo: { name: 'Bingo', full: 'AllFun Bingo', kind: 'Board game', pitch: '75-ball bingo just for fun: daub your numbers as Callie calls them and shout BINGO! when the pattern is done. One to four cards, 36 rounds in four rooms and a Daily Bingo.' },
    fizzwell: { name: 'Fizzwell', full: 'AllFun Fizzwell', kind: 'Arcade', pitch: 'Climb out of an old well before the glowing Fizz rising below catches you: run, jump and bounce off the walls, chain tricks for Flow and open Gates to new zones. 30 challenges and a daily one.' },
    motorush: { name: 'Moto Rush', full: 'AllFun Moto Rush', kind: 'Arcade', pitch: 'Race five riders through a seafront at sunset, a city centre by day and a neon night: lean through the bends, nitro on the straights, pass traffic close. Online and with friends.' },
    strikedistrict: { name: 'Strike District', full: 'AllFun Strike District', kind: 'Arcade', pitch: 'A 2D arcade fighter: four fighters, six city arenas, best of three rounds. Jab, kick, guard, chain your hits and land your special against the computer, a player online or a friend.' },
    skyshot: { name: 'Skyshot Slugger', full: 'AllFun Skyshot Slugger', kind: 'Sport', pitch: 'Step up to the plate in a 3D ballpark: read the pitch, time your swing, aim and send the ball over the wall. 12 home run challenges in three parks.' },
    wordwheel: { name: 'Letter Lark', full: 'AllFun Letter Lark', kind: 'Puzzle', pitch: 'Drag across a wheel of letters to spell words and fill a little crossword. 300 levels in 15 skies, bonus words, a Daily wheel and Word Search.' },
    crazyeights: { name: 'Crazy Eights', full: 'AllFun Crazy Eights', kind: 'Card game', pitch: 'The classic card game with a standard deck: match the suit or the rank, play an 8 to name the suit, and be the first to empty your hand. Against the computer, online or with a friend.' }
  };
  var SLUGS = Object.keys(GAMES);
  // The home grid's filters (each tile's data-cat on the home page, the same here): the phone menu's category cards
  // count from it. Racing is Arcade and Sport.
  var CATEGORY = {
    bubbles: 'arcade', tiles: 'puzzle', gems: 'puzzle', billiards: 'sport', blocks: 'puzzle', trivia: 'puzzle',
    bolts: 'puzzle', solitaire: 'cards', ludo: 'board', sort: 'puzzle', golf: 'sport', basketball: 'sport',
    merge: 'puzzle', dice: 'board', tripeaks: 'cards', runner: 'arcade', chefpath: 'puzzle', backgammon: 'board',
    spider: 'cards', snake: 'arcade', sudoku: 'puzzle', racing: 'arcade sport', bricks: 'arcade', domino: 'board',
    chess: 'board', mines: 'puzzle', pyramid: 'cards', chefdeck: 'puzzle', fourinarow: 'board', checkers: 'board',
    freecell: 'cards', hearts: 'cards', spades: 'cards', ginrummy: 'cards', pinball: 'arcade', darts: 'sport',
    tabletennis: 'sport', fishing: 'arcade', flags: 'puzzle', airhockey: 'arcade', suitcase: 'puzzle', royale: 'arcade', lasso: 'arcade', claw: 'arcade', crossword: 'puzzle', memory: 'puzzle', cinderpoint: 'arcade', bingo: 'board', fizzwell: 'arcade', motorush: 'arcade sport', strikedistrict: 'arcade', skyshot: 'sport', wordwheel: 'puzzle', crazyeights: 'cards'
  };
  var HOME_KEY = 'allfun.home.v1'; // the site's own memory: opened, hidden, favs (see "hiding games" below)
  var onHome = document.body.classList.contains('home');

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fmt = function (n) { return Number(n || 0).toLocaleString('en-US'); };
  var esc = function (s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
  var plural = function (n, one, many) { return n + ' ' + (n === 1 ? one : many); };

  function read(key) {
    try {
      var raw = window.localStorage.getItem(key);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }
  function write(key, value) {
    try { window.localStorage.setItem(key, JSON.stringify(value)); } catch (e) { /* storage blocked: fine */ }
  }
  function count(obj) { return obj && typeof obj === 'object' ? Object.keys(obj).length : 0; }
  function levelName(l) { return typeof l === 'string' && l ? l.charAt(0).toUpperCase() + l.slice(1) : 'In progress'; }
  function clock(ms) { var t = Math.round(ms / 1000); return Math.floor(t / 60) + ':' + String(t % 60).padStart(2, '0'); }
  function sumStars(levels) {
    var total = 0;
    if (levels && typeof levels === 'object') for (var k in levels) total += Number(levels[k]) || 0;
    return total;
  }
  function nextLevel(levels, max) {
    for (var n = 1; n <= max; n += 1) if (!levels || !levels[n]) return n;
    return max;
  }
  function dateKey(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  function levelFromXp(xp) { // src/game/profile.ts with the default config (baseXp 120, growth 1.35)
    var level = 1, rest = Math.max(Number(xp) || 0, 0);
    for (var i = 0; i < 200; i += 1) {
      var need = Math.round(120 * Math.pow(1.35, level - 1));
      if (rest < need) return level;
      rest -= need; level += 1;
    }
    return level;
  }

  // ==== THE MARKUP ===================================================================================
  // {H} becomes "" on the home page and "/" elsewhere, so "{H}#library" always reaches the games.

  // Icons used by the menu, the dock and the sheets (the home page's own pictures stay in its HTML).
  var DEFS = `<svg class="defs" style="position:absolute;width:0;height:0;overflow:hidden" width="0" height="0" aria-hidden="true" focusable="false"><defs>
  <linearGradient id="fav-g" x1=".2" y1="0" x2=".7" y2="1"><stop offset="0" stop-color="#ffc2d2"/><stop offset=".45" stop-color="#ff6f95"/><stop offset="1" stop-color="#d42c62"/></linearGradient>
  <symbol id="i-heart" viewBox="0 0 24 24"><path d="M12 20.4l-1.25-1.14C6.3 15.24 3.4 12.6 3.4 9.33 3.4 6.69 5.47 4.6 8.1 4.6c1.49 0 2.92.69 3.9 1.79.98-1.1 2.41-1.79 3.9-1.79 2.63 0 4.7 2.09 4.7 4.73 0 3.27-2.9 5.91-7.35 9.94z"/></symbol>
  <linearGradient id="afc-gold" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#ffe9a3"/><stop offset=".45" stop-color="#f7bd3a"/><stop offset="1" stop-color="#c9801a"/></linearGradient>
  <symbol id="i-user" viewBox="0 0 24 24"><circle cx="12" cy="8.6" r="3.7"/><path d="M4.9 19.6c1.1-3.4 3.9-5.3 7.1-5.3s6 1.9 7.1 5.3"/></symbol>
</defs></svg>`;

  // The menu. On a computer only the four links show, in a row. On a phone (the ☰ button) this is a
  // full-screen sheet that fits one screen: the logo; a 2-column grid (Sign in | Continue, then Games,
  // Daily, Coming soon, Guides, Contact as tiles; owner 1.11: Guides before Contact, on a phone in Contact's row); the home grid's categories as cards (All games, Favorites, Arcade,
  // Puzzle, Board, Cards, Sport, each with its count: owner, 17.10, instead of every game); one last row with
  // Privacy, Terms and the © (the social links join it once SOCIAL above has an address; until then they
  // render nothing). Sign in is design only for now: it opens the "Join AllFun" sheet; signed in, it reads
  // "Account".
  var MENU = `    <div class="m-head" aria-hidden="true">
      <img class="m-logo" src="/assets/img/allfun-logo-120.webp" width="187" height="120" alt="">
      <span>AllFun Games</span>
    </div>
    <div class="m-list">
      <button class="m-acct" type="button" aria-haspopup="dialog" style="--i:0">
        <span class="av" aria-hidden="true"><svg viewBox="0 0 24 24"><use href="#i-user"/></svg></span>
        <span class="m-acct-tx"><b>Sign in</b><span>Save your progress</span></span>
        <svg class="m-acct-go" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
      </button>
      <button class="m-cont" type="button" aria-haspopup="dialog" hidden style="--i:1">
        <span class="m-cont-art" aria-hidden="true"></span>
        <span class="m-cont-tx"><b>Continue</b><span class="m-cont-sub"></span></span>
        <span class="m-cont-go" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M7.5 5v14l11-7z"/></svg></span>
      </button>
      <a class="link m-item mi-games" href="{H}#library" style="--i:2">
        <span class="m-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="3.5" y="3.5" width="7.5" height="7.5" rx="2.2"/><rect x="13" y="3.5" width="7.5" height="7.5" rx="2.2"/><rect x="3.5" y="13" width="7.5" height="7.5" rx="2.2"/><circle cx="16.75" cy="16.75" r="3.9"/></svg></span>
        <span class="m-tx"><b class="m-t">Games</b><span class="m-sub" data-games-n>Fifty-four, all free</span></span>
        <svg class="m-go" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
      </a>
      <a class="link m-item mi-daily" href="{H}#daily" style="--i:3">
        <span class="m-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="3.5" y="5" width="17" height="15.5" rx="3"/><path d="M3.5 10h17M8.5 3v4M15.5 3v4"/><path d="M9.3 14.8l1.9 1.9 3.6-3.6"/></svg><i class="m-dot"></i></span>
        <span class="m-tx"><b class="m-t">Daily</b><span class="m-sub" id="m-daily-sub">New every day</span></span>
        <svg class="m-go" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
      </a>
      <a class="link m-item mi-soon" href="{H}#soon" style="--i:4" data-ads-on>
        <span class="m-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M12 3.2Q13 11 20.8 12Q13 13 12 20.8Q11 13 3.2 12Q11 11 12 3.2Z"/><circle cx="19" cy="5" r="1.4"/></svg></span>
        <span class="m-tx"><b class="m-t">Coming soon</b><span class="m-sub">New every week</span></span>
        <svg class="m-go" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
      </a>
      <a class="link m-item mi-guides" href="/guides/" style="--i:5">
        <span class="m-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M12 6.6C10.3 5.2 7.9 4.6 4.5 4.7v13.1c3.4-.1 5.8.5 7.5 1.9 1.7-1.4 4.1-2 7.5-1.9V4.7c-3.4-.1-5.8.5-7.5 1.9Z"/><path d="M12 6.6v13.1"/></svg></span>
        <span class="m-tx"><b class="m-t">Guides</b><span class="m-sub">Tips for every game</span></span>
        <svg class="m-go" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
      </a>
      <a class="link m-item mi-contact" href="/contact.html" style="--i:6">
        <span class="m-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M4 6.5A3 3 0 0 1 7 3.5h10a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-5.5L7 20.5v-4A3 3 0 0 1 4 13.5Z"/><path d="M8.5 9h7M8.5 12.5h4.5"/></svg></span>
        <span class="m-tx"><b class="m-t">Contact</b><span class="m-sub">Ideas, bugs, hello</span></span>
        <svg class="m-go" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
      </a>
    </div>
    <div class="m-games" style="--i:7" role="group" aria-labelledby="m-cats-h">
      <p class="m-h" id="m-cats-h">Browse by category</p>
      <div class="m-cats"></div>
    </div>
    <div class="m-end" style="--i:8">
      <div class="m-social soc" data-social hidden></div>
      <div class="m-foot"><a href="/privacy.html">Privacy</a><a href="/terms.html">Terms</a><button class="m-install" type="button" data-install><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 4.2v10.6M7.4 10.4 12 15l4.6-4.6M5.6 19.6h12.8"/></svg>Install app</button><span>© 2026 AllFun Games</span></div>
    </div>`;

  // The header's coin counter (owner approved, 20.10: the gold chip with the balance and "+"; on a phone without
  // the "+") and, beside it, Sign in (owner, 21.10: Continue left the header, it is in the dock; signed in the button
  // reads "Profile", with the player's initial or picture, and opens the account). The balance is the site's shared
  // wallet (assets/wallet.js), kept live by renderNavCoins below. Tapping it ([data-wallet-open]) opens the wallet
  // sheet (WALLET below).
  var NAV_BTNS = `  <button class="nav-coins" type="button" data-wallet-open aria-label="Your coins: 0">
    <svg class="ncn-coin" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="10.5" fill="url(#afc-gold)"/><circle class="ncn-ring" cx="12" cy="12" r="7.6" fill="none" stroke="#a8620f" stroke-opacity=".55" stroke-width="1.2"/><path d="M12 7.2l1.4 3 3.2.3-2.4 2.1.7 3.2L12 14.2l-2.9 1.6.7-3.2-2.4-2.1 3.2-.3z" fill="#fff5d1"/></svg>
    <span class="ncn-n" aria-hidden="true">0</span><span class="ncn-plus" aria-hidden="true">+</span>
  </button>
  <button class="nav-signin" type="button" aria-haspopup="dialog">
    <span class="av" aria-hidden="true"><svg viewBox="0 0 24 24"><use href="#i-user"/></svg><i class="av-i"></i></span><span class="ns-tx">Sign in</span>
  </button>`;

  // The bottom dock (phone and computer): Games · Continue · Favorites · Search. The glowing pill rides on Games
  // while the games are on screen (home page), and on Continue, Favorites or Search while their sheet is open.
  // Continue opens the list of paused games (or Backgammon on a first visit); Favorites opens the saved games,
  // with a count; Search (owner, 21.10, in place of Sign in, which is in the header) opens the quick game search.
  var DOCK = `<nav class="dock" aria-label="Quick links">
  <span class="dock-pill" aria-hidden="true"></span>
  <a class="dock-item" href="{H}#library" data-sec="library"><span class="dock-ic"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="4" y="4" width="7" height="7" rx="1.6"/><rect x="13" y="4" width="7" height="7" rx="1.6"/><rect x="4" y="13" width="7" height="7" rx="1.6"/><circle cx="16.5" cy="16.5" r="3.5"/></svg></span><span>Games</span></a>
  <a class="dock-item dock-cont" href="/backgammon/"><span class="dock-ic"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M10 8.5v7l5.5-3.5z" fill="currentColor"/></svg><b class="dock-n" aria-hidden="true" hidden></b></span><span class="dock-cont-label">Backgammon</span></a>
  <button class="dock-item dock-fav" type="button" aria-haspopup="dialog" aria-label="Favorites"><span class="dock-ic"><svg viewBox="0 0 24 24" aria-hidden="true"><use href="#i-heart"/></svg><b class="dock-n dock-fn" aria-hidden="true" hidden></b></span><span>Favorites</span></button>
  <button class="dock-item dock-search" type="button" aria-haspopup="dialog" aria-label="Search games"><span class="dock-ic"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.8" cy="10.8" r="6.3"/><path d="M15.4 15.4l4.6 4.6"/></svg></span><span>Search</span></button>
</nav>
<p class="sr-only" id="fav-live" aria-live="polite"></p>`;

  // The three sheets: a bottom sheet on a phone, a dialog on a computer.
  // - Continue: the games paused on this device. Removing a game only hides it here
  //   (allfun.home.v1 → hidden); the game's own save is never touched.
  // - Favorites: the games this visitor hearted (allfun.home.v1 → favs, in the order they were added).
  //   Un-hearting here can be undone for a few seconds.
  // - Sign in (18.10): the allfun.games account, email + password (Google, Apple and Facebook say "soon").
  //   Sign up / Log in tabs, the "which progress" choice, the welcome card, and the Account view. See ACCOUNTS below.
  var SHEETS = `<div class="cp" id="cont-pop" hidden>
  <div class="cp-scrim" data-close></div>
  <div class="cp-panel" role="dialog" aria-modal="true" aria-labelledby="cp-title" aria-describedby="cp-sub" tabindex="-1">
    <div class="cp-grab" aria-hidden="true"><i></i></div>
    <div class="cp-hd">
      <span class="cp-hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M8 5.5v13l10.5-6.5z"/></svg></span>
      <div class="cp-hd-tx"><h2 id="cp-title">Continue playing</h2><p class="cp-sub" id="cp-sub"></p></div>
      <button class="cp-x" type="button" aria-label="Close" data-close><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>
    </div>
    <ul class="cp-list"></ul>
    <div class="cp-empty" hidden>
      <span class="cp-empty-art" aria-hidden="true">
        <svg viewBox="0 0 120 92">
          <rect x="8" y="22" width="34" height="34" rx="10" fill="none" stroke="rgba(255,255,255,.22)" stroke-width="1.6" stroke-dasharray="4 3.4" transform="rotate(-8 25 39)"/>
          <rect x="78" y="22" width="34" height="34" rx="10" fill="none" stroke="rgba(255,255,255,.22)" stroke-width="1.6" stroke-dasharray="4 3.4" transform="rotate(8 95 39)"/>
          <g class="cp-e-ball"><circle cx="60" cy="42" r="25" fill="url(#cpE)"/><circle cx="60" cy="42" r="25" fill="none" stroke="#14308c" stroke-width="1.6"/>
            <path d="M42 34A19 19 0 0 1 55 22" fill="none" stroke="#fff" stroke-opacity=".7" stroke-width="2.6" stroke-linecap="round"/>
            <path d="M54.5 32.5v19l15-9.5z" fill="#fff"/></g>
          <ellipse class="cp-e-sh" cx="60" cy="82" rx="20" ry="4" fill="#000" opacity=".45"/>
          <path class="cp-e-tw" d="M100 10Q100.8 15.2 106 16Q100.8 16.8 100 22Q99.2 16.8 94 16Q99.2 15.2 100 10Z" fill="#4fe3ae"/>
          <path class="cp-e-tw t2" d="M18 66Q18.6 70.4 23 71Q18.6 71.6 18 76Q17.4 71.6 13 71Q17.4 70.4 18 66Z" fill="#8fc0ff"/>
          <defs><radialGradient id="cpE" cx=".35" cy=".3" r=".8"><stop offset="0" stop-color="#cfe5ff"/><stop offset=".45" stop-color="#3d7bff"/><stop offset="1" stop-color="#14308c"/></radialGradient></defs>
        </svg>
      </span>
      <b class="cp-empty-t">Nothing paused right now</b>
      <p>Start any game and it shows up here, so you can pick up where you left off.</p>
      <a class="btn btn-primary btn-sm cp-browse" href="{H}#library">Browse games</a>
    </div>
    <div class="cp-ft">
      <p class="cp-note"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3l7 3v5.5c0 4.4-3 8-7 9.5-4-1.5-7-5.1-7-9.5V6z"/><path d="M9 12l2.2 2.2L15.5 10"/></svg><span>Removing hides a game here. Its progress stays saved.</span></p>
      <div class="cp-toast"><span class="cp-toast-tx" role="status" aria-live="polite"></span><button class="cp-undo" type="button" tabindex="-1">Undo</button></div>
      <div class="cp-acts">
        <button class="cp-clear" type="button">Clear all</button>
        <span class="cp-confirm" hidden><span class="cp-confirm-q"></span>
          <button class="cp-no" type="button">Cancel</button><button class="cp-yes" type="button">Remove all</button></span>
      </div>
    </div>
  </div>
</div>
<div class="cp fv" id="fav-pop" hidden>
  <div class="cp-scrim" data-close></div>
  <div class="cp-panel" role="dialog" aria-modal="true" aria-labelledby="fv-title" aria-describedby="fv-sub" tabindex="-1">
    <div class="cp-grab" aria-hidden="true"><i></i></div>
    <div class="cp-hd">
      <span class="cp-hd-ic fv-hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><use href="#i-heart"/></svg></span>
      <div class="cp-hd-tx"><h2 id="fv-title">Favorites</h2><p class="cp-sub" id="fv-sub"></p></div>
      <button class="cp-x" type="button" aria-label="Close" data-close><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>
    </div>
    <ul class="cp-list fv-list"></ul>
    <div class="cp-empty fv-empty" hidden>
      <span class="cp-empty-art" aria-hidden="true">
        <svg viewBox="0 0 120 92">
          <rect x="0" y="24" width="30" height="30" rx="9" fill="none" stroke="rgba(255,255,255,.22)" stroke-width="1.6" stroke-dasharray="4 3.4" transform="rotate(-8 15 39)"/>
          <rect x="90" y="24" width="30" height="30" rx="9" fill="none" stroke="rgba(255,255,255,.22)" stroke-width="1.6" stroke-dasharray="4 3.4" transform="rotate(8 105 39)"/>
          <g class="cp-e-ball"><use href="#i-heart" x="35" y="14" width="50" height="50" fill="url(#fav-g)"/><ellipse cx="50.5" cy="28" rx="6.3" ry="3.5" fill="#fff" opacity=".55" transform="rotate(-32 49.5 27.5)"/></g>
          <ellipse class="cp-e-sh" cx="60" cy="82" rx="20" ry="4" fill="#000" opacity=".45"/>
          <path class="cp-e-tw" d="M100 10Q100.8 15.2 106 16Q100.8 16.8 100 22Q99.2 16.8 94 16Q99.2 15.2 100 10Z" fill="#4fe3ae"/>
          <path class="cp-e-tw t2" d="M18 66Q18.6 70.4 23 71Q18.6 71.6 18 76Q17.4 71.6 13 71Q17.4 70.4 18 66Z" fill="#8fc0ff"/>
        </svg>
      </span>
      <b class="cp-empty-t">No favorites yet</b>
      <p>Tap <svg class="fe-h" viewBox="0 0 24 24" role="img" aria-label="the heart"><use href="#i-heart"/></svg> on a game to keep it here.</p>
      <a class="btn btn-primary btn-sm fv-browse" href="{H}#library">Browse games</a>
    </div>
    <div class="cp-ft fv-ft">
      <p class="cp-note"><svg class="fv-note-ic" viewBox="0 0 24 24" aria-hidden="true"><use href="#i-heart"/></svg><span>Saved on this device. Tap a heart to take a game off.</span></p>
      <div class="cp-toast"><span class="cp-toast-tx" role="status" aria-live="polite"></span><button class="cp-undo" type="button" tabindex="-1">Undo</button></div>
    </div>
  </div>
</div>
<div class="cp sr" id="search-pop" hidden>
  <div class="cp-scrim" data-close></div>
  <div class="cp-panel sr-panel" role="dialog" aria-modal="true" aria-labelledby="sr-title" tabindex="-1">
    <div class="cp-grab" aria-hidden="true"><i></i></div>
    <h2 class="sr-only" id="sr-title">Search games</h2>
    <div class="sr-hd">
      <div class="sr-field">
        <svg class="sr-glass" viewBox="0 0 24 24" aria-hidden="true"><circle cx="10.8" cy="10.8" r="6.3"/><path d="M15.4 15.4l4.6 4.6"/></svg>
        <input class="sr-q" id="sr-q" type="search" role="combobox" aria-label="Search games" aria-autocomplete="list" aria-expanded="true"
          aria-controls="sr-list" placeholder="Search games" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" enterkeyhint="go">
        <button class="sr-clear" type="button" aria-label="Clear the search" hidden><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 8l8 8M16 8l-8 8"/></svg></button>
      </div>
      <button class="cp-x sr-x" type="button" aria-label="Close" data-close><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>
    </div>
    <div class="sr-cats" role="group" aria-label="Show a category"></div>
    <div class="sr-body">
      <div class="sr-list" id="sr-list" role="listbox" aria-label="Games"></div>
      <div class="sr-none" hidden>
        <span class="sr-none-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="10.8" cy="10.8" r="6.3"/><path d="M15.4 15.4l4.6 4.6M8.6 8.6l4.4 4.4M13 8.6l-4.4 4.4"/></svg></span>
        <b class="sr-none-t"></b>
        <p>Try a shorter word, or a kind of game like <button class="sr-try" type="button" data-q="cards">cards</button> or <button class="sr-try" type="button" data-q="puzzle">puzzle</button>.</p>
      </div>
    </div>
    <p class="sr-keys" aria-hidden="true"><span><kbd>↑</kbd><kbd>↓</kbd> to move</span><span><kbd>Enter</kbd> to play</span><span><kbd>Esc</kbd> to close</span></p>
    <p class="sr-only" id="sr-live" aria-live="polite"></p>
  </div>
</div>
<div class="cp si" id="signin-pop" hidden>
  <div class="cp-scrim" data-close></div>
  <div class="cp-panel si-panel" role="dialog" aria-modal="true" aria-labelledby="si-title" aria-describedby="si-sub" tabindex="-1">
    <div class="cp-grab" aria-hidden="true"><i></i></div>
    <button class="cp-x si-x" type="button" aria-label="Close" data-close><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>
    <div class="si-body">
      <div class="si-view si-join" data-view="join">
        <div class="si-intro">
          <div class="si-logo" aria-hidden="true">
            <i class="si-halo"></i>
            <img src="/assets/img/allfun-logo-120.webp" width="187" height="120" alt="">
            <svg class="si-tw" viewBox="0 0 160 90"><path class="cp-e-tw" d="M20 12Q20.8 17.2 26 18Q20.8 18.8 20 24Q19.2 18.8 14 18Q19.2 17.2 20 12Z" fill="#4fe3ae"/><path class="cp-e-tw t2" d="M140 58Q140.6 62.4 145 63Q140.6 63.6 140 68Q139.4 63.6 135 63Q139.4 62.4 140 58Z" fill="#a98bff"/></svg>
          </div>
          <h2 id="si-title">Join AllFun Games</h2>
          <p class="si-sub" id="si-sub">One free account for every game.</p>
          <ul class="si-perks">
            <li><span class="si-pi pi-dev" aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="2.8" y="5" width="13" height="9.6" rx="1.8"/><path d="M6.4 18.2h5.8M9.3 14.6v3.6"/><rect x="15.4" y="8.6" width="5.8" height="11" rx="1.6"/></svg></span><span>Your progress safe on every device</span></li>
            <li><span class="si-pi pi-friends" aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="4" y="10" width="16" height="10" rx="2"/><path d="M3 7h18v3H3zM12 7v13M12 7c-2-3-5.5-3.5-6-1.5S9 7 12 7zM12 7c2-3 5.5-3.5 6-1.5S15 7 12 7z"/></svg></span><span>No ads in your first 5 plays of every game</span></li>
            <li><span class="si-pi pi-coin" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8"/><path d="M12 7.6l1.3 2.7 3 .4-2.2 2.1.5 3L12 14.4l-2.6 1.4.5-3-2.2-2.1 3-.4z" class="f"/></svg></span><span>+800 coins · daily top-up to 600</span></li>
          </ul>
        </div>
        <div class="si-acts">
          <div class="si-tabs" role="tablist" aria-label="Sign up or log in">
            <i class="si-tab-pill" aria-hidden="true"></i>
            <button class="si-tab" type="button" role="tab" id="si-tab-signup" aria-selected="true" aria-controls="si-form" data-tab="signup">Sign up</button>
            <button class="si-tab" type="button" role="tab" id="si-tab-login" aria-selected="false" aria-controls="si-form" data-tab="login" tabindex="-1">Log in</button>
          </div>
          <form class="si-form" id="si-form" aria-labelledby="si-tab-signup" novalidate>
            <label class="si-field"><span class="si-lbl">Email</span>
              <span class="si-in"><svg class="si-in-ic" viewBox="0 0 24 24" aria-hidden="true"><rect x="3.4" y="5.4" width="17.2" height="13.2" rx="2.6"/><path d="M4.6 7.2l7.4 5.8 7.4-5.8"/></svg><input type="email" name="email" autocomplete="email" inputmode="email" autocapitalize="off" autocorrect="off" spellcheck="false" maxlength="254" placeholder="you@example.com" required></span></label>
            <label class="si-field"><span class="si-lbl">Password</span>
              <span class="si-in"><svg class="si-in-ic" viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10.5" width="14" height="9.5" rx="2.4"/><path d="M8.3 10.5V8a3.7 3.7 0 0 1 7.4 0v2.5"/></svg><input type="password" name="password" autocomplete="new-password" maxlength="200" placeholder="At least 8 characters" required><button class="si-eye" type="button" aria-label="Show password" aria-pressed="false"><svg viewBox="0 0 24 24" aria-hidden="true"><path class="eye-o" d="M2.6 12S6 5.6 12 5.6 21.4 12 21.4 12 18 18.4 12 18.4 2.6 12 2.6 12z"/><circle class="eye-o" cx="12" cy="12" r="2.9"/><path class="eye-x" d="M4 4l16 16"/></svg></button></span></label>
            <p class="si-help si-help-up">At least 8 characters. We never sell or share your email.</p>
            <p class="si-help si-help-in" hidden>Forgot it? Write to <a href="mailto:support@allfun.games">support@allfun.games</a></p>
            <p class="si-forgot-row" hidden><button class="si-forgot" type="button" data-act="forgot">Forgot password?</button></p>
            <p class="si-err" role="alert"></p>
            <button class="si-submit" type="submit"><span class="si-submit-tx">Sign up free</span><i class="si-spin" aria-hidden="true"></i></button>
          </form>
          <div class="si-or" aria-hidden="true"><span>or</span></div>
          <div class="si-social">
            <button class="si-btn" type="button" data-provider="Google" aria-label="Continue with Google (coming soon)"><span class="si-g" aria-hidden="true"><svg viewBox="0 0 24 24"><g fill="none" stroke-width="3.3"><path d="M17.09 6.91A7.2 7.2 0 0 0 5.23 9.54" stroke="#ea4335"/><path d="M5.23 9.54A7.2 7.2 0 0 0 5.23 14.46" stroke="#fbbc05"/><path d="M5.23 14.46A7.2 7.2 0 0 0 17.09 17.09" stroke="#34a853"/><path d="M17.09 17.09A7.2 7.2 0 0 0 19.2 12H12.3" stroke="#4285f4"/></g></svg></span><span class="si-bn">Google</span><em class="si-soon">Soon</em></button>
            <button class="si-btn" type="button" data-provider="Apple" aria-label="Continue with Apple (coming soon)"><span class="si-g" aria-hidden="true"><svg viewBox="0 0 24 24"><path fill="#f5f7fb" d="M16.4 12.7c0-2 1.6-2.9 1.7-3-1-1.4-2.4-1.6-2.9-1.6-1.2-.1-2.4.7-3 .7-.6 0-1.6-.7-2.6-.7-1.3 0-2.6.8-3.3 2-1.4 2.4-.4 6 1 8 .7 1 1.4 2 2.4 2s1.3-.6 2.5-.6 1.5.6 2.5.6 1.7-1 2.3-2c.7-1.1 1-2.2 1-2.3 0 0-2-.8-2-3.1zM14.5 6.6c.5-.7.9-1.6.8-2.6-.8 0-1.8.5-2.4 1.2-.5.6-1 1.5-.8 2.5.9.1 1.8-.4 2.4-1.1z"/></svg></span><span class="si-bn">Apple</span><em class="si-soon">Soon</em></button>
            <button class="si-btn" type="button" data-provider="Facebook" aria-label="Continue with Facebook (coming soon)"><span class="si-g" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9.5" fill="#1877f2"/><path fill="#fff" d="M13.3 21.4v-6.9h2.3l.35-2.7H13.3v-1.7c0-.8.22-1.3 1.36-1.3h1.4V6.4c-.25 0-1.08-.1-2.05-.1-2.03 0-3.42 1.24-3.42 3.5v2h-2.3v2.7h2.3v6.8z"/></svg></span><span class="si-bn">Facebook</span><em class="si-soon">Soon</em></button>
          </div>
          <p class="si-note" role="status" aria-live="polite"></p>
          <button class="si-later" type="button" data-close>Not now</button>
          <p class="si-fine">13+ · By continuing you agree to the <a href="/terms.html">Terms</a> and <a href="/privacy.html">Privacy Policy</a>.</p>
        </div>
      </div>
      <div class="si-view si-choose" data-view="choose" hidden>
        <span class="si-badge si-badge-sync" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M19.5 9A7.8 7.8 0 0 0 5.6 7.4L4 9M4.5 15a7.8 7.8 0 0 0 13.9 1.6L20 15"/><path d="M4 4.5V9h4.5M20 19.5V15h-4.5"/></svg></span>
        <h2 id="si-choose-title">Which progress to keep?</h2>
        <p class="si-sub" id="si-choose-sub">This device and your account both have saved games.</p>
        <div class="si-opts" role="radiogroup" aria-labelledby="si-choose-title">
          <button class="si-opt on" type="button" role="radio" aria-checked="true" data-pick="account">
            <span class="si-opt-ic oi-cloud" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M7 18.5h10.2a4.3 4.3 0 0 0 .6-8.56A6 6 0 0 0 6.3 9.3 4.6 4.6 0 0 0 7 18.5z"/><path d="M9.4 13.4l2 2 3.6-3.8"/></svg></span>
            <span class="si-opt-tx"><b>Use the progress saved in your account</b><span class="si-opt-sub" data-acct-when></span></span>
            <em class="si-rec">Recommended</em><i class="si-radio" aria-hidden="true"></i>
          </button>
          <button class="si-opt" type="button" role="radio" aria-checked="false" data-pick="device" tabindex="-1">
            <span class="si-opt-ic oi-dev" aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="6.5" y="2.8" width="11" height="18.4" rx="2.6"/><path d="M10.4 18h3.2"/></svg></span>
            <span class="si-opt-tx"><b>Keep this device’s progress</b><span class="si-opt-sub" data-dev-what></span></span>
            <i class="si-radio" aria-hidden="true"></i>
          </button>
        </div>
        <p class="si-err" role="alert"></p>
        <button class="si-submit" type="button" data-act="pick"><span class="si-submit-tx">Continue</span><i class="si-spin" aria-hidden="true"></i></button>
      </div>
      <div class="si-view si-fp" data-view="forgot" hidden>
        <span class="si-badge si-badge-key" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="8" cy="15.5" r="4.2"/><path d="M11 12.5l8-8M16.2 7.3l2.4 2.4M14 9.5l2 2"/><circle cx="8" cy="15.5" r="1.1" class="f"/></svg></span>
        <h2 id="si-fp-title">Forgot your password?</h2>
        <p class="si-sub" id="si-fp-sub">Enter the email of your account. We’ll send you a link to choose a new password.</p>
        <form class="si-form si-fp-form" novalidate>
          <label class="si-field"><span class="si-lbl">Email</span>
            <span class="si-in"><svg class="si-in-ic" viewBox="0 0 24 24" aria-hidden="true"><rect x="3.4" y="5.4" width="17.2" height="13.2" rx="2.6"/><path d="M4.6 7.2l7.4 5.8 7.4-5.8"/></svg><input type="email" name="email" autocomplete="email" inputmode="email" autocapitalize="off" autocorrect="off" spellcheck="false" maxlength="254" placeholder="you@example.com" required></span></label>
          <p class="si-err" role="alert"></p>
          <button class="si-submit" type="submit"><span class="si-submit-tx">Send reset link</span><i class="si-spin" aria-hidden="true"></i></button>
        </form>
        <button class="si-later si-to-login" type="button" data-act="to-login"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 12H6M11 6l-6 6 6 6"/></svg><span>Back to log in</span></button>
      </div>
      <div class="si-view si-fp si-sent" data-view="sent" hidden>
        <span class="si-mail" aria-hidden="true"><i class="si-ring"></i><svg viewBox="0 0 48 48"><path class="m-letter" d="M15 25V12.5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2V25"/><path class="m-line" d="M19.5 16h9M19.5 20.5h6"/><path class="m-body" d="M8.5 21.5v15a3 3 0 0 0 3 3h25a3 3 0 0 0 3-3v-15"/><path class="m-flap" d="M8.5 21.5 24 32l15.5-10.5"/></svg><b class="si-mail-dot">1</b><i class="si-sp s1"></i><i class="si-sp s2"></i><i class="si-sp s3"></i><i class="si-sp s4"></i></span>
        <h2 id="si-sent-title">Check your email</h2>
        <p class="si-sub" id="si-sent-sub">If an account exists for that email, we’ve sent a reset link.</p>
        <p class="si-sent-to"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3.4" y="5.4" width="17.2" height="13.2" rx="2.6"/><path d="M4.6 7.2l7.4 5.8 7.4-5.8"/></svg><span data-sent-to></span></p>
        <ul class="si-tips">
          <li><span class="si-tip-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.2"/><path d="M12 7.6V12l3 2"/></svg></span><span>The link works for <b>30 minutes</b>, and only once.</span></li>
          <li><span class="si-tip-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M4 13.5l2.4-7a2 2 0 0 1 1.9-1.4h7.4a2 2 0 0 1 1.9 1.4l2.4 7V18a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"/><path d="M4 13.5h4.5l1.2 2.2h4.6l1.2-2.2H20"/></svg></span><span>Not there in a minute? Look in <b>Spam</b> or <b>Promotions</b>.</span></li>
        </ul>
        <p class="si-err" role="alert"></p>
        <button class="si-submit" type="button" data-act="to-login"><span class="si-submit-tx">Back to log in</span></button>
        <button class="si-later" type="button" data-act="again"><span>Send it again</span></button>
      </div>
      <div class="si-view si-fp si-sent si-code" data-view="code" hidden>
        <span class="si-mail" aria-hidden="true"><i class="si-ring"></i><svg viewBox="0 0 48 48"><path class="m-letter" d="M15 25V12.5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2V25"/><path class="m-line" d="M19.5 16h9M19.5 20.5h6"/><path class="m-body" d="M8.5 21.5v15a3 3 0 0 0 3 3h25a3 3 0 0 0 3-3v-15"/><path class="m-flap" d="M8.5 21.5 24 32l15.5-10.5"/></svg><b class="si-mail-dot">1</b><i class="si-sp s1"></i><i class="si-sp s2"></i><i class="si-sp s3"></i><i class="si-sp s4"></i></span>
        <h2 id="si-code-title">Check your email</h2>
        <p class="si-sub" id="si-code-sub">We sent a 6-digit code to</p>
        <p class="si-sent-to"><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3.4" y="5.4" width="17.2" height="13.2" rx="2.6"/><path d="M4.6 7.2l7.4 5.8 7.4-5.8"/></svg><span data-code-to></span></p>
        <form class="si-form si-code-form" novalidate>
          <input class="si-vh" type="email" name="username" autocomplete="username" tabindex="-1" aria-hidden="true" readonly>
          <label class="si-field si-code-field"><span class="si-vh">6-digit code</span>
            <span class="si-in"><input type="text" name="code" autocomplete="one-time-code" inputmode="numeric" pattern="[0-9]*" maxlength="12" enterkeyhint="go" autocapitalize="off" autocorrect="off" spellcheck="false" placeholder="••••••" aria-describedby="si-code-sub" required></span></label>
          <p class="si-err" role="alert"></p>
          <p class="si-note" role="status" aria-live="polite"></p>
          <button class="si-submit" type="submit"><span class="si-submit-tx">Verify</span><i class="si-spin" aria-hidden="true"></i></button>
        </form>
        <ul class="si-tips">
          <li><span class="si-tip-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.2"/><path d="M12 7.6V12l3 2"/></svg></span><span>The code is valid for <b>15 minutes</b>.</span></li>
          <li><span class="si-tip-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M4 13.5l2.4-7a2 2 0 0 1 1.9-1.4h7.4a2 2 0 0 1 1.9 1.4l2.4 7V18a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2z"/><path d="M4 13.5h4.5l1.2 2.2h4.6l1.2-2.2H20"/></svg></span><span>Not there in a minute? Look in <b>Spam</b> or <b>Promotions</b>.</span></li>
        </ul>
        <div class="si-code-links">
          <button class="si-later si-resend" type="button" data-act="resend"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19.5 9A7.8 7.8 0 0 0 5.6 7.4L4 9M4.5 15a7.8 7.8 0 0 0 13.9 1.6L20 15"/><path d="M4 4.5V9h4.5M20 19.5V15h-4.5"/></svg><span class="si-resend-tx">Send a new code</span></button>
          <button class="si-later si-to-login" type="button" data-act="other-email"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 12H6M11 6l-6 6 6 6"/></svg><span>Use a different email</span></button>
        </div>
      </div>
      <div class="si-view si-fp" data-view="reset" hidden>
        <span class="si-badge si-badge-lock" aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="5" y="10.5" width="14" height="9.5" rx="2.4"/><path d="M8.3 10.5V8a3.7 3.7 0 0 1 7.4 0v2.5"/><path class="k" d="M12 14.2v2.2"/></svg></span>
        <h2 id="si-rs-title">Choose a new password</h2>
        <p class="si-sub" id="si-rs-sub">For <b class="si-rs-email" data-rs-email>your AllFun Games account</b></p>
        <form class="si-form si-rs-form" novalidate>
          <input class="si-vh" type="text" name="username" autocomplete="username" tabindex="-1" aria-hidden="true" readonly>
          <label class="si-field"><span class="si-lbl">New password</span>
            <span class="si-in"><svg class="si-in-ic" viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10.5" width="14" height="9.5" rx="2.4"/><path d="M8.3 10.5V8a3.7 3.7 0 0 1 7.4 0v2.5"/></svg><input type="password" name="password" autocomplete="new-password" maxlength="200" placeholder="At least 8 characters" required><button class="si-eye" type="button" aria-label="Show password" aria-pressed="false"><svg viewBox="0 0 24 24" aria-hidden="true"><path class="eye-o" d="M2.6 12S6 5.6 12 5.6 21.4 12 21.4 12 18 18.4 12 18.4 2.6 12 2.6 12z"/><circle class="eye-o" cx="12" cy="12" r="2.9"/><path class="eye-x" d="M4 4l16 16"/></svg></button></span></label>
          <label class="si-field"><span class="si-lbl">Confirm new password</span>
            <span class="si-in"><svg class="si-in-ic" viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10.5" width="14" height="9.5" rx="2.4"/><path d="M8.3 10.5V8a3.7 3.7 0 0 1 7.4 0v2.5"/></svg><input type="password" name="confirm" autocomplete="new-password" maxlength="200" placeholder="Type it again" required><button class="si-eye" type="button" aria-label="Show password" aria-pressed="false"><svg viewBox="0 0 24 24" aria-hidden="true"><path class="eye-o" d="M2.6 12S6 5.6 12 5.6 21.4 12 21.4 12 18 18.4 12 18.4 2.6 12 2.6 12z"/><circle class="eye-o" cx="12" cy="12" r="2.9"/><path class="eye-x" d="M4 4l16 16"/></svg></button></span></label>
          <p class="si-help">At least 8 characters. Every device signed in to this account will be signed out.</p>
          <p class="si-err" role="alert"></p>
          <button class="si-submit" type="submit"><span class="si-submit-tx">Save new password</span><i class="si-spin" aria-hidden="true"></i></button>
        </form>
      </div>
      <div class="si-view si-fp" data-view="expired" hidden>
        <span class="si-badge si-badge-late" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M7 3.8h10M7 20.2h10M8 3.8v2.6c0 2 1.6 3.3 4 5.6 2.4-2.3 4-3.6 4-5.6V3.8M8 20.2v-2.6c0-2 1.6-3.3 4-5.6 2.4 2.3 4 3.6 4 5.6v2.6"/></svg></span>
        <h2 id="si-ex-title">This link has expired</h2>
        <p class="si-sub" id="si-ex-sub">Reset links work for 30 minutes, and only once. Ask for a new one — it takes a few seconds.</p>
        <button class="si-submit si-ex-go" type="button" data-act="forgot"><span class="si-submit-tx">Send me a new link</span></button>
        <button class="si-later si-to-login" type="button" data-act="to-login"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 12H6M11 6l-6 6 6 6"/></svg><span>Back to log in</span></button>
      </div>
      <div class="si-view si-done" data-view="done" hidden>
        <span class="si-check" aria-hidden="true"><i class="si-ring"></i><svg viewBox="0 0 48 48"><path d="M14 25l7 7 14-15"/></svg><i class="si-sp s1"></i><i class="si-sp s2"></i><i class="si-sp s3"></i><i class="si-sp s4"></i></span>
        <h2 id="si-done-title">You’re in!</h2>
        <p class="si-sub" id="si-done-sub">Your progress is saved to your account.</p>
        <ul class="si-gifts">
          <li><b>No ads</b><span>first 5 plays of every game</span></li>
          <li><b>+800</b><span>coins · daily top-up to&nbsp;600</span></li>
        </ul>
        <a class="si-submit si-back" href="/" hidden><span class="si-submit-tx">Back to the game</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12h13M13 6l6 6-6 6"/></svg></a>
        <button class="si-submit si-play" type="button" data-close><span class="si-submit-tx">Start playing</span></button>
      </div>
      <div class="si-view si-acct" data-view="account" hidden>
        <div class="sa-hd pf-card">
          <button class="pf-av" type="button" data-pf-go="avatars" aria-label="Change your picture"><span class="sa-av pf-face" data-pf-face><b class="sa-init">A</b></span><span class="pf-av-pen" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M4 20h4L19 9l-4-4L4 16z"/><path d="M13.5 6.5l4 4"/></svg></span></button>
          <div class="sa-id"><h2 id="si-acct-title">Your account</h2><p class="sa-email" id="si-acct-sub"></p><p class="sa-coins" hidden><span class="coins af-coins"></span> coins · shared by all games</p></div>
          <div class="pf-acts" hidden>
            <button class="pf-btn" type="button" data-pf-go="nick"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 20h4L19 9l-4-4L4 16z"/><path d="M13.5 6.5l4 4"/></svg><span data-pf-nick-btn>Edit nickname</span></button>
            <button class="pf-btn" type="button" data-pf-go="avatars"><svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><circle cx="9.2" cy="10.4" r="1.1" class="f"/><circle cx="14.8" cy="10.4" r="1.1" class="f"/><path d="M8.6 14.2q3.4 3 6.8 0"/></svg><span>Change picture</span></button>
          </div>
        </div>
        <div class="sa-status" data-state="ok">
          <span class="sa-st-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M7 18.5h10.2a4.3 4.3 0 0 0 .6-8.56A6 6 0 0 0 6.3 9.3 4.6 4.6 0 0 0 7 18.5z"/><path class="ok" d="M9.4 13.4l2 2 3.6-3.8"/></svg></span>
          <span class="sa-st-tx"><b>Progress saved to your account ✓</b><span class="sa-st-sub" role="status" aria-live="polite"></span></span>
        </div>
        <div class="sa-list">
          <div class="sa-item">
            <button class="sa-row" type="button" data-open="pw" aria-expanded="false" aria-controls="sa-pw"><span class="sa-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><rect x="5" y="10.5" width="14" height="9.5" rx="2.4"/><path d="M8.3 10.5V8a3.7 3.7 0 0 1 7.4 0v2.5"/></svg></span><span>Change password</span><svg class="sa-go" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button>
            <form class="sa-more" id="sa-pw" hidden novalidate>
              <p class="sa-gnote"></p>
              <label class="si-field sa-cur"><span class="si-lbl">Current password</span><span class="si-in"><input type="password" name="current" autocomplete="current-password" maxlength="200" required><button class="si-eye" type="button" aria-label="Show password" aria-pressed="false"><svg viewBox="0 0 24 24" aria-hidden="true"><path class="eye-o" d="M2.6 12S6 5.6 12 5.6 21.4 12 21.4 12 18 18.4 12 18.4 2.6 12 2.6 12z"/><circle class="eye-o" cx="12" cy="12" r="2.9"/><path class="eye-x" d="M4 4l16 16"/></svg></button></span></label>
              <label class="si-field"><span class="si-lbl">New password</span><span class="si-in"><input type="password" name="password" autocomplete="new-password" maxlength="200" placeholder="At least 8 characters" required><button class="si-eye" type="button" aria-label="Show password" aria-pressed="false"><svg viewBox="0 0 24 24" aria-hidden="true"><path class="eye-o" d="M2.6 12S6 5.6 12 5.6 21.4 12 21.4 12 18 18.4 12 18.4 2.6 12 2.6 12z"/><circle class="eye-o" cx="12" cy="12" r="2.9"/><path class="eye-x" d="M4 4l16 16"/></svg></button></span></label>
              <p class="si-err" role="alert"></p>
              <button class="si-submit sm" type="submit"><span class="si-submit-tx">Save new password</span><i class="si-spin" aria-hidden="true"></i></button>
            </form>
          </div>
          <div class="sa-item">
            <button class="sa-row" type="button" data-act="signout"><span class="sa-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M14 4.5H7.5a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2H14M10.5 12h9M16.5 8.5 20 12l-3.5 3.5"/></svg></span><span>Sign out</span><i class="si-spin" aria-hidden="true"></i></button>
          </div>
          <div class="sa-item sa-danger">
            <button class="sa-row" type="button" data-open="del" aria-expanded="false" aria-controls="sa-del"><span class="sa-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M4.5 7h15M9.5 7V4.8h5V7M6.5 7l.9 12.2a1.8 1.8 0 0 0 1.8 1.6h5.6a1.8 1.8 0 0 0 1.8-1.6L17.5 7M10 11v6M14 11v6"/></svg></span><span>Delete account</span><svg class="sa-go" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg></button>
            <form class="sa-more" id="sa-del" hidden novalidate>
              <p class="sa-warn">This deletes your account and the progress saved in it, for good. This device keeps its own copy.</p>
              <p class="sa-gnote"></p>
              <label class="si-field sa-cur"><span class="si-lbl">Your password, to confirm</span><span class="si-in"><input type="password" name="password" autocomplete="current-password" maxlength="200" required><button class="si-eye" type="button" aria-label="Show password" aria-pressed="false"><svg viewBox="0 0 24 24" aria-hidden="true"><path class="eye-o" d="M2.6 12S6 5.6 12 5.6 21.4 12 21.4 12 18 18.4 12 18.4 2.6 12 2.6 12z"/><circle class="eye-o" cx="12" cy="12" r="2.9"/><path class="eye-x" d="M4 4l16 16"/></svg></button></span></label>
              <p class="si-err" role="alert"></p>
              <div class="sa-del-acts"><button class="sa-cancel" type="button" data-open="del">Cancel</button><button class="si-submit sm danger" type="submit"><span class="si-submit-tx">Delete my account</span><i class="si-spin" aria-hidden="true"></i></button></div>
            </form>
          </div>
        </div>
        <p class="si-note" role="status" aria-live="polite"></p>
        <p class="si-fine">Need help? <a href="mailto:support@allfun.games">support@allfun.games</a> · <a href="/privacy.html">Privacy</a></p>
      </div>
      <!-- Members' profile (21.10): the nickname editor, the picture picker and the first-time setup (PROFILE below). -->
      <div class="si-view pf-view pf-nick" data-view="nick" hidden>
        <button class="pf-back" type="button" data-pf-go="account"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 12H6M11 6l-6 6 6 6"/></svg><span>Account</span></button>
        <h2 id="si-nick-title">Your nickname</h2>
        <p class="si-sub" id="si-nick-sub">The name other players see, in every game.</p>
        <div class="pf-tag" aria-hidden="true"><span class="pf-face pf-tag-av" data-pf-face></span><span class="pf-tag-tx"><b data-pf-tag>Your nickname</b><small>How other players see you</small></span><i class="pf-tag-live"></i></div>
        <form class="si-form pf-form" novalidate>
          <label class="si-field"><span class="si-vh">Nickname</span>
            <span class="si-in"><svg class="si-in-ic" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8.6" r="3.6"/><path d="M5 19.6c.9-3.4 3.7-5.2 7-5.2s6.1 1.8 7 5.2"/></svg><input type="text" name="nick" maxlength="16" autocomplete="nickname" autocapitalize="words" autocorrect="off" spellcheck="false" enterkeyhint="done" placeholder="Your nickname" aria-describedby="pf-st-nick"><span class="pf-count" aria-hidden="true">0/16</span></span></label>
          <p class="pf-status" id="pf-st-nick" data-state="idle" aria-live="polite"><i class="pf-st-ic" aria-hidden="true"></i><span class="pf-st-tx">3–16 letters or numbers. Spaces, _ and - are fine.</span></p>
          <div class="pf-price">
            <p class="pf-free"><em>Free</em><span>Your first nickname costs nothing.</span></p>
            <div class="pf-pay" role="radiogroup" aria-label="How to pay for the change" hidden>
              <button class="pf-opt" type="button" role="radio" aria-checked="false" data-pay="coins"><i class="wl-c" aria-hidden="true"></i><span class="pf-opt-tx"><b>40 coins</b><small data-pf-bal></small></span></button>
              <button class="pf-opt" type="button" role="radio" aria-checked="false" data-pay="video"><span class="pf-play" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M9 7.5v9l7.5-4.5z"/></svg></span><span class="pf-opt-tx"><b>Watch a video</b><small>Free</small></span></button>
            </div>
          </div>
          <p class="si-err" role="alert"></p>
          <button class="si-submit" type="submit"><i class="pf-vid" aria-hidden="true"></i><span class="si-submit-tx">Save nickname</span><i class="si-spin" aria-hidden="true"></i></button>
        </form>
      </div>
      <div class="si-view pf-view pf-pics" data-view="avatars" hidden>
        <button class="pf-back" type="button" data-pf-go="account"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M19 12H6M11 6l-6 6 6 6"/></svg><span>Account</span></button>
        <h2 id="si-pics-title">Choose your picture</h2>
        <p class="si-sub" id="si-pics-sub">Always free. Tap one and it’s saved.</p>
        <div class="pf-grid" data-pf-grid="pics" role="radiogroup" aria-labelledby="si-pics-title"></div>
        <p class="si-err" role="alert"></p>
      </div>
      <div class="si-view pf-view pf-setup" data-view="setup" hidden>
        <span class="pf-face pf-hero" data-pf-face aria-hidden="true"></span>
        <h2 id="si-setup-title">Choose your nickname &amp; avatar</h2>
        <p class="si-sub" id="si-setup-sub">This is how other players see you. Your first nickname is free.</p>
        <form class="si-form pf-form" novalidate>
          <label class="si-field"><span class="si-vh">Nickname</span>
            <span class="si-in"><svg class="si-in-ic" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="8.6" r="3.6"/><path d="M5 19.6c.9-3.4 3.7-5.2 7-5.2s6.1 1.8 7 5.2"/></svg><input type="text" name="nick" maxlength="16" autocomplete="nickname" autocapitalize="words" autocorrect="off" spellcheck="false" enterkeyhint="done" placeholder="Your nickname" aria-describedby="pf-st-setup"><span class="pf-count" aria-hidden="true">0/16</span></span></label>
          <p class="pf-status" id="pf-st-setup" data-state="idle" aria-live="polite"><i class="pf-st-ic" aria-hidden="true"></i><span class="pf-st-tx">3–16 letters or numbers. Spaces, _ and - are fine.</span></p>
          <div class="pf-grid pf-grid-sm" data-pf-grid="setup" role="radiogroup" aria-label="Your picture"></div>
          <p class="si-err" role="alert"></p>
          <button class="si-submit" type="submit"><span class="si-submit-tx">Save</span><i class="si-spin" aria-hidden="true"></i></button>
        </form>
        <button class="si-later" type="button" data-act="pf-later">Later</button>
      </div>
    </div>
  </div>
</div>`;

  // The wallet sheet (20.10, the site-wide coin economy): the header's coin chip opens it. The look of the games'
  // out-of-coins sheet (games/shared/arcade.ts: the navy card with a gold edge, the coin stack, gold "+N" pills),
  // built like the other sheets here (a bottom sheet on a phone, a dialog on a computer). Its body is drawn by
  // the WALLET code below: the balance, what a game costs, and the ways to get coins.
  var WL_STAR = (function () {
    var d = '';
    for (var i = 0; i < 10; i += 1) {
      var a = -Math.PI / 2 + i * Math.PI / 5, r = i % 2 ? 4.8 : 11.5;
      d += (i ? 'L' : 'M') + (78 + Math.cos(a) * r).toFixed(1) + ' ' + (49.5 + Math.sin(a) * r).toFixed(1);
    }
    return d + 'Z';
  })();
  var WL_STACK = (function () {
    var s = '';
    for (var i = 0; i < 4; i += 1) {
      var y = 84 - i * 8.5;
      s += '<path d="M14 ' + y + 'v6a24 8 0 0 0 48 0v-6" fill="url(#wl-edge)"/><ellipse cx="38" cy="' + y + '" rx="24" ry="8" fill="url(#wl-face)" stroke="#9a5f08" stroke-width="1"/>';
    }
    return '<svg class="wl-stack" viewBox="0 0 120 100"><defs>' +
      '<linearGradient id="wl-edge" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#e3a422"/><stop offset="1" stop-color="#8f5a06"/></linearGradient>' +
      '<radialGradient id="wl-face" cx=".35" cy=".3" r=".85"><stop offset="0" stop-color="#fff6cf"/><stop offset=".45" stop-color="#f8cf5e"/><stop offset="1" stop-color="#c98a12"/></radialGradient></defs>' + s +
      '<g class="wl-big"><circle cx="81" cy="52" r="30" fill="url(#wl-edge)"/><circle cx="78" cy="49" r="30" fill="url(#wl-face)" stroke="#9a5f08" stroke-width="1.5"/>' +
      '<circle cx="78" cy="49" r="22.5" fill="none" stroke="rgba(150,95,5,.55)" stroke-width="2"/><path d="' + WL_STAR + '" fill="#c98a12" stroke="#9a5f08" stroke-width=".8" stroke-linejoin="round"/>' +
      '<path d="M58 37a24 24 0 0 1 18-10" fill="none" stroke="rgba(255,255,255,.75)" stroke-width="3" stroke-linecap="round"/></g></svg>';
  })();
  var WL_TW = '<path d="M7 0Q7.7 6.3 14 7Q7.7 7.7 7 14Q6.3 7.7 0 7Q6.3 6.3 7 0Z"/>';
  var WALLET = `<div class="cp wl" id="wallet-pop" hidden>
  <div class="cp-scrim" data-close></div>
  <div class="cp-panel wl-panel" role="dialog" aria-modal="true" aria-labelledby="wl-title" aria-describedby="wl-sub" tabindex="-1">
    <div class="cp-grab" aria-hidden="true"><i></i></div>
    <button class="cp-x wl-x" type="button" aria-label="Close" data-close><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>
    <button class="wl-back" type="button" aria-label="Back" data-wl="main" hidden><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg></button>
    <div class="wl-body">
      <div class="wl-head">
        <span class="wl-brand"><i aria-hidden="true">AF</i>AllFun coins</span>
        <div class="wl-art" aria-hidden="true"><i class="wl-halo"></i>${WL_STACK}<i class="wl-fly c1"></i><i class="wl-fly c2"></i><i class="wl-fly c3"></i><svg class="wl-tw t1" viewBox="0 0 14 14">${WL_TW}</svg><svg class="wl-tw t2" viewBox="0 0 14 14">${WL_TW}</svg><svg class="wl-tw t3" viewBox="0 0 14 14">${WL_TW}</svg></div>
        <h2 id="wl-title">Your coins</h2>
        <div class="wl-bal"><i class="wl-c" aria-hidden="true"></i><b data-wl-bal>0</b><span>coins</span></div>
        <p class="wl-sub" id="wl-sub"></p>
      </div>
      <div class="wl-view" data-wl-view="main"></div>
      <div class="wl-view" data-wl-view="invite" hidden></div>
      <p class="wl-note">Coins are for play only. They can't be exchanged for real money.</p>
    </div>
  </div>
</div>`;

  // The Install sheet (iPhone and iPad, in-app browsers, or a browser that has no install prompt to offer right now):
  // a short animated guide. Its steps are filled in by installSteps() below for the device in hand.
  var INSTALL = `<div class="cp ins" id="install-pop" hidden>
  <div class="cp-scrim" data-close></div>
  <div class="cp-panel ins-panel" role="dialog" aria-modal="true" aria-labelledby="ins-title" aria-describedby="ins-sub" tabindex="-1">
    <div class="cp-grab" aria-hidden="true"><i></i></div>
    <button class="cp-x ins-x" type="button" aria-label="Close" data-close><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>
    <div class="ins-body">
      <div class="ins-hd">
        <span class="ins-app" aria-hidden="true"><i class="ins-halo"></i><img src="/apple-touch-icon.png" width="180" height="180" alt=""><i class="ins-shine"></i></span>
        <div class="ins-hd-tx"><h2 id="ins-title">Install AllFun</h2><p class="ins-sub" id="ins-sub"></p></div>
      </div>
      <ol class="ins-steps"></ol>
      <div class="ins-acts"><button class="ins-copy" type="button" hidden><svg viewBox="0 0 24 24" aria-hidden="true"><rect x="8.5" y="8.5" width="11" height="11" rx="2.6"/><path d="M15.5 5.6A2.1 2.1 0 0 0 13.4 4.5H6.6A2.1 2.1 0 0 0 4.5 6.6v6.8a2.1 2.1 0 0 0 1.1 2.1"/></svg><span>Copy link</span></button><button class="btn btn-primary ins-ok" type="button" data-close>Got it</button></div>
    </div>
    <div class="ins-point" aria-hidden="true"><span class="ins-point-tx"></span><svg viewBox="0 0 24 24"><path d="M12 4v15M6 13l6 6 6-6"/></svg></div>
  </div>
  <div class="ins-up" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M12 20V5M6 11l6-6 6 6"/></svg><span>Share is up here</span></div>
</div>`;

  // The live pages already hold the icons, the menu and the header's buttons (scripts/build-site.mjs puts this same
  // markup in at deploy, so the header is whole from the first paint); a page without them gets them here.
  (function build() {
    var at = function (s) { return s.replace(/\{H\}/g, onHome ? '' : '/'); };
    if (!document.getElementById('i-user')) document.body.insertAdjacentHTML('afterbegin', DEFS);
    var menuEl = document.getElementById('site-menu');
    if (menuEl && !menuEl.querySelector('.m-list')) menuEl.innerHTML = at(MENU);
    // The ads switch (ADS_LIVE above): off, every "Coming soon" goes — the menu tile, the links, the home tile and section.
    document.querySelectorAll(ADS_LIVE ? '[data-ads-off]' : '[data-ads-on]').forEach(function (n) { n.remove(); });
    var tog = document.querySelector('.nav-toggle');
    if (tog && !document.querySelector('.nav .nav-coins')) tog.insertAdjacentHTML('beforebegin', NAV_BTNS);
    document.querySelectorAll('.nav .nav-signin[hidden]').forEach(function (b) { b.hidden = false; });
    var old = document.querySelector('.dock');
    if (old) old.remove();
    var foot = document.querySelector('footer.site-footer');
    if (foot) foot.insertAdjacentHTML('afterend', at(DOCK + SHEETS + WALLET + INSTALL));
    else document.body.insertAdjacentHTML('beforeend', at(DOCK + SHEETS + WALLET + INSTALL));
  })();

  // A page's own script can listen in (window.AllFun.hooks): the home page uses them for its Continue
  // row, its Favorites filter and its chip count.
  var hooks = {};
  function hook(name) {
    var f = hooks[name];
    return typeof f === 'function' ? f.apply(null, Array.prototype.slice.call(arguments, 1)) : undefined;
  }

  // ---- progress on this device -----------------------------------------------------------------
  // Each reader returns null (never played) or { slug, line, extra, live, weight, at }.
  var READERS = {
    backgammon: function () {
      var p = read('bg.profile.v1'), w = read('bg.wallet.v1'), m = read('bg.matchSave.v1');
      var st = (p && p.stats) || {};
      var ledger = (w && Array.isArray(w.ledger)) ? w.ledger : [];
      var played = (st.matchesPlayed > 0) || (p && (p.matchesStarted > 0 || p.xp > 0)) || ledger.length > 1 || !!m;
      if (!played) return null;
      var last = ledger.length ? Number(ledger[ledger.length - 1].at) || 0 : 0;
      // Coins: the whole site's shared wallet (round 164, assets/wallet.js from games/shared/wallet.ts).
      var coins = window.AllFunWallet ? window.AllFunWallet.balance() : w && typeof w.balance === 'number' ? w.balance : null;
      return { line: 'Level ' + levelFromXp(p && p.xp), coins: coins,
        live: !!m, weight: (st.matchesPlayed || 0) + 1, at: last };
    },
    blocks: function () {
      var s = read('allfun.blocks.v1');
      if (!s || !(s.best > 0 || count(s.levels) || s.classic)) return null;
      var line = s.classic ? fmt(s.classic.score) + ' points' : s.best > 0 ? 'Best ' + fmt(s.best) : 'Level ' + nextLevel(s.levels, 30);
      return { line: line, live: !!s.classic, weight: sumStars(s.levels) + (s.best > 0 ? 1 : 0) };
    },
    sort: function () {
      var s = read('allfun.sort.v1');
      if (!s || !(count(s.levels) || s.current)) return null;
      return { line: 'Level ' + ((s.current && s.current.level) || nextLevel(s.levels, 500)), live: !!s.current, weight: count(s.levels) };
    },
    merge: function () {
      var s = read('allfun.merge.v1');
      if (!s || !(s.best > 0 || count(s.levels) || s.endless || s.level)) return null;
      var line = s.level ? 'Level ' + s.level.number : s.best > 0 ? 'Best ' + fmt(s.best) : 'Level ' + nextLevel(s.levels, 30);
      return { line: line, live: !!(s.endless || s.level), weight: sumStars(s.levels) + (s.best > 0 ? 1 : 0), top: s.top };
    },
    gems: function () {
      var s = read('allfun.gems.v1');
      if (!s || !(count(s.levels) || s.current)) return null;
      return { line: 'Level ' + ((s.current && s.current.number) || nextLevel(s.levels, 40)), live: !!s.current, weight: count(s.levels) };
    },
    bubbles: function () {
      var s = read('allfun.bubbles.v1');
      if (!s || !(count(s.levels) || s.current || s.endless || s.best > 0)) return null;
      var line = (s.current || count(s.levels)) ? 'Level ' + ((s.current && s.current.number) || nextLevel(s.levels, 40)) : 'Endless best ' + fmt(s.best);
      return { line: line, live: !!(s.current || s.endless), weight: count(s.levels) + (s.best > 0 ? 1 : 0) };
    },
    domino: function () {
      var s = read('allfun.domino.v1');
      var st = (s && s.stats) || {};
      if (!s || !(st.played > 0 || s.current)) return null;
      var line = st.won > 0 ? fmt(st.won) + (st.won === 1 ? ' win' : ' wins') : st.played > 0 ? fmt(st.played) + ' played' : 'Match started';
      return { line: line, live: !!s.current, weight: (st.played || 0) };
    },
    solitaire: function () {
      var s = read('allfun.solitaire.v1');
      if (!s) return null;
      var a = (s.stats && s.stats['1']) || {}, b = (s.stats && s.stats['3']) || {};
      var won = (a.won || 0) + (b.won || 0), played = (a.played || 0) + (b.played || 0);
      if (!(played > 0 || won > 0 || s.current || count(s.daily))) return null;
      var line = won > 0 ? fmt(won) + (won === 1 ? ' win' : ' wins') : played > 0 ? fmt(played) + ' played' : 'Deal in progress';
      return { line: line, live: !!s.current, weight: played + won };
    },
    // games/mines/src/save.ts: stats per board ('easy', 'medium-s', …, 'daily'), a game in progress and today's Daily apart.
    mines: function () {
      var s = read('allfun.mines.v1');
      if (!s) return null;
      var played = 0, won = 0, best = 0;
      for (var k in (s.stats || {})) {
        var st = s.stats[k] || {};
        played += st.played || 0; won += st.won || 0;
        if (st.best > 0 && (!best || st.best < best)) best = st.best;
      }
      var cur = s.current || s.currentDaily;
      if (!(played > 0 || cur || count(s.daily))) return null;
      var line = cur ? (cur.mode === 'daily' ? 'Daily board' : levelName(cur.mode)) : best ? 'Best ' + clock(best) : won > 0 ? fmt(won) + (won === 1 ? ' win' : ' wins') : fmt(played) + ' played';
      return { line: line, live: !!cur, weight: played + won };
    },
    // games/sudoku/src/save.ts: stats per difficulty, the Daily puzzles solved, the puzzle in progress.
    sudoku: function () {
      var s = read('allfun.sudoku.v1');
      if (!s) return null;
      var played = 0, solved = 0;
      for (var k in (s.stats || {})) { played += (s.stats[k] || {}).played || 0; solved += (s.stats[k] || {}).won || 0; }
      var cur = s.current;
      if (!(played > 0 || cur || count(s.daily))) return null;
      var line = cur ? (cur.daily ? 'Daily puzzle' : levelName(cur.difficulty)) : solved > 0 ? 'Solved ' + fmt(solved) : fmt(played) + ' played';
      return { line: line, live: !!cur, weight: played + solved };
    },
    // games/checkers/src/save.ts: stats per computer level, the match being played.
    checkers: function () {
      var s = read('allfun.checkers.v1');
      if (!s) return null;
      var played = 0, won = 0;
      for (var k in (s.stats || {})) { played += (s.stats[k] || {}).played || 0; won += (s.stats[k] || {}).won || 0; }
      var cur = s.current;
      var live = !!(cur && cur.game && !cur.game.result);
      if (!(played > 0 || live)) return null;
      var line = won > 0 ? 'Won ' + fmt(won) : live ? levelName(cur.settings && cur.settings.level) : fmt(played) + ' played';
      return { line: line, live: live, weight: played + won };
    },
    // games/airhockey/src/save.ts: stats per computer level, two-player matches, the match being played.
    airhockey: function () {
      var s = read('allfun.airhockey.v1');
      if (!s) return null;
      var played = 0, won = 0;
      for (var k in (s.stats || {})) { played += (s.stats[k] || {}).played || 0; won += (s.stats[k] || {}).won || 0; }
      var duo = Number(s.duo) || 0;
      var cur = s.current && Array.isArray(s.current.score) ? s.current : null;
      if (!(played > 0 || duo > 0 || cur)) return null;
      var line = won > 0 ? 'Won ' + fmt(won) : cur ? 'Match ' + cur.score[0] + '–' + cur.score[1] : fmt(played + duo) + ' played';
      return { line: line, live: !!cur, weight: played + duo + won };
    },
    // games/fishing/src/save.ts (v 2 since 19.10, "Glowtide"): stars per level, the Fish Log (26 with the King Crab, 19.10), a round under way.
    // A save from before (v 1: XP, 40 species, a trip) is read the old way until the game turns it into v 2.
    fishing: function () {
      var s = read('allfun.fishing.v1');
      if (!s) return null;
      if (s.v === 2) {
        var stars = 0, beaten = 0, levels = Array.isArray(s.stars) ? s.stars : [];
        for (var i = 0; i < levels.length; i += 1) { var st = Number(levels[i]) || 0; stars += st; if (st > 0) beaten = i + 1; }
        var found = count(s.log), rounds = (s.stats && s.stats.rounds) || 0;
        var live = !!(s.round && s.round.over !== 'won');
        if (!(beaten || found || rounds || live)) return null;
        var line = live ? 'Level ' + s.round.level + ' in progress' : 'Level ' + Math.min(40, beaten + 1) + ' · ' + Math.min(found, 26) + '/27 found';
        return { line: line, live: live, weight: stars + found + rounds };
      }
      var xp = Number(s.xp) || 0, fish = count(s.dex), casts = (s.stats && s.stats.casts) || 0;
      var trip = !!(s.trip && s.trip.casts > 0);
      if (!(xp > 0 || fish || casts > 0 || trip)) return null;
      var lv = 1;
      while (lv < 60 && xp >= Math.round(50 * Math.pow(lv, 1.75))) lv += 1;
      return { line: 'Lv ' + lv + ' · ' + Math.min(fish, 40) + '/40 fish', live: trip, weight: fish + casts };
    },
    // games/tabletennis/src/save.ts: stats per computer level (the longest rally), the match being played.
    tabletennis: function () {
      var s = read('allfun.tabletennis.v1');
      if (!s) return null;
      var played = 0, won = 0, best = 0;
      for (var k in (s.stats || {})) {
        var st = s.stats[k] || {};
        played += st.played || 0; won += st.won || 0; best = Math.max(best, st.longest || 0);
      }
      var live = !!(s.current && s.current.m && s.current.m.winner == null);
      if (!(played > 0 || best > 0 || live)) return null;
      var line = best > 0 ? 'Best rally ' + fmt(best) : won > 0 ? 'Won ' + fmt(won) : live ? 'Match in progress' : fmt(played) + ' played';
      return { line: line, live: live, weight: played + won };
    },
    // games/pinball/src/save.ts: the best score, games played, the game in progress (it carries on from the
    // start of its ball).
    pinball: function () {
      var s = read('allfun.pinball.v1');
      if (!s) return null;
      var best = Number(s.best) || 0, played = Number(s.played) || 0;
      var cur = s.current && Number(s.current.ball) >= 1 ? s.current : null;
      if (!(best > 0 || played > 0 || cur)) return null;
      var line = cur ? 'Ball ' + Math.min(Math.floor(cur.ball), 3) : best > 0 ? 'Best ' + fmt(best) : fmt(played) + ' played';
      return { line: line, live: !!cur, weight: played };
    },
    // games/hearts/src/save.ts: stats (games, the lowest final score), the game being played (its hand number).
    hearts: function () {
      var s = read('allfun.hearts.v1');
      if (!s) return null;
      var st = s.stats || {};
      var m = s.current && s.current.m;
      var live = !!(m && m.winner == null);
      if (!(st.played > 0 || st.hands > 0 || live)) return null;
      var hand = live ? Number(m.round && m.round.no) || ((m.history && m.history.length) || 0) + 1 : 0;
      var line = live ? 'Hand ' + hand : st.won > 0 ? 'Wins ' + fmt(st.won) : st.best != null ? 'Best ' + fmt(st.best) : fmt(st.played || 0) + ' played';
      return { line: line, live: live, weight: (st.played || 0) + (st.won || 0) };
    },
    // games/spider/src/save.ts: stats per number of suits ('1', '2', '4'), the daily deals won, the deal being played.
    spider: function () {
      var s = read('allfun.spider.v1');
      if (!s) return null;
      var played = 0, won = 0;
      for (var k in (s.stats || {})) { played += (s.stats[k] || {}).played || 0; won += (s.stats[k] || {}).won || 0; }
      var cur = s.current;
      var live = !!(cur && !cur.won && (cur.moves > 0 || cur.counted));
      var daily = 0;
      for (var d in (s.daily || {})) daily += count(s.daily[d]);
      if (!(played > 0 || live || daily)) return null;
      var line = live ? (cur.daily ? 'Daily deal' : plural(Number(cur.suits) || 1, 'suit', 'suits')) + ' · ' + Math.min((cur.done || []).length, 8) + '/8 runs'
        : won > 0 ? 'Wins ' + fmt(won) : fmt(played) + ' played';
      return { line: line, live: live, weight: played + won };
    },
    // games/freecell/src/save.ts: stats per level ('easy', 'medium', 'hard'), the daily deals won, the deal being played.
    freecell: function () {
      var s = read('allfun.freecell.v1');
      if (!s) return null;
      var played = 0, won = 0;
      for (var k in (s.stats || {})) { played += (s.stats[k] || {}).played || 0; won += (s.stats[k] || {}).won || 0; }
      var cur = s.current;
      var live = !!(cur && !cur.won && (cur.moves > 0 || cur.counted));
      var daily = count(s.daily);
      if (!(played > 0 || live || daily)) return null;
      var line = live ? (cur.daily ? 'Daily deal' : 'Deal #' + fmt(cur.no)) : won > 0 ? 'Wins ' + fmt(won) : daily ? 'Daily deal' : fmt(played) + ' played';
      return { line: line, live: live, weight: played + won };
    },
    // games/spades/src/save.ts: stats (matches, rounds, the best team score), the match being played (its round and our score).
    spades: function () {
      var s = read('allfun.spades.v1');
      if (!s) return null;
      var st = s.stats || {};
      var m = s.current && s.current.m;
      var live = !!(m && m.round && m.winner == null);
      if (!(st.matchesPlayed > 0 || st.roundsPlayed > 0 || live)) return null;
      var line = live ? 'Round ' + (Number(m.round.no) || 1) + ' · Us ' + fmt((m.scores && m.scores[0]) || 0)
        : st.matchesWon > 0 ? 'Wins ' + fmt(st.matchesWon) : st.bestScore > 0 ? 'Best ' + fmt(st.bestScore)
        : st.matchesPlayed > 0 ? fmt(st.matchesPlayed) + ' played' : plural(st.roundsPlayed, 'round', 'rounds') + ' played';
      return { line: line, live: live, weight: (st.roundsPlayed || 0) + (st.matchesWon || 0) };
    },
    // games/tripeaks/src/save.ts: stars per level (72 levels), the daily deals won, the level being played.
    tripeaks: function () {
      var s = read('allfun.tripeaks.v1');
      if (!s) return null;
      var stars = sumStars(s.levels), daily = count(s.daily);
      var cur = s.current;
      var live = !!(cur && !cur.won && !cur.missed && cur.state && cur.state.moves > 0);
      if (!(stars > 0 || live || daily)) return null;
      var line = live ? (cur.date ? 'Daily deal' : 'Level ' + (Number(cur.level) || 1)) : stars > 0 ? 'Stars ' + fmt(stars) : 'Daily deal';
      return { line: line, live: live, weight: stars + daily };
    },
    // games/snake/src/save.ts: the best scores (Classic, Zen), stars per level, the game in progress.
    snake: function () {
      var s = read('allfun.snake.v1');
      if (!s) return null;
      var best = (s.best && s.best.classic) || 0, zen = (s.best && s.best.zen) || 0, stars = sumStars(s.levels);
      var g = (s.stats && s.stats.games) || {}, played = (g.classic || 0) + (g.zen || 0) + (g.levels || 0);
      var cur = s.current && s.current.state;
      if (!(best > 0 || zen > 0 || stars > 0 || played > 0 || cur)) return null;
      var line = cur ? (cur.mode === 'levels' ? 'Level ' + (Number(cur.level) || 1) : (cur.mode === 'zen' ? 'Zen' : 'Classic') + ' · ' + fmt(cur.score))
        : best > 0 ? 'Best ' + fmt(best) : stars > 0 ? 'Stars ' + fmt(stars) : zen > 0 ? 'Zen best ' + fmt(zen) : fmt(played) + ' played';
      return { line: line, live: !!cur, weight: played + stars };
    },
    // games/bricks/src/save.ts: stars per level (100 levels), Endless best, the game in progress (a level or Endless).
    bricks: function () {
      var s = read('allfun.bricks.v1');
      if (!s) return null;
      var stars = sumStars(s.levels), cur = s.current, played = Number(s.played) || 0, endless = Number(s.endlessBest) || 0;
      if (!(stars > 0 || cur || played > 0 || endless > 0)) return null;
      var line = cur ? (cur.mode === 'endless' ? 'Endless · ' + fmt(cur.score) : 'Level ' + (Number(cur.level) || 1))
        : stars > 0 ? 'Level ' + nextLevel(s.levels, 100) : endless > 0 ? 'Endless best ' + fmt(endless) : fmt(played) + ' played';
      return { line: line, live: !!cur, weight: stars + played };
    },
    // games/chess/src/save.ts: stats per computer level, the rating, puzzles solved, the game being played.
    chess: function () {
      var s = read('allfun.chess.v1');
      if (!s) return null;
      var played = 0, won = 0;
      for (var k in (s.stats || {})) { played += (s.stats[k] || {}).played || 0; won += (s.stats[k] || {}).won || 0; }
      var cur = s.current, live = !!(cur && !cur.result && Array.isArray(cur.moves) && cur.moves.length > 0);
      var pz = (s.puzzles && s.puzzles.solved) || 0, local = Number(s.localGames) || 0;
      if (!(played > 0 || live || pz > 0 || local > 0)) return null;
      var line = live ? (cur.mode === 'local' ? 'Two players' : 'Level ' + (Number(cur.level) || 1)) + ' · Move ' + (Math.floor(cur.moves.length / 2) + 1)
        : s.ratingGames > 0 ? 'Rating ' + fmt(s.rating) : won > 0 ? 'Won ' + fmt(won) : pz > 0 ? plural(pz, 'puzzle', 'puzzles') + ' solved' : fmt(played + local) + ' played';
      return { line: line, live: live, weight: played + won + pz + local };
    },
    // games/fourinarow/src/save.ts: stats per computer level, two-player games, the match being played.
    fourinarow: function () {
      var s = read('allfun.fourinarow.v1');
      if (!s) return null;
      var played = 0, won = 0;
      for (var k in (s.stats || {})) { played += (s.stats[k] || {}).played || 0; won += (s.stats[k] || {}).won || 0; }
      var duo = (s.duo && s.duo.played) || 0, cur = s.current, live = !!(cur && cur.game);
      if (!(played > 0 || duo > 0 || live)) return null;
      var what = live && cur.settings ? (cur.settings.mode === 'duo' ? '2 players' : levelName(cur.settings.level)) : '';
      var line = live ? what + ' · Game ' + (Number(cur.game.no) || 1) : won > 0 ? 'Won ' + fmt(won) : fmt(played + duo) + ' played';
      return { line: line, live: live, weight: played + duo + won };
    },
    // games/ginrummy/src/save.ts: stats (hands, matches, gins), the daily challenges won, the match being played.
    ginrummy: function () {
      var s = read('allfun.ginrummy.v1');
      if (!s) return null;
      var st = s.stats || {}, m = s.current && s.current.m;
      var live = !!(m && m.winner == null);
      if (!(st.handsPlayed > 0 || st.matchesPlayed > 0 || live || count(s.daily))) return null;
      var line = live ? (m.daily ? 'Daily challenge' : 'Hand ' + (Number(m.handNo) || 1) + ' · ' + fmt((m.scores && m.scores[0]) || 0) + '–' + fmt((m.scores && m.scores[1]) || 0))
        : st.matchesWon > 0 ? 'Wins ' + fmt(st.matchesWon) : st.gins > 0 ? plural(st.gins, 'Gin', 'Gins') : count(s.daily) ? 'Daily challenge' : plural(st.handsPlayed || 0, 'hand', 'hands') + ' played';
      return { line: line, live: live, weight: (st.handsPlayed || 0) + (st.matchesWon || 0) };
    },
    // games/pyramid/src/save.ts: stars per level (72 levels), the daily deals won, classic deals, the game being played.
    pyramid: function () {
      var s = read('allfun.pyramid.v1');
      if (!s) return null;
      var stars = sumStars(s.levels), daily = count(s.daily), classic = (s.classic && s.classic.played) || 0;
      var cur = s.current;
      var live = !!(cur && !cur.won && !cur.missed && cur.state && cur.state.moves > 0);
      if (!(stars > 0 || live || daily || classic > 0)) return null;
      var line = live ? (cur.date ? 'Daily deal' : cur.level < 0 ? 'Classic deal' : 'Level ' + (Number(cur.level) || 1))
        : stars > 0 ? 'Stars ' + fmt(stars) : daily ? 'Daily deal' : fmt(classic) + ' played';
      return { line: line, live: live, weight: stars + daily + classic };
    },
    // games/racing/src/save.ts: the championship under way (its cup and next race), races and wins, the best finish per
    // cup and difficulty (a trophy is 1st to 3rd), time trials and the daily race.
    racing: function () {
      var s = read('allfun.racing.v1');
      if (!s) return null;
      var races = Number(s.races) || 0, wins = Number(s.wins) || 0, trials = count(s.bestRace), cups = 0;
      for (var k in (s.cups || {})) {
        var best = 9, row = s.cups[k] || {};
        for (var d in row) best = Math.min(best, Number(row[d]) || 9);
        if (best <= 3) cups += 1;
      }
      var cup = s.cup && typeof s.cup.cup === 'number' ? s.cup : null;
      if (!(races > 0 || cup || trials || (s.daily && s.daily.best > 0))) return null;
      var line = cup ? (['Midnight', 'Canyon', 'Glacier', 'Nebula'][cup.cup] || 'Cup') + ' Cup · Race ' + (Math.min(Number(cup.race) || 0, 3) + 1)
        : cups > 0 ? plural(cups, 'trophy', 'trophies') : wins > 0 ? 'Wins ' + fmt(wins) : races > 0 ? plural(races, 'race', 'races') : 'Time trial';
      return { line: line, live: !!cup, weight: races + wins + trials };
    },
    // games/basketball/src/save.ts: the Arcade best, games played, stars per challenge, the game in progress (Arcade,
    // a challenge or the daily one).
    basketball: function () {
      var s = read('allfun.basketball.v1');
      if (!s) return null;
      var best = Number(s.best) || 0, played = Number(s.played) || 0, stars = sumStars(s.stars);
      var cur = s.current && s.current.mode ? s.current : null;
      if (!(best > 0 || played > 0 || stars > 0 || cur)) return null;
      var line = cur ? (cur.mode === 'arcade' ? 'Arcade · ' + fmt(cur.game && cur.game.score) : cur.mode === 'daily' ? 'Daily challenge' : 'Challenge ' + (Number(cur.challenge) || 1))
        : best > 0 ? 'Best ' + fmt(best) : stars > 0 ? 'Stars ' + fmt(stars) : fmt(played) + ' played';
      return { line: line, live: !!cur, weight: played + stars };
    },
    // games/darts/src/save.ts: legs and 180s per mode, matches against each computer level, two-player legs, stars per
    // challenge, the match or challenge in progress (main.ts sessionLabel).
    darts: function () {
      var s = read('allfun.darts.v1');
      if (!s) return null;
      var legs = 0, n180 = 0, won = 0;
      for (var k in (s.stats || {})) { legs += (s.stats[k] || {}).legs || 0; n180 += (s.stats[k] || {}).n180 || 0; }
      for (var l in (s.levels || {})) won += (s.levels[l] || {}).won || 0;
      var duo = (s.duo && s.duo.legs) || 0, stars = sumStars(s.stars), c = s.current;
      var live = !!(c && (c.kind === 'match' || c.kind === 'challenge'));
      if (!(legs > 0 || duo > 0 || stars > 0 || live)) return null;
      var set = (c && c.settings) || {};
      var mode = { '501': '501', '301': '301', cricket: 'Cricket', clock: 'Clock' }[set.mode] || '501';
      var who = set.opp === 'duo' ? '2 players' : set.opp === 'solo' ? 'Solo' : levelName(set.level || 'medium');
      var line = live ? (c.kind === 'challenge' ? (c.id === 0 ? 'Daily challenge' : 'Challenge ' + c.id) : mode + ' · ' + who + (set.legs > 1 && c.leg ? ' · leg ' + c.leg.no : ''))
        : n180 > 0 ? plural(n180, '180', '180s') : won > 0 ? 'Won ' + fmt(won) : stars > 0 ? 'Stars ' + fmt(stars) : plural(legs + duo, 'leg', 'legs') + ' played';
      return { line: line, live: live, weight: legs + duo + stars };
    },
    // games/flags/src/save.ts: stars per level, the quiz in progress in each mode (Flags, Capitals, Map Shapes) and in
    // the Daily Quiz, Continents, Bigger or Smaller and Learn, the days played, the answers given.
    flags: function () {
      var s = read('allfun.flags.v1');
      if (!s) return null;
      var AREA = { europe: 'Europe', asia: 'Asia', africa: 'Africa', americas: 'Americas', oceania: 'Oceania', world: 'World' };
      var cur = s.current || {}, mode = ['flags', 'capitals', 'shapes'].filter(function (m) { return cur[m]; })[0];
      var d = s.daily || {}, dcur = d.current && d.current.date === dateKey(new Date()) ? d.current : null;
      var other = s.continents && s.continents.current ? 'Continents' : s.compare && s.compare.current ? 'Bigger or Smaller' : s.review && s.review.current ? 'Learn' : '';
      var stars = sumStars(s.stars) + sumStars(s.continents && s.continents.stars), days = count(d.history), answered = Number(s.answered) || 0;
      var live = !!(mode || dcur || other);
      if (!(live || stars > 0 || days || answered > 0)) return null;
      var line = dcur ? 'Daily Quiz · ' + (Number(dcur.at) || 0) + '/10'
        : mode ? { flags: 'Flags', capitals: 'Capitals', shapes: 'Map Shapes' }[mode] + ' · ' + (AREA[cur[mode].area] || 'World')
        : other || (stars > 0 ? 'Stars ' + fmt(stars) : days ? plural(days, 'daily quiz', 'daily quizzes') : fmt(Number(s.right) || 0) + ' right');
      return { line: line, live: live, weight: answered + stars };
    },
    // games/suitcase/src/save.ts: stars per level (156 levels), the daily trips packed, the trip being packed.
    suitcase: function () {
      var s = read('allfun.suitcase.v1');
      if (!s) return null;
      var stars = sumStars(s.levels), daily = count(s.daily), cur = s.current;
      var live = !!(cur && cur.moves > 0);
      if (!(stars > 0 || daily || live)) return null;
      var line = live ? (cur.date ? 'Daily trip' : 'Level ' + (Number(cur.number) || 1)) : stars > 0 ? 'Level ' + nextLevel(s.levels, 156) : 'Daily trip';
      return { line: line, live: live, weight: count(s.levels) + daily };
    },
    // games/chefpath/src/save.ts: stars per level (210 levels, 35 per eatery: data.ts EATERIES), the daily specials
    // cooked, the level (or daily special) being played.
    chefpath: function () {
      var s = read('allfun.chefpath.v1');
      if (!s) return null;
      var EAT = ['The Ladle Truck', 'Teacup Corner', 'Lantern Alley', 'Seashell Grill', 'Snowberry Lodge', 'The Silver Cloche'];
      var at = function (n) { return EAT[Math.min(5, Math.max(0, Math.floor((n - 1) / 35)))] + ' · Level ' + n; };
      var stars = sumStars(s.levels), daily = count(s.daily), cur = s.current && s.current.state ? s.current : null;
      if (!(stars > 0 || daily || cur)) return null;
      var line = cur ? (cur.date || !cur.number ? 'Daily special' : at(Number(cur.number) || 1)) : stars > 0 ? at(nextLevel(s.levels, 210)) : 'Daily special';
      return { line: line, live: !!(cur && cur.state.moves > 0), weight: count(s.levels) + daily };
    },
    // games/chefdeck/src/save.ts: the run in progress (its day and restaurant: content.ts THEMES), today's Daily run, the
    // runs played, Golden Stars, the best run and the Recipe Book's pairings found.
    chefdeck: function () {
      var s = read('allfun.chefdeck.v1');
      if (!s) return null;
      var PLACE = { bistro: 'Corner Bistro', wok: 'Night Wok', loft: 'Sugar Loft', harbour: 'Harbour Shack', bazaar: 'Spice Bazaar' };
      var run = s.run && s.run.day ? s.run : null;
      var dr = s.dailyRun && s.dailyRun.day && s.dailyRun.daily === dateKey(new Date()) ? s.dailyRun : null;
      var runs = Number(s.runs) || 0, found = Array.isArray(s.found) ? s.found.length : 0, stars = Number(s.stars) || 0, best = Number(s.bestDays) || 0;
      var dailies = count(s.daily && s.daily.done);
      if (!(run || dr || runs > 0 || found || dailies)) return null;
      var line = run ? 'Day ' + run.day + ' · ' + (PLACE[run.theme] || 'Kitchen') : dr ? 'Daily run · Day ' + dr.day
        : stars > 0 ? 'Stars ' + fmt(stars) : best > 0 ? 'Best run ' + plural(best, 'day', 'days')
        : found ? plural(found, 'pairing', 'pairings') + ' found' : plural(runs + dailies, 'run', 'runs') + ' played';
      return { line: line, live: !!(run || dr), weight: runs + found + dailies };
    },
    // games/runner/src/save.ts: the best distance (m), the runs, the parcels delivered and the daily run's streak (it lapses
    // when yesterday was missed: save.ts streakNow). A run is never saved half-way, so nothing is ever "in progress".
    runner: function () {
      var s = read('allfun.runner.v1');
      if (!s) return null;
      var st = s.stats || {}, best = Number(s.best) || 0, runs = Number(st.runs) || 0, d = s.daily || {};
      var today = dateKey(new Date()), y = new Date();
      y.setDate(y.getDate() - 1);
      var streak = (d.last === today || d.last === dateKey(y)) ? Number(d.streak) || 0 : 0;
      if (!(best > 0 || runs > 0 || d.last)) return null;
      var line = streak > 1 && d.last !== today ? 'Daily run · streak ' + streak : best > 0 ? 'Best ' + fmt(best) + ' m'
        : runs > 0 ? plural(runs, 'run', 'runs') : 'Daily run';
      return { line: line, live: false, weight: runs + (Number(st.deliveries) || 0) };
    },
    // games/trivia/src/save.ts: the XP (engine.ts levelOf: 120 XP for level 2, 40 more for each level after), the stars of
    // every category level (stars[cat][level]), the Daily Trivia days played (daily[date]; its streak lapses when yesterday
    // was missed: engine.ts streakOf) and the round being played (run, until its end card: run.ended).
    trivia: function () {
      var s = read('allfun.trivia.v1');
      if (!s) return null;
      var CAT = { geography: 'Geography', history: 'History', science: 'Science', nature: 'Nature', space: 'Space', food: 'Food',
        sports: 'Sports', body: 'Body', inventions: 'Inventions', arts: 'Arts', words: 'Words', general: 'General' };
      var xp = Math.max(0, Number(s.xp) || 0), level = 1, need = 120;
      while (xp >= need && level < 999) { xp -= need; level += 1; need = 120 + (level - 1) * 40; }
      var stars = 0, cats = s.stars && typeof s.stars === 'object' ? s.stars : {};
      for (var c in cats) stars += sumStars(cats[c]);
      var st = s.stats || {}, rounds = Number(st.rounds) || 0, answered = Number(st.answered) || 0;
      var daily = s.daily && typeof s.daily === 'object' ? s.daily : {}, day = new Date(), today = dateKey(day), streak = 0;
      if (!daily[today]) day.setDate(day.getDate() - 1);
      while (daily[dateKey(day)] && streak < 3660) { streak += 1; day.setDate(day.getDate() - 1); }
      var run = s.run && typeof s.run === 'object' && !s.run.ended && Array.isArray(s.run.ids) && s.run.ids.length ? s.run : null;
      if (run && run.mode === 'daily' && run.date !== today) run = null; // yesterday's Daily is gone
      if (!(run || rounds > 0 || answered > 0 || stars > 0 || Number(s.xp) > 0)) return null;
      var at = run ? Math.min((Number(run.at) || 0) + 1, run.ids.length) : 0;
      var line = !run ? (streak > 1 && !daily[today] ? 'Daily streak ' + streak : 'Level ' + level + (stars > 0 ? ' · ' + fmt(stars) + ' ★' : ''))
        : run.mode === 'level' ? (CAT[run.cat] || 'Category') + ' · Level ' + (Number(run.level) || 1)
        : run.mode === 'daily' ? 'Daily Trivia · ' + at + '/' + run.ids.length
        : run.mode === 'survival' ? 'Survival · ' + (run.answers || []).filter(function (a) { return a && a.right; }).length + ' right'
        : run.mode === 'duel' ? 'Duel · ' + at + '/' + run.ids.length
        : 'Quick Round · ' + at + '/' + run.ids.length;
      return { line: line, live: !!run, weight: rounds + stars };
    },
    // games/tiles/src/save.ts: stars per level (160 levels, 20 in each of eight waters: levels.ts WORLDS), the Daily puzzles
    // cleared (daily[date]; the streak lapses when yesterday was missed: save.ts dailyStreak) and the level or today's Daily
    // puzzle being played (current: saved as soon as it starts, so it is "in progress" once a tile has been picked).
    tiles: function () {
      var s = read('allfun.tiles.v1');
      if (!s) return null;
      var WORLD = ['Sunny Shallows', 'Kelp Forest', 'Coral Gardens', 'Pearl Lagoon', 'Sunken Galleon', 'Moonlit Reef', 'Glowing Deep', 'Abyss Lights'];
      var stars = sumStars(s.levels), daily = s.daily && typeof s.daily === 'object' ? s.daily : {}, days = count(daily);
      var day = new Date(), today = dateKey(day), streak = 0;
      if (!daily[today]) day.setDate(day.getDate() - 1);
      while (daily[dateKey(day)] && streak < 3660) { streak += 1; day.setDate(day.getDate() - 1); }
      var cur = s.current && s.current.state && typeof s.current.state === 'object' ? s.current : null;
      if (cur && cur.date && cur.date !== today) cur = null; // yesterday's Daily puzzle is gone
      var live = !!(cur && Array.isArray(cur.state.gone) && cur.state.gone.length && !cur.state.over);
      if (!(stars > 0 || days || live)) return null;
      var n = live && !cur.date ? Math.max(1, Number(cur.number) || 1) : nextLevel(s.levels, 160);
      var line = live ? (cur.date ? 'Daily puzzle' : 'Level ' + n + ' · ' + WORLD[Math.min(7, Math.floor((n - 1) / 20))])
        : streak > 1 && !daily[today] ? 'Daily streak ' + streak
        : stars > 0 ? 'Level ' + n + ' · ' + fmt(stars) + ' ★' : 'Daily puzzle';
      return { line: line, live: live, weight: count(s.levels) + days };
    },
    // games/ludo/src/save.ts: games against the computer and the ones won (games, wins), the win streak, games on one
    // device (local) and the game being played (current: kept until it is over, play.ts; its seats, settings and whose turn).
    ludo: function () {
      var s = read('allfun.ludo.v1');
      if (!s) return null;
      var RIVAL = { nova: 'Nova', pixel: 'Pixel', mako: 'Mako', vega: 'Vega' }, LEVEL = { easy: 'Easy', normal: 'Normal', hard: 'Hard' };
      var games = Number(s.games) || 0, wins = Number(s.wins) || 0, streak = Number(s.streak) || 0, local = Number(s.local) || 0;
      var cur = s.current && s.current.state && Array.isArray(s.current.seats) && Array.isArray(s.current.state.players) ? s.current : null;
      var live = !!(cur && cur.state.phase !== 'over' && cur.seats.length >= 2);
      if (!(games > 0 || local > 0 || live)) return null;
      var line;
      if (live) {
        var n = cur.seats.length, set = cur.settings || {}, seat = cur.seats[cur.state.turn] || {};
        line = set.mode === 'local' ? 'Pass & play · ' + n + ' players'
          : (n === 2 ? 'vs ' + (RIVAL[(cur.seats[1] || {}).rival] || '1 rival') : 'vs ' + (n - 1) + ' rivals')
            + ' · ' + (seat.kind === 'human' ? 'your turn' : LEVEL[set.level] || 'Normal');
      } else line = wins > 0 ? 'Wins ' + fmt(wins) + (streak > 1 ? ' · streak ' + streak : '') : plural(games + local, 'game', 'games');
      return { line: line, live: live, weight: games + local + wins };
    },
    // games/billiards/src/save.ts: wins and losses per rival and level (rivals), the win streak, Trick Shot stars per level
    // (tricks), the Rack Run's days (rack: date -> result), games played and the game being played (current: a match with
    // its frame and whose turn, a Trick Shot level, or today's Rack Run; a lost match is kept for a retry, play.ts).
    billiards: function () {
      var s = read('allfun.billiards.v1');
      if (!s) return null;
      var RIVAL = { mako: 'Mako', pixel: 'Pixel', nova: 'Nova', vega: 'Vega' };
      var games = Number(s.games) || 0, stars = sumStars(s.tricks), rack = s.rack && typeof s.rack === 'object' ? s.rack : {};
      var wins = 0;
      if (s.rivals && typeof s.rivals === 'object') for (var id in s.rivals) {
        var w = s.rivals[id] && s.rivals[id].w;
        if (Array.isArray(w)) wins += (Number(w[0]) || 0) + (Number(w[1]) || 0) + (Number(w[2]) || 0);
      }
      var day = new Date(), today = dateKey(day), streak = 0;
      if (!rack[today]) day.setDate(day.getDate() - 1);
      while (rack[dateKey(day)] && streak < 3660) { streak += 1; day.setDate(day.getDate() - 1); }
      var cur = s.current && typeof s.current === 'object' ? s.current : null, line = '', live = false;
      if (cur && cur.kind === 'match' && cur.frame && typeof cur.frame === 'object' && cur.frame.winner == null) {
        var who = RIVAL[cur.rival] || 'the computer';
        live = true;
        line = (cur.mode === '9ball' ? '9-Ball' : '8-Ball') + ' vs ' + who + ' · ' + (cur.frame.turn === 1 ? who + '’s shot' : 'your shot');
      } else if (cur && cur.kind === 'trick' && !cur.won && Number(cur.n) >= 1) {
        live = true;
        line = 'Trick Shot ' + Math.min(100, Math.floor(Number(cur.n)));
      } else if (cur && cur.kind === 'rack' && cur.date === today && !cur.done) {
        live = true;
        line = 'Rack Run · today';
      }
      if (!(games > 0 || stars > 0 || count(rack) || live)) return null;
      if (!live) line = streak > 1 ? 'Rack Run streak ' + streak
        : stars > 0 ? 'Trick Shots · ' + fmt(stars) + ' ★'
        : wins > 0 ? 'Wins ' + fmt(wins) + (Number(s.streak) > 1 ? ' · streak ' + Number(s.streak) : '')
        : games > 0 ? plural(games, 'game', 'games') : 'Rack Run';
      return { line: line, live: live, weight: games + count(s.tricks) + count(rack) };
    },
    // games/bolts/src/save.ts: stars per level (levels: 160 in eight workshop corners of 20, levels.ts CHAPTERS), the Daily
    // puzzles cleared (daily: date -> result), and the level being played (current: its number, or 0 with the date for the
    // Daily puzzle; its state: the screws taken out (gone) and over). It is saved as soon as a level opens, so it counts as
    // in progress only once a screw is out.
    bolts: function () {
      var s = read('allfun.bolts.v1');
      if (!s) return null;
      var CORNER = ['Sawdust Corner', 'Brass Drawer', 'Paint Shelf', 'Clockwork Nook', 'Glass Cabinet', 'Spring Loft', 'Locksmith Bench', 'Master’s Table'];
      var stars = sumStars(s.levels), daily = s.daily && typeof s.daily === 'object' ? s.daily : {}, days = count(daily);
      var day = new Date(), today = dateKey(day), streak = 0;
      if (!daily[today]) day.setDate(day.getDate() - 1);
      while (daily[dateKey(day)] && streak < 3660) { streak += 1; day.setDate(day.getDate() - 1); }
      var cur = s.current && s.current.state && typeof s.current.state === 'object' ? s.current : null;
      if (cur && cur.date && cur.date !== today) cur = null; // yesterday's Daily puzzle is gone
      var live = !!(cur && Array.isArray(cur.state.gone) && cur.state.gone.length && !cur.state.over);
      if (!(stars > 0 || days || live)) return null;
      var n = live && !cur.date ? Math.min(160, Math.max(1, Math.floor(Number(cur.number)) || 1)) : nextLevel(s.levels, 160);
      var line = live ? (cur.date ? 'Daily puzzle' : 'Level ' + n + ' · ' + CORNER[Math.min(7, Math.floor((n - 1) / 20))])
        : streak > 1 && !daily[today] ? 'Daily streak ' + streak
        : stars > 0 ? 'Level ' + n + ' · ' + fmt(stars) + ' ★' : 'Daily puzzle';
      return { line: line, live: live, weight: count(s.levels) + days };
    },
    // games/golf/src/save.ts: the best strokes and stars on every hole (holes: 'c1h1'…, 54 on six courses of nine), each
    // course's best round (courses: one trophy each), the holes and rounds played, the daily holes played (daily: date ->
    // result; the streak lapses when yesterday was missed: save.ts dailyStreak) and the round being played (current: a course
    // and its hole, a round against a rival, or today's daily hole; kept until it is over, home.ts current()).
    golf: function () {
      var s = read('allfun.golf.v1');
      if (!s) return null;
      var COURSE = ['Clover Meadow', 'Driftwood Cove', 'Sunstone Canyon', 'Frostpeak', 'Maple Hollow', 'Moonlit Garden'];
      var RIVAL = { mako: 'Mako', pixel: 'Pixel', nova: 'Nova', vega: 'Vega' };
      var holes = s.holes && typeof s.holes === 'object' ? s.holes : {}, stars = 0;
      for (var k in holes) stars += (holes[k] && Number(holes[k].stars)) || 0;
      var trophies = count(s.courses), daily = s.daily && typeof s.daily === 'object' ? s.daily : {}, days = count(daily);
      var day = new Date(), today = dateKey(day), streak = 0;
      if (!daily[today]) day.setDate(day.getDate() - 1);
      while (daily[dateKey(day)] && streak < 3660) { streak += 1; day.setDate(day.getDate() - 1); }
      var cur = s.current && typeof s.current === 'object' && s.current.kind ? s.current : null;
      if (cur && cur.kind === 'daily' && cur.date !== today) cur = null; // yesterday's daily hole is gone
      var live = !!(cur && !cur.over), played = Number(s.holesPlayed) || 0;
      if (!(live || stars > 0 || days || played > 0)) return null;
      var hole = live ? Math.min(9, Math.max(1, Math.floor(Number(cur.hole)) + 1 || 1)) : 1;
      var line = live ? (cur.kind === 'daily' ? 'Daily hole' : cur.kind === 'rival' ? 'vs ' + (RIVAL[cur.rival] || 'a rival') + ' · hole ' + hole
          : (COURSE[Math.floor(Number(cur.c))] || 'Course') + ' · hole ' + hole)
        : streak > 1 && !daily[today] ? 'Daily hole · streak ' + streak
        : stars > 0 ? fmt(stars) + ' ★' + (trophies ? ' · ' + plural(trophies, 'trophy', 'trophies') : '')
        : played > 0 ? plural(played, 'hole', 'holes') : 'Daily hole';
      return { line: line, live: live, weight: played + days };
    },
    // games/dice/src/save.ts: the game being played (current: Solo, against a rival or pass & play, kept until it is over;
    // a match's state: rules.ts, a card per player, 13 boxes), today's Daily game (dailyGame, its own slot), the Daily days
    // (daily: date -> best; the streak: daily.ts streakOf, today or yesterday back), the top scores (bests) and games played.
    dice: function () {
      var s = read('allfun.dice.v1');
      if (!s) return null;
      var RIVAL = { nova: 'Nova', pixel: 'Pixel', mako: 'Mako', vega: 'Vega' };
      var ok = function (m) {
        return m && typeof m === 'object' && m.state && Array.isArray(m.state.players) && m.state.players.length && m.state.phase !== 'over';
      };
      var turn = function (m) {
        var card = m.state.players[Math.floor(Number(m.state.turn)) || 0] || m.state.players[0];
        var filled = card && Array.isArray(card.s) ? card.s.filter(function (v) { return v !== null && v !== undefined; }).length : 0;
        return 'turn ' + Math.min(13, filled + 1) + '/13';
      };
      var daily = s.daily && typeof s.daily === 'object' ? s.daily : {}, days = count(daily);
      var day = new Date(), today = dateKey(day), streak = 0;
      if (!daily[today]) day.setDate(day.getDate() - 1);
      while (daily[dateKey(day)] && streak < 3660) { streak += 1; day.setDate(day.getDate() - 1); }
      var cur = ok(s.current) && s.current.mode !== 'daily' ? s.current : null;
      var dg = ok(s.dailyGame) && s.dailyGame.date === today ? s.dailyGame : null; // yesterday's Daily is gone
      var best = Array.isArray(s.bests) && s.bests[0] ? Number(s.bests[0].score) || 0 : 0, games = Number(s.games) || 0;
      if (!(cur || dg || days || best > 0 || games > 0)) return null;
      var who = cur && (cur.mode === 'rival' ? 'vs ' + (RIVAL[(cur.seats && cur.seats[1] && cur.seats[1].rival) || ''] || 'a rival')
        : cur.mode === 'local' ? 'Pass & play' : 'Solo');
      var line = cur ? who + ' · ' + turn(cur)
        : dg ? 'Daily dice · ' + turn(dg)
        : streak > 1 && !daily[today] ? 'Daily dice · streak ' + streak
        : best > 0 ? 'Best ' + fmt(best)
        : games > 0 ? plural(games, 'game', 'games') : 'Daily dice';
      return { line: line, live: !!(cur || dg), weight: games + days };
    },
    // games/royale/src/save.ts: XP (data.ts levelOf: 160 XP for level 2, 60 more for each level after, up to 99; the
    // rank: RANKS), the match stats (matches, wins), the free supply crate (crate.date: the day it was last opened). A match
    // is never resumed (save.live only keeps what a cut-off match already paid), so it is never "in progress".
    royale: function () {
      var s = read('allfun.royale.v1');
      if (!s) return null;
      var st = s.stats && typeof s.stats === 'object' ? s.stats : {};
      var matches = Math.floor(Number(st.matches)) || 0, wins = Math.floor(Number(st.wins)) || 0, xp = Math.max(0, Math.floor(Number(s.xp)) || 0);
      if (!(matches > 0 || xp > 0)) return null;
      var level = 1;
      while (level < 99 && xp >= 160 + 60 * (level - 1)) { xp -= 160 + 60 * (level - 1); level += 1; }
      var RANKS = [[26, 'Zenith'], [19, 'Nova'], [13, 'Prism'], [8, 'Flare'], [4, 'Spark'], [1, 'Rookie']], rank = 'Rookie';
      for (var i = 0; i < RANKS.length; i += 1) if (level >= RANKS[i][0]) { rank = RANKS[i][1]; break; }
      var crate = !(s.crate && s.crate.date === dateKey(new Date()));
      var line = crate && matches > 0 ? 'Supply crate ready'
        : 'Lv ' + level + ' · ' + rank + (wins > 0 ? ' · ' + plural(wins, 'win', 'wins') : matches > 0 ? ' · ' + plural(matches, 'match', 'matches') : '');
      return { line: line, live: false, weight: matches };
    },
    // games/lasso/src/save.ts: stars per level (1…30), the daily round (date, stars), coins, the round in progress
    // (current: a level or the daily round; it resumes exactly where it was, so "in progress" is true).
    lasso: function () {
      var s = read('allfun.lasso.v1');
      if (!s) return null;
      var stars = sumStars(s.stars), rounds = Math.floor(Number(s.rounds)) || 0;
      var cur = s.current && (s.current.mode === 'level' || s.current.mode === 'daily') ? s.current : null;
      if (!(stars > 0 || rounds > 0 || cur)) return null;
      var next = 1;
      while (next < 30 && s.stars && s.stars[next] > 0) next += 1;
      var line = cur ? (cur.mode === 'daily' ? 'Daily round · in progress' : 'Level ' + (Math.floor(Number(cur.level)) || 1) + ' · in progress')
        : 'Level ' + next + (stars > 0 ? ' · ' + stars + ' ★' : '');
      return { line: line, live: !!cur, weight: rounds + stars };
    },
    // games/claw/src/save.ts: the Prize Shelf (shelf: plush id -> how many), the series completed (badges), grabs and
    // wins, XP (catalog.ts levelOf: level n from 60·n·(n−1) XP), and tries of a turn not dropped yet (turns: machine ->
    // { left }; credit before round 170: the game carries on with them, so it is "in progress").
    claw: function () {
      var s = read('allfun.claw.v1');
      if (!s) return null;
      var shelf = s.shelf && typeof s.shelf === 'object' ? s.shelf : {};
      var got = Object.keys(shelf).filter(function (k) { return Number(shelf[k]) > 0; }).length;
      var grabs = Math.floor(Number(s.grabs)) || 0, xp = Math.max(0, Math.floor(Number(s.xp)) || 0);
      if (!(grabs > 0 || got > 0)) return null;
      var level = 1;
      while (level < 99 && 60 * (level + 1) * level <= xp) level += 1;
      var turns = s.turns && typeof s.turns === 'object' ? s.turns : {};
      var left = Object.keys(turns).reduce(function (n, k) { var t = turns[k]; return Math.max(n, t && typeof t === 'object' ? Math.floor(Number(t.left)) || 0 : 0); }, 0);
      var live = left > 0 || !!(s.credit && typeof s.credit === 'object');
      var line = live ? (left > 1 ? left + ' tries left' : left === 1 ? '1 try left' : 'A try is paid') : got + '/24 plush · Lv ' + level;
      return { line: line, live: live, weight: grabs };
    },
    // games/crossword/src/save.ts: the puzzles solved (packs and Daily, by id), the Daily Crosswords solved by date,
    // puzzles started, and the puzzle played last if it is unfinished (current: it carries on letter for letter, so
    // "in progress" is true). Pack ids: p<size><e|m|h><n> (games/crossword/src/data.ts packId).
    crossword: function () {
      var s = read('allfun.crossword.v1');
      if (!s) return null;
      var solved = count(s.solved), played = Math.floor(Number(s.played)) || 0;
      var cur = s.current && typeof s.current === 'object' && typeof s.current.id === 'string' ? s.current : null;
      if (!(played > 0 || solved > 0 || count(s.daily) || cur)) return null;
      var m = cur && /^p(5|7|9|11|13)([emh])\d$/.exec(cur.id);
      var line = cur ? (cur.daily ? 'Daily Crossword' : m ? m[1] + '×' + m[1] + ' · ' + { e: 'Easy', m: 'Medium', h: 'Hard' }[m[2]] : 'Crossword')
        : solved > 0 ? 'Solved ' + fmt(solved) : fmt(played) + ' started';
      return { line: line, live: !!cur, weight: played + solved };
    },
    // games/memory/src/save.ts: stars per level (stars: '1'…'72' → 1–3), the Daily Memory days (daily: date → result),
    // games against the computer (vsGames) and on one device (duoGames), and the game in progress (current: main.ts
    // carries it on card for card, so "in progress" is true; yesterday's Daily is dropped, home.ts showHome).
    memory: function () {
      var s = read('allfun.memory.v1');
      if (!s) return null;
      var stars = sumStars(s.stars), daily = s.daily && typeof s.daily === 'object' ? s.daily : {}, days = count(daily);
      var day = new Date(), today = dateKey(day), streak = 0;
      if (!daily[today]) day.setDate(day.getDate() - 1);
      while (daily[dateKey(day)] && streak < 3660) { streak += 1; day.setDate(day.getDate() - 1); }
      var cur = s.current && typeof s.current === 'object' && s.current.st && typeof s.current.st === 'object' ? s.current : null;
      if (cur && cur.mode === 'daily' && cur.date !== today) cur = null; // yesterday's Daily is gone
      var vs = Math.floor(Number(s.vsGames)) || 0, duo = Math.floor(Number(s.duoGames)) || 0;
      if (!(stars > 0 || days || vs || duo || cur)) return null;
      var sc = cur && Array.isArray(cur.st.scores) ? (Number(cur.st.scores[0]) || 0) + '–' + (Number(cur.st.scores[1]) || 0) : '';
      var sp = cur && cur.st.spec && typeof cur.st.spec === 'object' ? cur.st.spec : null;
      var line = cur ? (cur.mode === 'level' ? 'Level ' + (Math.floor(Number(cur.level)) || 1) + (sp ? ' · ' + sp.cols + '×' + sp.rows : '')
          : cur.mode === 'daily' ? 'Daily Memory' : cur.mode === 'duo' ? '2 Players · ' + sc
          : 'vs ' + ({ easy: 'Mako', medium: 'Nova', hard: 'Vega' }[cur.vs] || 'Mako') + ' · ' + sc)
        : streak > 1 && !daily[today] ? 'Daily streak ' + streak
        : stars > 0 ? 'Level ' + nextLevel(s.stars, 72) + ' · ' + fmt(stars) + ' ★'
        : days ? 'Daily Memory' : fmt(vs + duo) + (vs + duo === 1 ? ' game' : ' games');
      return { line: line, live: !!cur, weight: count(s.stars) + days + vs + duo };
    },
    // games/cinderpoint/src/save.ts: matches won (wins), the most eliminations in one match (best), matches finished
    // (played; the first is the free warm-up) and the solo match in progress (current: the home's "Resume match" carries
    // it on exactly where it was, so "in progress" is true). The arena names: maps.ts ARENAS.
    cinderpoint: function () {
      var s = read('allfun.cinderpoint.v1');
      if (!s) return null;
      var wins = Math.floor(Number(s.wins)) || 0, best = Math.floor(Number(s.best)) || 0, played = Math.floor(Number(s.played)) || 0;
      var cur = s.current && typeof s.current === 'object' && s.current.phase === 'playing' && Array.isArray(s.current.actors) ? s.current : null;
      if (!(played > 0 || cur)) return null;
      var me = cur ? cur.actors.filter(function (a) { return a && a.id === 'you'; })[0] : null;
      var line = cur ? (['Kiln Yard', 'Tideworks', 'Aster Court'][cur.arena] || 'Match') + ' · ' + plural((me && Math.floor(Number(me.kills))) || 0, 'elim', 'elims')
        : wins > 0 ? plural(wins, 'win', 'wins') + (best > 0 ? ' · best ' + best : '')
        : plural(played, 'match', 'matches') + (best > 0 ? ' · best ' + best : '');
      return { line: line, live: !!cur, weight: played };
    },
    // games/bingo/src/save.ts: the stars of the 36 rounds (stars: room × 9 + round → 0–3), rounds won (roundsWon) and
    // played (played), the Daily Bingo days (daily: date → result) and the round in progress (current: the home's Resume
    // carries it on call for call, so "in progress" is true; a Daily of another day is not resumed, home.ts showHome).
    // The room names: rooms.ts ROOMS.
    bingo: function () {
      var s = read('allfun.bingo.v1');
      if (!s) return null;
      var stars = sumStars(s.stars), won = Math.floor(Number(s.roundsWon)) || 0, played = Math.floor(Number(s.played)) || 0;
      var daily = s.daily && typeof s.daily === 'object' ? s.daily : {}, days = count(daily);
      var day = new Date(), today = dateKey(day), streak = 0;
      if (!daily[today]) day.setDate(day.getDate() - 1);
      while (daily[dateKey(day)] && streak < 3660) { streak += 1; day.setDate(day.getDate() - 1); }
      var cur = s.current && typeof s.current === 'object' && typeof s.current.seed === 'string' && (s.current.kind === 'room' || s.current.kind === 'daily') ? s.current : null;
      if (cur && cur.kind === 'daily' && cur.date !== today) cur = null; // yesterday's Daily is gone
      if (!(played > 0 || stars > 0 || days || cur)) return null;
      var line = cur ? (cur.kind === 'daily' ? 'Daily Bingo'
          : (['Sunny Hall', 'Seaside Pier', 'Garden Party', 'Starlit Rooftop'][cur.room] || 'Bingo') + ' · Round ' + ((Math.floor(Number(cur.round)) || 0) + 1))
        : streak > 1 && !daily[today] ? 'Daily streak ' + streak
        : stars > 0 ? fmt(stars) + ' ★ · ' + plural(won, 'round won', 'rounds won')
        : days ? 'Daily Bingo' : plural(played, 'round', 'rounds');
      return { line: line, live: !!cur, weight: played + days };
    },
    // games/fizzwell/src/save.ts: the bests of Endless (best score, bestHeight in metres), climbs played (played), the
    // stars of the 30 challenges (stars: number → 1–3) and the climb in progress (current: the home's Continue carries it
    // on where it was, so "in progress" is true — main.ts shows it once the climb has started: a ledge reached, 3 s
    // played, or a challenge / the daily one). Its height: engine.ts metres() (10 world units a metre).
    fizzwell: function () {
      var s = read('allfun.fizzwell.v1');
      if (!s) return null;
      var best = Math.floor(Number(s.best)) || 0, height = Math.floor(Number(s.bestHeight)) || 0;
      var played = Math.floor(Number(s.played)) || 0, stars = sumStars(s.stars);
      var cur = s.current && typeof s.current === 'object' && s.current.run && typeof s.current.run === 'object' ? s.current : null;
      if (cur && !(Number(cur.run.top) > 0 || Number(cur.run.time) > 3 || cur.mode !== 'endless')) cur = null;
      if (!(played > 0 || best > 0 || stars > 0 || cur)) return null;
      var line = cur ? (cur.mode === 'daily' ? 'Daily challenge' : cur.mode === 'challenge' ? 'Challenge ' + (Math.floor(Number(cur.challenge)) || 1)
          : 'Climbing · ' + fmt(Math.max(0, Math.floor((Number(cur.run.topY) || 0) / 10))) + ' m')
        : best > 0 ? 'Best ' + fmt(best) + (height > 0 ? ' · ' + fmt(height) + ' m' : '')
        : stars > 0 ? fmt(stars) + ' ★' : plural(played, 'climb', 'climbs');
      return { line: line, live: !!cur, weight: played + count(s.stars) };
    },
    // games/motorush/src/save.ts: solo races finished (races), won (wins), the best time per route (best: seconds) and the
    // race in progress (current: the home's "Resume race" carries it on where it was, so "in progress" is true).
    motorush: function () {
      var s = read('allfun.motorush.v1');
      if (!s) return null;
      var races = Math.floor(Number(s.races)) || 0, wins = Math.floor(Number(s.wins)) || 0;
      var names = { coast: 'Harbor Run', metro: 'Civic Circuit', night: 'After Hours' }, lengths = { coast: 3200, metro: 3800, night: 3400 };
      var cur = s.current && typeof s.current === 'object' && names[s.current.route] && s.current.riders && s.current.riders[0] ? s.current : null;
      var best = 0, bestRoute = '';
      for (var k in (s.best || {})) { var b = Number(s.best[k]); if (names[k] && b > 0 && (!best || b < best)) { best = b; bestRoute = k; } }
      if (!(races > 0 || cur)) return null;
      var time = function (t) { var m = Math.floor(t / 60), x = (t - m * 60).toFixed(1); return m + ':' + (x < 10 ? '0' : '') + x; };
      var line = cur ? names[cur.route] + ' · ' + Math.max(0, Math.min(99, Math.round((Number(cur.riders[0].z) || 0) / lengths[cur.route] * 100))) + '%'
        : wins > 0 ? plural(wins, 'win', 'wins') + (best ? ' · best ' + time(best) : '')
        : best ? names[bestRoute] + ' · ' + time(best) : plural(races, 'race', 'races');
      return { line: line, live: !!cur, weight: races + wins };
    },
    // games/strikedistrict/src/save.ts: matches won (wins) and played (played), the longest chain (best) and the match in
    // progress (current: a whole engine.ts Match against the computer; the home's Resume match carries it on from the round
    // and the score it was at, so "in progress" is true — save.ts keeps it only while it is not over).
    strikedistrict: function () {
      var s = read('allfun.strikedistrict.v1');
      if (!s) return null;
      var wins = Math.floor(Number(s.wins)) || 0, best = Math.floor(Number(s.best)) || 0, played = Math.floor(Number(s.played)) || 0;
      var names = { mara: 'Mara', leon: 'Leon', tessa: 'Tessa', niko: 'Niko' };
      var cur = s.current && typeof s.current === 'object' && s.current.mode === 'solo' && s.current.phase !== 'matchover' && !s.current.counted
        && Array.isArray(s.current.fighters) && s.current.fighters.length === 2 && Array.isArray(s.current.wins) ? s.current : null;
      if (!(played > 0 || cur)) return null;
      var line = cur ? (names[cur.fighters[0] && cur.fighters[0].id] || 'You') + ' vs ' + (names[cur.fighters[1] && cur.fighters[1].id] || 'Rival')
          + ' · ' + (Math.floor(Number(cur.wins[0])) || 0) + ' : ' + (Math.floor(Number(cur.wins[1])) || 0)
        : wins > 0 ? plural(wins, 'win', 'wins') + (best > 1 ? ' · best chain ' + best : '')
        : plural(played, 'match', 'matches');
      return { line: line, live: !!cur, weight: played };
    },
    // games/skyshot/src/save.ts: stars per challenge (levels), best score (best), longest hit in metres (longest),
    // challenges finished (played) and a challenge in progress (current: an engine.ts State; the home's Continue picks it
    // up at the pitch it was on, so "in progress" is true — save.ts never keeps a finished one).
    skyshot: function () {
      var s = read('allfun.skyshot.v1');
      if (!s) return null;
      var best = Math.floor(Number(s.best)) || 0, longest = Math.round(Number(s.longest)) || 0, played = Math.floor(Number(s.played)) || 0;
      var stars = sumStars(s.levels);
      var cur = s.current && typeof s.current === 'object' && s.current.phase !== 'end' && Number(s.current.number) >= 1 ? s.current : null;
      if (!(played > 0 || best > 0 || stars > 0 || cur)) return null;
      var line = cur ? 'Challenge ' + Math.min(12, Math.floor(Number(cur.number)) || 1) + ' · pitch ' + Math.min(Math.floor(Number(cur.budget)) || 10, (Math.floor(Number(cur.pitches)) || 0) + 1)
        : stars > 0 ? fmt(stars) + ' ★' + (best > 0 ? ' · best ' + fmt(best) : '')
        : best > 0 ? 'Best ' + fmt(best) + (longest > 0 ? ' · ' + longest + ' m' : '')
        : plural(played, 'challenge', 'challenges');
      return { line: line, live: !!cur, weight: played + count(s.levels) };
    },
    // games/wordwheel/src/save.ts: the levels cleared (levels: number → true, 300 in 15 skies), the Daily wheels
    // cleared (daily: date → result), Word Search stars (search.stars) and three games that carry on where they were
    // left (current: a level; dailyNow: today's Daily wheel, yesterday's is not resumed, as home.ts; search.current).
    wordwheel: function () {
      var s = read('allfun.wordwheel.v1');
      if (!s) return null;
      var ws = s.search && typeof s.search === 'object' ? s.search : {};
      var done = count(s.levels), daily = s.daily && typeof s.daily === 'object' ? s.daily : {}, days = count(daily), stars = sumStars(ws.stars);
      var day = new Date(), today = dateKey(day), streak = 0;
      if (!daily[today]) day.setDate(day.getDate() - 1);
      while (daily[dateKey(day)] && streak < 3660) { streak += 1; day.setDate(day.getDate() - 1); }
      var cur = s.current && typeof s.current === 'object' && Number(s.current.number) >= 1 ? s.current : null;
      var dn = s.dailyNow && typeof s.dailyNow === 'object' && s.dailyNow.date === today ? s.dailyNow : null;
      var sc = ws.current && typeof ws.current === 'object' && Number(ws.current.level) >= 1 ? ws.current : null;
      if (!(done || days || stars || cur || dn || sc)) return null;
      var line = cur ? 'Level ' + Math.min(300, Math.floor(Number(cur.number))) : dn ? 'Daily wheel' : sc ? 'Word Search · Level ' + Math.floor(Number(sc.level))
        : streak > 1 ? 'Daily streak ' + fmt(streak) : done ? 'Level ' + nextLevel(s.levels, 300)
        : stars > 0 ? 'Word Search · ' + fmt(stars) + ' ★' : plural(days, 'daily wheel', 'daily wheels');
      return { line: line, live: !!(cur || dn || sc), weight: done + days + stars };
    },
    // games/crazyeights/src/save.ts: stats (rounds, matches, best round, streak), the daily challenges won, the match being
    // played (current.m: the engine's Match; the game's Continue carries it on, so "in progress" is true while m.winner is null).
    crazyeights: function () {
      var s = read('allfun.crazyeights.v1');
      if (!s) return null;
      var st = s.stats || {}, m = s.current && s.current.m;
      var live = !!(m && m.winner == null && m.round && Number(s.v) >= 2);
      if (!(st.roundsPlayed > 0 || st.matchesPlayed > 0 || live || count(s.daily))) return null;
      var line = live ? (m.daily ? 'Daily challenge' : 'Round ' + (Number(m.roundNo) || 1) + ' · vs ' + Math.max(1, (Number(m.players) || 2) - 1))
        : st.matchesWon > 0 ? 'Wins ' + fmt(st.matchesWon) + (st.bestRound > 0 ? ' · best ' + fmt(st.bestRound) : '') : count(s.daily) ? 'Daily challenge'
        : plural(st.roundsPlayed || 0, 'round', 'rounds') + ' played';
      return { line: line, live: live, weight: (st.roundsPlayed || 0) + (st.matchesWon || 0) };
    }
  };

  function progress() {
    var seen = (read(HOME_KEY) || {}).opened || {};
    var list = [];
    SLUGS.forEach(function (slug) {
      var r = null;
      try { r = READERS[slug](); } catch (e) { r = null; }
      if (!r) return;
      r.slug = slug;
      r.at = Math.max(Number(seen[slug]) || 0, r.at || 0);
      list.push(r);
    });
    // Most recent first (opened from this site, or the last coin change in Backgammon), then
    // games with something in progress, then by how much has been played.
    list.sort(function (x, y) {
      return (y.at - x.at) || ((y.live ? 1 : 0) - (x.live ? 1 : 0)) || (y.weight - x.weight);
    });
    return list;
  }

  // The picture at the start of a row in the Continue and Favorites sheets. The home page passes its own
  // (small copies of the games' animated logos, AllFun.setArt); elsewhere it is the game's app icon from
  // the footer, on the game's own colours.
  var art = function (r) {
    var svg = document.querySelector('.ft-chip.fg-' + r.slug + ' .ft-ic svg');
    return svg ? '<span class="cc-fic">' + svg.outerHTML + '</span>' : '';
  };

  // ---- hiding games from Continue ---------------------------------------------------------------
  // allfun.home.v1 = { opened: { slug: time }, hidden: { slug: { at: time, fp: 'length:hash' } },
  //                    favs: [slug, …] (Favorites, in the order they were added) }.
  // "Remove" only adds the game to `hidden`; its own save is never touched. The fingerprint is taken
  // from the game's save keys when it is hidden: once the game saves anything new (it was played
  // again), the fingerprint differs and the game comes back by itself.
  var SAVE_KEYS = {
    backgammon: ['bg.profile.v1', 'bg.wallet.v1', 'bg.matchSave.v1'], blocks: ['allfun.blocks.v1'], sort: ['allfun.sort.v1'],
    merge: ['allfun.merge.v1'], gems: ['allfun.gems.v1'], bubbles: ['allfun.bubbles.v1'], domino: ['allfun.domino.v1'],
    solitaire: ['allfun.solitaire.v1'], mines: ['allfun.mines.v1'], sudoku: ['allfun.sudoku.v1'], checkers: ['allfun.checkers.v1'],
    airhockey: ['allfun.airhockey.v1'], fishing: ['allfun.fishing.v1'], tabletennis: ['allfun.tabletennis.v1'],
    pinball: ['allfun.pinball.v1'], hearts: ['allfun.hearts.v1'], spider: ['allfun.spider.v1'],
    freecell: ['allfun.freecell.v1'], spades: ['allfun.spades.v1'], tripeaks: ['allfun.tripeaks.v1'], bricks: ['allfun.bricks.v1'],
    snake: ['allfun.snake.v1'], chess: ['allfun.chess.v1'], fourinarow: ['allfun.fourinarow.v1'], ginrummy: ['allfun.ginrummy.v1'],
    pyramid: ['allfun.pyramid.v1'], racing: ['allfun.racing.v1'], basketball: ['allfun.basketball.v1'], darts: ['allfun.darts.v1'],
    flags: ['allfun.flags.v1'], suitcase: ['allfun.suitcase.v1'], chefpath: ['allfun.chefpath.v1'], chefdeck: ['allfun.chefdeck.v1'],
    runner: ['allfun.runner.v1'],
    trivia: ['allfun.trivia.v1'],
    tiles: ['allfun.tiles.v1'],
    ludo: ['allfun.ludo.v1'],
    billiards: ['allfun.billiards.v1'],
    bolts: ['allfun.bolts.v1'],
    golf: ['allfun.golf.v1'],
    dice: ['allfun.dice.v1'],
    royale: ['allfun.royale.v1'],
    lasso: ['allfun.lasso.v1'],
    claw: ['allfun.claw.v1'],
    crossword: ['allfun.crossword.v1'],
    memory: ['allfun.memory.v1'],
    cinderpoint: ['allfun.cinderpoint.v1'],
    bingo: ['allfun.bingo.v1'],
    fizzwell: ['allfun.fizzwell.v1'],
    motorush: ['allfun.motorush.v1'],
    strikedistrict: ['allfun.strikedistrict.v1'],
    skyshot: ['allfun.skyshot.v1'],
    wordwheel: ['allfun.wordwheel.v1'],
    crazyeights: ['allfun.crazyeights.v1']
  };
  var memory = read(HOME_KEY) || {}; // kept in memory too, so hiding works for this visit even when storage is blocked
  function updateMemory(change) {
    var m = read(HOME_KEY) || memory;
    change(m);
    memory = m;
    write(HOME_KEY, m);
  }
  function rawSave(key) { try { return window.localStorage.getItem(key) || ''; } catch (e) { return ''; } }
  function fingerprint(slug) {
    var s = SAVE_KEYS[slug].map(rawSave).join('\u0001');
    var h = 0x811c9dc5;
    for (var i = 0; i < s.length; i += 1) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0; }
    return s.length + ':' + h.toString(36);
  }
  function visibleProgress() {
    var hidden = memory.hidden || {};
    var back = [];
    var list = progress().filter(function (r) {
      var h = hidden[r.slug];
      if (!h) return true;
      if (h.fp !== fingerprint(r.slug)) { back.push(r.slug); return true; } // played again since: show it again
      return false;
    });
    if (back.length) updateMemory(function (m) { back.forEach(function (slug) { if (m.hidden) delete m.hidden[slug]; }); });
    return list;
  }
  function hideGames(slugs) {
    updateMemory(function (m) {
      m.hidden = m.hidden || {};
      slugs.forEach(function (slug) { m.hidden[slug] = { at: Date.now(), fp: fingerprint(slug) }; });
    });
  }
  function unhideGames(slugs) {
    updateMemory(function (m) { slugs.forEach(function (slug) { if (m.hidden) delete m.hidden[slug]; }); });
  }

  var played = visibleProgress();

  function statusHTML(r) {
    return esc(r.line) + (r.coins != null ? ' <span class="coins af-coins">' + fmt(r.coins) + '</span>' : '');
  }

  // Everything that shows the list: the page's own (the home page's "Continue playing" row, through a
  // hook), the dock, the menu.
  function renderContinue() {
    hook('continueRendered', played);
    var n = played.length;
    var label = n ? 'Continue: ' + plural(n, 'paused game', 'paused games') : '';
    // The dock's third slot: the list when there is one, Backgammon on a first visit (or an emptied list).
    var dockCont = document.querySelector('.dock-cont');
    if (dockCont) {
      var badge = dockCont.querySelector('.dock-n');
      dockCont.classList.toggle('has-paused', !!n);
      dockCont.querySelector('.dock-cont-label').textContent = n ? 'Continue' : 'Backgammon';
      if (n) { dockCont.setAttribute('aria-label', label); dockCont.setAttribute('aria-haspopup', 'dialog'); }
      else { dockCont.setAttribute('aria-label', 'Play AllFun Backgammon'); dockCont.removeAttribute('aria-haspopup'); }
      badge.hidden = !n;
      badge.textContent = n > 9 ? '9+' : n;
    }
    var mc = document.querySelector('.m-cont');
    if (mc) {
      mc.hidden = !n;
      mc.parentNode.classList.toggle('no-cont', !n); // Sign in takes the whole row
      mc.querySelector('.m-cont-sub').textContent = n ? plural(n, 'game', 'games') + ' paused' : '';
      mc.querySelector('.m-cont-art').innerHTML = played.slice(0, 3).map(function (r, i) {
        var chip = document.querySelector('.ft-chip.fg-' + r.slug + ' .ft-ic');
        return chip ? '<span class="ft-ic fg-' + r.slug + '" style="--k:' + i + '">' + chip.innerHTML + '</span>' : '';
      }).join('');
      mc.setAttribute('aria-label', label || 'Continue playing');
    }
  }

  // ---- the menu's Daily tile: is something still waiting today? ---------------------------------
  // (the Solitaire deal not solved, or the Backgammon bonus not collected)
  (function menuDaily() {
    var today = dateKey(new Date());
    var sol = read('allfun.solitaire.v1');
    var st = read('bg.dailies.v1');
    var hasBg = !!(read('bg.profile.v1') || read('bg.wallet.v1'));
    var solDone = !!(sol && sol.daily && today in sol.daily);
    var bgWaiting = !!((st || hasBg) && (!st || st.lastClaim !== today));
    var mDaily = document.querySelector('.mi-daily');
    if (mDaily) {
      mDaily.classList.toggle('waiting', !solDone || bgWaiting);
      document.getElementById('m-daily-sub').textContent = !solDone ? 'Deal waiting' : bgWaiting ? 'Bonus waiting' : 'Done for today';
    }
  })();

  // ---- favorites -------------------------------------------------------------------------------
  // A heart on every game tile and the Game of the day on the home page (the menu's Favorites card counts
  // them). Stored in allfun.home.v1 → favs, in the order they were added. A heart is a button beside the
  // link (never inside it), so tapping it can never open the game.
  function getFavs() {
    var seen = {};
    return (Array.isArray(memory.favs) ? memory.favs : []).filter(function (s) {
      if (!GAMES[s] || seen[s]) return false;
      seen[s] = true;
      return true;
    });
  }
  var favs = getFavs();
  function saveFavs(list) {
    favs = list.slice();
    updateMemory(function (m) { m.favs = favs.slice(); });
  }
  var heartInner = function () {
    var p = '';
    for (var i = 0; i < 7; i += 1) p += '<i class="fav-p" style="--a:' + Math.round(i * 360 / 7 - 10) + 'deg"></i>';
    return '<span class="fav-in" aria-hidden="true"><i class="fav-ring"></i>' + p +
      '<svg class="fav-o" viewBox="0 0 24 24"><use href="#i-heart"/></svg>' +
      '<svg class="fav-f" viewBox="0 0 24 24"><use href="#i-heart"/><ellipse cx="8.3" cy="8.6" rx="2.4" ry="1.35" transform="rotate(-40 8.3 8.6)"/></svg></span>';
  };
  function favBtnHTML(slug, cls) {
    return '<button class="fav ' + cls + '" type="button" data-slug="' + slug + '" aria-pressed="false" aria-label="Favorite ' + esc(GAMES[slug].full) + '">' + heartInner() + '</button>';
  }
  function burst(btn, on) {
    btn.classList.remove('burst', 'unburst');
    void btn.offsetWidth; // replay
    btn.classList.add(on ? 'burst' : 'unburst');
    clearTimeout(btn._bt);
    btn._bt = setTimeout(function () { btn.classList.remove('burst', 'unburst'); }, 800);
  }
  var live = document.getElementById('fav-live');
  function announce(text) {
    if (!live) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 40);
  }

  var dockFav = document.querySelector('.dock-fav');
  var dockFavN = dockFav && dockFav.querySelector('.dock-fn');
  function renderFavs() {
    document.querySelectorAll('.fav[data-slug]').forEach(function (b) {
      b.setAttribute('aria-pressed', favs.indexOf(b.dataset.slug) >= 0 ? 'true' : 'false');
    });
    var n = favs.length;
    hook('favsRendered', n);
    var mFav = document.querySelector('.mc-fav');
    if (mFav) {
      mFav.querySelector('.mc-n').textContent = n ? plural(n, 'game', 'games') : 'None yet';
      mFav.setAttribute('aria-label', 'Favorites: ' + (n ? plural(n, 'game', 'games') : 'none yet'));
    }
    if (dockFav) {
      dockFav.classList.toggle('has-favs', !!n);
      dockFav.setAttribute('aria-label', n ? 'Favorites: ' + plural(n, 'game', 'games') : 'Favorites');
      dockFavN.hidden = !n;
      dockFavN.textContent = n > 9 ? '9+' : n;
    }
  }
  function bump(el) {
    if (!el || reduce) return;
    el.classList.remove('bump');
    void el.offsetWidth;
    el.classList.add('bump');
  }
  function toggleFav(slug, btn) {
    var on = favs.indexOf(slug) < 0;
    var list = favs.filter(function (s) { return s !== slug; });
    if (on) list.push(slug);
    saveFavs(list);
    renderFavs();
    if (btn) burst(btn, on);
    bump(dockFavN); hook('favsBumped');
    announce(GAMES[slug].name + (on ? ' added to Favorites' : ' removed from Favorites'));
    hook('favToggled', slug, on, btn);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.fav[data-slug]');
    if (!b) return;
    e.preventDefault();
    toggleFav(b.dataset.slug, b);
  });

  // ---- remember which game was opened from here (for the order of Continue) ----------------------
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a) return;
    var m = /^\/([a-z]+)\/$/.exec(a.getAttribute('href') || '');
    if (!m || !GAMES[m[1]]) return;
    updateMemory(function (mem) {
      mem.opened = mem.opened || {};
      mem.opened[m[1]] = Date.now();
    });
  });

  // ---- phone menu: the home grid's categories, each with its count (owner, 17.10: instead of every game) ------
  // A card opens the games with that filter on: on the home page it closes the menu, shows the filter and scrolls to the
  // games (home.js, hook showCategory); elsewhere it goes to /?cat=…#library and the home page applies it as it opens.
  var CATS = [
    ['all', 'All games', '<rect x="3.5" y="3.5" width="7.5" height="7.5" rx="2.2"/><rect x="13" y="3.5" width="7.5" height="7.5" rx="2.2"/><rect x="3.5" y="13" width="7.5" height="7.5" rx="2.2"/><circle cx="16.75" cy="16.75" r="3.9"/>'],
    ['fav', 'Favorites', '<path class="f" d="M12 20.1l-1.2-1.1C6.5 15.1 3.7 12.6 3.7 9.4 3.7 6.9 5.7 4.9 8.2 4.9c1.4 0 2.8.7 3.8 1.7 1-1 2.4-1.7 3.8-1.7 2.5 0 4.5 2 4.5 4.5 0 3.2-2.8 5.7-7.1 9.6z"/>'],
    ['arcade', 'Arcade', '<path d="M7.6 8.2h8.8a4.6 4.6 0 0 1 4.4 5.9l-.9 3.1a2.3 2.3 0 0 1-3.9.9l-1.9-2.1H9.9L8 18.1a2.3 2.3 0 0 1-3.9-.9l-.9-3.1a4.6 4.6 0 0 1 4.4-5.9z"/><path d="M8 10.9v3.2M6.4 12.5h3.2"/><circle class="f" cx="15.6" cy="11.5" r=".95"/><circle class="f" cx="17.5" cy="13.5" r=".95"/>'],
    ['puzzle', 'Puzzle', '<path d="M5 7.6h3.4a2.4 2.4 0 1 1 4.6 0h3.4V11a2.4 2.4 0 1 1 0 4.6v3.6H13a2.4 2.4 0 1 0-4.6 0H5v-3.6a2.4 2.4 0 1 0 0-4.6z"/>'],
    ['board', 'Board', '<circle cx="12" cy="6.4" r="2.7"/><path d="M9.6 10.3h4.8M10.3 10.3l-1.3 6.2h6l-1.3-6.2"/><path d="M6.8 19.6h10.4a.1.1 0 0 0 0-3.1H6.8a.1.1 0 0 0 0 3.1z"/>'],
    ['cards', 'Cards', '<rect x="3.6" y="6.4" width="9.6" height="13" rx="2" transform="rotate(-12 8.4 12.9)"/><rect x="10.6" y="4.6" width="9.6" height="13" rx="2" transform="rotate(9 15.4 11.1)"/><path class="f" d="M15.3 8.6c.9-1 2.4-.4 2.2.9-.1.8-1.2 1.6-2.3 2.4-.9-1-1.8-2-1.6-2.8.3-1.2 1.8-1.3 1.7-.5z"/>'],
    ['sport', 'Sport', '<circle cx="12" cy="12" r="8.4"/><path d="M3.6 12h16.8M12 3.6v16.8M6 6.1c2.9 3.1 2.9 8.7 0 11.8M18 6.1c-2.9 3.1-2.9 8.7 0 11.8"/>']
  ];
  function catCount(f) {
    if (f === 'all') return SLUGS.length;
    return SLUGS.filter(function (s) { return (' ' + (CATEGORY[s] || '') + ' ').indexOf(' ' + f + ' ') >= 0; }).length;
  }
  // Every number of games on a page comes from GAMES and CATEGORY above (22.10: the home said "Forty-four", its grid
  // 42 and the footer 43): [data-cat-n] is a filter's count ("all": every game), [data-cat-games] the same as "N games",
  // [data-games-n] starts with the number in words ("Forty-four, all free"). scripts/build-site.mjs writes the same
  // numbers into the built pages (and the meta descriptions), so they are right before this runs too.
  function gamesInWords(n) {
    var ones = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve',
      'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
    var tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];
    var w = n < 20 ? ones[n] : n < 100 ? tens[Math.floor(n / 10)] + (n % 10 ? '-' + ones[n % 10] : '') : String(n);
    return w.charAt(0).toUpperCase() + w.slice(1);
  }
  document.querySelectorAll('[data-cat-n]').forEach(function (n) {
    var t = String(catCount(n.getAttribute('data-cat-n')));
    if (n.textContent !== t) n.textContent = t;
  });
  document.querySelectorAll('[data-cat-games]').forEach(function (n) {
    var t = plural(catCount(n.getAttribute('data-cat-games')), 'game', 'games');
    if (n.textContent !== t) n.textContent = t;
  });
  document.querySelectorAll('[data-games-n]').forEach(function (n) {
    var t = n.textContent.replace(/^[A-Z][a-z]+(?:-[a-z]+)?/, gamesInWords(SLUGS.length));
    if (n.textContent !== t) n.textContent = t;
  });
  var catBox = document.querySelector('.m-cats');
  if (catBox) {
    catBox.innerHTML = CATS.map(function (c, i) {
      // Off the home page a category opens its own page (SEO, owner 31.10); All games and Favorites open the home grid.
      var page = { arcade: '/arcade-games/', puzzle: '/puzzle-games/', board: '/board-games/', cards: '/card-games/', sport: '/sports-games/' }[c[0]];
      var href = onHome ? '#library' : page || (c[0] === 'all' ? '/#library' : '/?cat=' + c[0] + '#library');
      var n = c[0] === 'fav' ? '' : plural(catCount(c[0]), 'game', 'games');
      return '<a class="m-cat mc-' + c[0] + '" href="' + href + '" data-filter="' + c[0] + '" style="--j:' + i + '"' + (n ? ' aria-label="' + c[1] + ': ' + n + '"' : '') + '>' +
        '<span class="mc-ic" aria-hidden="true"><svg viewBox="0 0 24 24">' + c[2] + '</svg></span>' +
        '<span class="mc-tx"><b class="mc-t">' + c[1] + '</b><span class="mc-n">' + n + '</span></span></a>';
    }).join('');
    if (onHome) {
      catBox.addEventListener('click', function (e) {
        var a = e.target.closest('.m-cat');
        if (!a) return;
        e.preventDefault();
        closeMenu();
        hook('showCategory', a.dataset.filter);
      });
    }
  }
  renderContinue();
  renderFavs();

  // ---- social links (menu and footer), from SOCIAL at the top ------------------------------------
  var SOC = {
    facebook: { name: 'Facebook', svg: '<path d="M13.4 21v-7.6h2.6l.4-3h-3V8.6c0-.9.27-1.5 1.55-1.5h1.6V4.4c-.28-.04-1.23-.12-2.33-.12-2.3 0-3.88 1.4-3.88 3.98v2.14H7.7v3h2.64V21z"/>' },
    instagram: { name: 'Instagram', svg: '<rect x="3.9" y="3.9" width="16.2" height="16.2" rx="4.8" fill="none" stroke="currentColor" stroke-width="1.9"/><circle cx="12" cy="12" r="3.85" fill="none" stroke="currentColor" stroke-width="1.9"/><circle cx="16.85" cy="7.15" r="1.15"/>' },
    tiktok: { name: 'TikTok', svg: '<path d="M15.7 3.2c.3 2.3 1.7 3.8 4 4v2.8c-1.5.02-2.82-.43-4-1.2v6a5.55 5.55 0 1 1-5.55-5.55c.3 0 .6.02.9.07v2.9a2.7 2.7 0 1 0 1.9 2.58V3.2z"/>' },
    youtube: { name: 'YouTube', svg: '<path fill-rule="evenodd" d="M21.3 7.7a2.6 2.6 0 0 0-1.84-1.84C17.84 5.4 12 5.4 12 5.4s-5.84 0-7.46.46A2.6 2.6 0 0 0 2.7 7.7C2.25 9.33 2.25 12 2.25 12s0 2.67.45 4.3a2.6 2.6 0 0 0 1.84 1.84c1.62.46 7.46.46 7.46.46s5.84 0 7.46-.46a2.6 2.6 0 0 0 1.84-1.84c.45-1.63.45-4.3.45-4.3s0-2.67-.45-4.3zM10 15.05V8.95L15.2 12z"/>' },
    x: { name: 'X', svg: '<path d="M17.55 3.6h2.95l-6.45 7.37 7.59 10.03h-5.94l-4.65-6.08-5.32 6.08H2.78l6.9-7.88L2.4 3.6h6.09l4.2 5.56zm-1.04 15.63h1.64L7.59 5.27H5.84z"/>' }
  };
  function renderSocial(box) {
    var linked = Object.keys(SOC).filter(function (k) { return /^https?:\/\//.test(SOCIAL[k] || ''); });
    box.hidden = !linked.length;
    box.innerHTML = !linked.length ? '' : '<p class="soc-h"><span>Follow us</span></p><ul class="soc-list">' + linked.map(function (k) {
      return '<li><a class="soc-btn s-' + k + '" href="' + esc(SOCIAL[k]) + '" target="_blank" rel="noopener" aria-label="AllFun Games on ' + SOC[k].name +
        ' (opens in a new tab)"><svg viewBox="0 0 24 24" aria-hidden="true">' + SOC[k].svg + '</svg></a></li>';
    }).join('') + '</ul>';
  }
  document.querySelectorAll('[data-social]').forEach(renderSocial);

  var toggle = document.querySelector('.nav-toggle');
  function closeMenu() { if (toggle && toggle.getAttribute('aria-expanded') === 'true') toggle.click(); } // site.js owns the menu

  // ---- the Continue list: a bottom sheet on a phone, a dialog on a computer ----------------------
  var pop = document.getElementById('cont-pop');
  var panel = pop.querySelector('.cp-panel');
  var listEl = pop.querySelector('.cp-list');
  var emptyEl = pop.querySelector('.cp-empty');
  var footEl = pop.querySelector('.cp-ft');
  var subEl = pop.querySelector('.cp-sub');
  var confirmEl = pop.querySelector('.cp-confirm');
  var clearBtn = pop.querySelector('.cp-clear');
  var toast = pop.querySelector('.cp-toast');
  var actsEl = pop.querySelector('.cp-acts');
  var undoBtn = pop.querySelector('.cp-undo');
  var returnTo = null, closeTimer = 0, toastTimer = 0, undoSlugs = null;
  var sheetMQ = window.matchMedia('(max-width: 760px)');

  function rowHTML(r, i) {
    var g = GAMES[r.slug];
    var live = r.live ? '<span class="live">In progress</span>' : '';
    return '<li class="cp-row t-' + r.slug + '" data-slug="' + r.slug + '" style="--k:' + i + '">' +
      '<a class="cp-main" href="/' + r.slug + '/" aria-label="Play ' + esc(g.full) + ', ' + esc(r.line) + (r.live ? ', in progress' : '') + '">' +
        '<span class="cc-ic cp-ic" aria-hidden="true">' + art(r) + '</span>' +
        '<span class="cp-tx"><b>' + esc(g.name) + '</b><span class="cp-st"><span>' + statusHTML(r) + '</span>' + live + '</span></span>' +
        '<span class="cp-play" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M8 5.5v13l10.5-6.5z"/></svg>Play</span>' +
      '</a>' +
      '<button class="cp-rm" type="button" aria-label="Remove ' + esc(g.name) + ' from Continue"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 7l10 10M17 7L7 17"/></svg></button>' +
    '</li>';
  }
  function renderHead() {
    var n = played.length;
    subEl.textContent = n ? plural(n, 'game', 'games') + ' paused on this device' : '';
    subEl.hidden = !n;
    emptyEl.hidden = !!n;
    listEl.hidden = !n;
    actsEl.hidden = !n;
    footEl.hidden = !n && !footEl.classList.contains('toasting');
    confirmEl.hidden = true;
    footEl.classList.remove('confirming');
    clearBtn.hidden = false;
  }
  function renderList() {
    listEl.innerHTML = played.map(rowHTML).join('');
    renderHead();
  }
  function focusables() {
    return Array.prototype.filter.call(panel.querySelectorAll('a[href], button:not([disabled])'), function (el) {
      return el.tabIndex >= 0 && el.offsetParent !== null && !el.closest('[hidden]');
    });
  }
  function openPop(from) {
    clearTimeout(closeTimer);
    returnTo = from || document.activeElement;
    played = visibleProgress();
    renderContinue();
    renderList();
    hideToast();
    pop.hidden = false;
    pop.classList.toggle('sheet', sheetMQ.matches);
    void pop.offsetWidth; // start the entrance from the closed state
    pop.classList.add('open');
    document.body.classList.add('cp-open');
    panel.style.transform = '';
    panel.focus({ preventScroll: true });
    dockSet('cont');
  }
  function closePop() {
    if (pop.hidden || !pop.classList.contains('open')) return;
    pop.classList.remove('open');
    document.body.classList.remove('cp-open');
    panel.style.transform = '';
    closeTimer = setTimeout(function () { pop.hidden = true; hideToast(); }, reduce ? 0 : 340);
    var back = returnTo;
    if (!back || !document.contains(back) || back.offsetParent === null || back.closest('[hidden]')) back = document.querySelector('.dock-cont') || toggle;
    if (back && back.offsetParent !== null) back.focus({ preventScroll: true });
    spy(true);
  }
  function showToast(text, slugs) {
    clearTimeout(toastTimer);
    undoSlugs = slugs;
    toast.querySelector('.cp-toast-tx').textContent = text;
    footEl.classList.remove('toasting');
    void footEl.offsetWidth; // replay the entrance for a second removal
    footEl.classList.add('toasting');
    footEl.hidden = false;
    undoBtn.tabIndex = 0;
    toastTimer = setTimeout(function () { hideToast(); }, 6000);
  }
  function hideToast() {
    clearTimeout(toastTimer);
    if (document.activeElement === undoBtn) panel.focus({ preventScroll: true });
    footEl.classList.remove('toasting');
    if (!played.length) footEl.hidden = true;
    undoBtn.tabIndex = -1;
    undoSlugs = null;
  }
  // A row slides out, then the gap closes.
  function animateOut(li, delay) {
    return new Promise(function (done) {
      if (reduce || !li.animate) { done(); return; }
      var h = li.getBoundingClientRect().height;
      var a = li.animate([{ opacity: 1, transform: 'none' }, { opacity: 0, transform: 'translateX(56px) scale(.97)' }],
        { duration: 220, delay: delay || 0, easing: 'cubic-bezier(.5, 0, .75, 0)', fill: 'forwards' });
      a.onfinish = function () {
        li.style.overflow = 'hidden';
        var b = li.animate([{ height: h + 'px', marginBottom: '8px' }, { height: '0px', marginBottom: '0px' }],
          { duration: 240, easing: 'cubic-bezier(.22, .72, .18, 1)', fill: 'forwards' });
        b.onfinish = done;
      };
    });
  }
  function afterChange() {
    played = visibleProgress();
    renderContinue();
    renderHead();
    if (!played.length) {
      emptyEl.classList.remove('in');
      void emptyEl.offsetWidth;
      emptyEl.classList.add('in');
    }
  }
  function removeOne(li) {
    var slug = li.dataset.slug;
    var rows = Array.prototype.slice.call(listEl.children);
    var i = rows.indexOf(li);
    var next = rows[i + 1] || rows[i - 1];
    hideGames([slug]);
    li.classList.add('leaving');
    li.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = -1; });
    if (next) next.querySelector('.cp-rm').focus({ preventScroll: true });
    showToast(GAMES[slug].name + ' removed', [slug]);
    animateOut(li).then(function () {
      li.remove();
      afterChange();
      if (!played.length) (emptyEl.querySelector('.cp-browse')).focus({ preventScroll: true });
    });
  }
  function clearAll() {
    var slugs = played.map(function (r) { return r.slug; });
    hideGames(slugs);
    confirmEl.hidden = true;
    footEl.classList.remove('confirming');
    var rows = Array.prototype.slice.call(listEl.children);
    rows.forEach(function (li) { li.classList.add('leaving'); });
    showToast(plural(slugs.length, 'game', 'games') + ' removed', slugs);
    Promise.all(rows.map(function (li, i) { return animateOut(li, i * 50); })).then(function () {
      listEl.innerHTML = '';
      afterChange();
      emptyEl.querySelector('.cp-browse').focus({ preventScroll: true });
    });
  }

  pop.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-close]')) { closePop(); return; }
    var rm = t.closest('.cp-rm');
    if (rm) { var li = rm.closest('.cp-row'); if (li && !li.classList.contains('leaving')) removeOne(li); return; }
    if (t.closest('.cp-clear')) {
      clearBtn.hidden = true;
      confirmEl.querySelector('.cp-confirm-q').textContent = 'Remove ' + (played.length === 1 ? 'it' : played.length === 2 ? 'both' : 'all ' + played.length) + '?';
      confirmEl.hidden = false;
      footEl.classList.add('confirming');
      confirmEl.querySelector('.cp-no').focus();
      return;
    }
    if (t.closest('.cp-no')) { confirmEl.hidden = true; footEl.classList.remove('confirming'); clearBtn.hidden = false; clearBtn.focus(); return; }
    if (t.closest('.cp-yes')) { clearAll(); return; }
    if (t.closest('.cp-undo')) {
      if (undoSlugs) unhideGames(undoSlugs);
      hideToast();
      played = visibleProgress();
      renderContinue();
      renderList();
      var first = listEl.querySelector('.cp-main');
      if (first) first.focus({ preventScroll: true });
      return;
    }
    if (t.closest('.cp-browse')) { closePop(); return; } // the link scrolls to the games
    if (t.closest('.cp-main')) { closePop(); } // the game opens (the page-wide listener remembers it)
  });
  pop.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { e.preventDefault(); closePop(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) { e.preventDefault(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  sheetMQ.addEventListener && sheetMQ.addEventListener('change', function () { pop.classList.toggle('sheet', sheetMQ.matches); });

  // Phone: drag the sheet down by its top to close it.
  (function dragToClose() {
    var startY = 0, dy = 0, t0 = 0, dragging = false;
    var grab = pop.querySelectorAll('.cp-grab, .cp-hd');
    function down(e) {
      if (!pop.classList.contains('sheet') || e.target.closest('button')) return;
      dragging = true; startY = e.clientY; dy = 0; t0 = Date.now();
      panel.classList.add('dragging');
      e.currentTarget.setPointerCapture && e.currentTarget.setPointerCapture(e.pointerId);
    }
    function move(e) {
      if (!dragging) return;
      dy = Math.max(0, e.clientY - startY);
      panel.style.transform = 'translate3d(0,' + dy + 'px,0)';
    }
    function up() {
      if (!dragging) return;
      dragging = false;
      panel.classList.remove('dragging');
      var fast = dy / Math.max(1, Date.now() - t0) > 0.6;
      if (dy > 110 || (fast && dy > 30)) closePop(); else panel.style.transform = '';
    }
    grab.forEach(function (g) {
      g.addEventListener('pointerdown', down);
      g.addEventListener('pointermove', move);
      g.addEventListener('pointerup', up);
      g.addEventListener('pointercancel', up);
    });
  })();

  // The ways in: the dock, the menu's Continue (and on the home page, the row's Edit).
  var menuCont = document.querySelector('.m-cont');
  if (menuCont) menuCont.addEventListener('click', function () { closeMenu(); openPop(toggle); });

  // ---- more sheets, built like Continue: Favorites and Sign in ----------------------------------
  // A bottom sheet on a phone (drag it down by the top to close), a dialog on a computer; the focus
  // stays inside while it is open, Escape or the scrim closes it, and focus goes back where it was.
  function shown(el) { return !!el && document.contains(el) && el.offsetParent !== null && !el.closest('[hidden]'); }
  function makeSheet(root, opt) {
    var panel = root.querySelector('.cp-panel');
    var from = null, timer = 0;
    function isOpen() { return !root.hidden && root.classList.contains('open'); }
    function open(src) {
      clearTimeout(timer);
      from = src || document.activeElement;
      if (opt.render) opt.render();
      root.hidden = false;
      root.classList.toggle('sheet', sheetMQ.matches);
      void root.offsetWidth;
      root.classList.add('open');
      document.body.classList.add('cp-open');
      panel.style.transform = '';
      panel.scrollTop = 0;
      panel.focus({ preventScroll: true });
      if (opt.dock) dockSet(opt.dock);
    }
    function close() {
      if (!isOpen()) return;
      root.classList.remove('open');
      document.body.classList.remove('cp-open');
      panel.style.transform = '';
      timer = setTimeout(function () { root.hidden = true; if (opt.closed) opt.closed(); }, reduce ? 0 : 340);
      var back = shown(from) ? from : opt.fallback && opt.fallback();
      if (shown(back)) back.focus({ preventScroll: true });
      spy(true);
    }
    root.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) close(); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled])'), function (el) {
        return el.tabIndex >= 0 && el.offsetParent !== null && !el.closest('[hidden]');
      });
      if (!f.length) { e.preventDefault(); return; }
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    sheetMQ.addEventListener && sheetMQ.addEventListener('change', function () { root.classList.toggle('sheet', sheetMQ.matches); });
    var y0 = 0, dy = 0, t0 = 0, dragging = false;
    root.querySelectorAll(opt.grab || '.cp-grab, .cp-hd').forEach(function (g) {
      g.addEventListener('pointerdown', function (e) {
        if (!root.classList.contains('sheet') || e.target.closest('button, a')) return;
        dragging = true; y0 = e.clientY; dy = 0; t0 = Date.now();
        panel.classList.add('dragging');
        g.setPointerCapture && g.setPointerCapture(e.pointerId);
      });
      g.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        dy = Math.max(0, e.clientY - y0);
        panel.style.transform = 'translate3d(0,' + dy + 'px,0)';
      });
      var up = function () {
        if (!dragging) return;
        dragging = false;
        panel.classList.remove('dragging');
        if (dy > 110 || (dy / Math.max(1, Date.now() - t0) > 0.6 && dy > 30)) close(); else panel.style.transform = '';
      };
      g.addEventListener('pointerup', up);
      g.addEventListener('pointercancel', up);
    });
    return { open: open, close: close, isOpen: isOpen, panel: panel };
  }

  // Favorites: big rows with Play, and a filled heart that takes the game off the list (with Undo).
  var fvRoot = document.getElementById('fav-pop');
  var fvList = fvRoot.querySelector('.fv-list');
  var fvEmpty = fvRoot.querySelector('.fv-empty');
  var fvFoot = fvRoot.querySelector('.fv-ft');
  var fvSub = fvRoot.querySelector('.cp-sub');
  var fvToast = fvRoot.querySelector('.cp-toast');
  var fvUndo = fvRoot.querySelector('.cp-undo');
  var fvUndoData = null, fvToastTimer = 0;
  function fvRowHTML(slug, i, prog) {
    var g = GAMES[slug], r = prog[slug];
    return '<li class="cp-row fv-row t-' + slug + '" data-slug="' + slug + '" style="--k:' + i + '">' +
      '<a class="cp-main" href="/' + slug + '/" aria-label="Play ' + esc(g.full) + (r ? ', ' + esc(r.line) : '') + '">' +
        '<span class="cc-ic cp-ic" aria-hidden="true">' + art(r || { slug: slug }) + '</span>' +
        '<span class="cp-tx"><b>' + esc(g.name) + '</b><span class="cp-st"><span>' + (r ? statusHTML(r) : esc(g.kind)) + '</span>' +
          (r && r.live ? '<span class="live">In progress</span>' : '') + '</span></span>' +
        '<span class="cp-play" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M8 5.5v13l10.5-6.5z"/></svg>Play</span>' +
      '</a>' +
      '<button class="fav fv-rm on" type="button" aria-label="Remove ' + esc(g.name) + ' from Favorites">' + heartInner() + '</button>' +
    '</li>';
  }
  function fvHead() {
    var n = favs.length;
    fvSub.textContent = n ? plural(n, 'game', 'games') + ' saved on this device' : 'Your saved games live here';
    fvEmpty.hidden = !!n;
    fvList.hidden = !n;
    fvFoot.hidden = !n && !fvFoot.classList.contains('toasting');
  }
  function fvRender() {
    var prog = {};
    progress().forEach(function (r) { prog[r.slug] = r; });
    fvList.innerHTML = favs.map(function (s, i) { return fvRowHTML(s, i, prog); }).join('');
    fvHead();
  }
  function fvHideToast() {
    clearTimeout(fvToastTimer);
    if (document.activeElement === fvUndo) fv.panel.focus({ preventScroll: true });
    fvFoot.classList.remove('toasting');
    fvUndo.tabIndex = -1;
    fvUndoData = null;
    fvHead();
  }
  function fvShowToast(text, data) {
    clearTimeout(fvToastTimer);
    fvUndoData = data;
    fvToast.querySelector('.cp-toast-tx').textContent = text;
    fvFoot.classList.remove('toasting');
    void fvFoot.offsetWidth;
    fvFoot.classList.add('toasting');
    fvFoot.hidden = false;
    fvUndo.tabIndex = 0;
    fvToastTimer = setTimeout(fvHideToast, 6000);
  }
  var fv = makeSheet(fvRoot, {
    dock: 'fav',
    render: function () { fvHideToast(); fvRender(); },
    closed: fvHideToast,
    fallback: function () { return document.querySelector('.dock-fav'); }
  });
  function afterFavChange() {
    renderFavs();
    bump(dockFavN); hook('favsBumped');
    hook('favsChanged');
  }
  fvRoot.addEventListener('click', function (e) {
    var t = e.target;
    var rm = t.closest('.fv-rm');
    if (rm) {
      var li = rm.closest('.fv-row');
      if (!li || li.classList.contains('leaving')) return;
      var slug = li.dataset.slug, at = favs.indexOf(slug);
      var rows = Array.prototype.slice.call(fvList.children);
      var next = rows[rows.indexOf(li) + 1] || rows[rows.indexOf(li) - 1];
      saveFavs(favs.filter(function (s) { return s !== slug; }));
      afterFavChange();
      rm.classList.remove('on');
      burst(rm, false);
      li.classList.add('leaving');
      li.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = -1; });
      if (next) next.querySelector('.fv-rm').focus({ preventScroll: true });
      fvShowToast(GAMES[slug].name + ' removed from Favorites', { slug: slug, at: at });
      setTimeout(function () {
        animateOut(li).then(function () {
          li.remove();
          fvHead();
          if (!favs.length) {
            fvEmpty.classList.remove('in');
            void fvEmpty.offsetWidth;
            fvEmpty.classList.add('in');
            if (!fvRoot.contains(document.activeElement) || document.activeElement === fv.panel) fvEmpty.querySelector('.fv-browse').focus({ preventScroll: true });
          }
        });
      }, reduce ? 0 : 160);
      return;
    }
    if (t.closest('.cp-undo')) {
      var d = fvUndoData;
      if (d && favs.indexOf(d.slug) < 0) {
        var list = favs.slice();
        list.splice(Math.min(d.at, list.length), 0, d.slug);
        saveFavs(list);
        afterFavChange();
      }
      fvHideToast();
      fvRender();
      var row = d && fvList.querySelector('.fv-row[data-slug="' + d.slug + '"] .cp-main');
      if (row) row.focus({ preventScroll: true });
      return;
    }
    if (t.closest('.fv-browse')) { hook('favBrowse'); fv.close(); return; } // the link scrolls to the games
    if (t.closest('.cp-main')) fv.close(); // the game opens
  });

  // ==== ACCOUNTS (18.10) ===========================================================================
  // Owner, 18.10: "it should depend on signing up" — an allfun.games account with an email and a password
  // (Google and Facebook later: their buttons say "soon"). The server: /api/auth/* and /api/sync
  // (server/src/members.ts). Signed in, this browser keeps allfun.auth.v1 = { uid, email, token, since }.
  // The account keeps the player's saves: every "allfun." key of this browser except the device-only
  // ones, as one JSON map (at most 1 MB). This page brings them in (on sign-in and on every visit) and
  // sends what changed; the games send theirs after each game (games/*/src/ads.ts, the same rules).
  // Merging is key by key: what changed here since the last sync wins, the rest comes from the account.
  // With no server (local mode, offline) nothing breaks: the progress stays on this device.
  var AUTH_KEY = 'allfun.auth.v1', SYNC_KEY = 'allfun.sync.v1';
  // allfun.wallet.v1: the shared coin wallet's cache (games/shared/wallet.ts); with an account the coins are on the server.
  var LOCAL_ONLY = [AUTH_KEY, 'allfun.sid.v1', SYNC_KEY, 'allfun.install.v1', 'allfun.wallet.v1'];
  var SAVE_CAP = 1000000;

  function auth() {
    var a = read(AUTH_KEY);
    return a && typeof a.uid === 'string' && a.uid && typeof a.token === 'string' ? a : null;
  }
  function isSignedIn() { return !!auth(); }
  function forget(key) { try { window.localStorage.removeItem(key); } catch (e) { /* blocked */ } }
  function saveHash(text) { // FNV-1a, as in ads.ts
    var h = 0x811c9dc5;
    for (var i = 0; i < text.length; i += 1) { h ^= text.charCodeAt(i); h = Math.imul(h, 0x01000193); }
    return text.length.toString(36) + '.' + (h >>> 0).toString(36);
  }
  function collectSaves() {
    var data = {};
    try {
      for (var i = 0; i < window.localStorage.length; i += 1) {
        var k = window.localStorage.key(i);
        if (!k || !/^allfun\.[A-Za-z0-9._-]{1,80}$/.test(k) || LOCAL_ONLY.indexOf(k) >= 0) continue;
        var v = window.localStorage.getItem(k);
        if (v !== null) data[k] = v;
      }
    } catch (e) { /* blocked storage */ }
    return data;
  }
  function hashAll(d) { var o = {}; Object.keys(d).forEach(function (k) { o[k] = saveHash(d[k]); }); return o; }
  function mergeSaves(here, account, hashes) {
    var out = {}, seen = {};
    Object.keys(here).concat(Object.keys(account)).forEach(function (k) {
      if (seen[k]) return; seen[k] = 1;
      var mine = k in here ? saveHash(here[k]) : null;
      var v = mine !== (hashes[k] === undefined ? null : hashes[k]) ? here[k] : account[k];
      if (v !== undefined) out[k] = v;
    });
    return out;
  }
  function sameSaves(a, b) {
    var ka = Object.keys(a), kb = Object.keys(b);
    return ka.length === kb.length && ka.every(function (k) { return b[k] === a[k]; });
  }
  function unchanged(d, hashes) {
    var ks = Object.keys(d);
    return ks.length === Object.keys(hashes).length && ks.every(function (k) { return hashes[k] === saveHash(d[k]); });
  }
  /** Makes this browser's saves exactly `next` (the device-only keys stay). */
  function applySaves(next) {
    var now = collectSaves();
    try {
      Object.keys(now).forEach(function (k) { if (!(k in next)) window.localStorage.removeItem(k); });
      Object.keys(next).forEach(function (k) { if (now[k] !== next[k]) window.localStorage.setItem(k, next[k]); });
    } catch (e) { /* blocked storage */ }
  }
  function meta() {
    var m = read(SYNC_KEY), a = auth();
    return m && a && m.uid === a.uid && typeof m.version === 'number' && m.hashes ? m : null;
  }
  function setMeta(version, data) { var a = auth(); if (a) write(SYNC_KEY, { uid: a.uid, version: version, hashes: hashAll(data), at: Date.now() }); }

  /** A call to the server: resolves { status, json } (also for errors it answers); rejects when unreachable. */
  function api(method, path, body, token) {
    if (!window.fetch || !/^https?:$/.test(location.protocol)) return Promise.reject(new Error('offline'));
    var headers = { 'content-type': 'application/json' };
    if (token) headers.authorization = 'Bearer ' + token;
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = ctl ? setTimeout(function () { ctl.abort(); }, 12000) : 0;
    return fetch('/api' + path, { method: method, headers: headers, body: body === undefined ? undefined : JSON.stringify(body), signal: ctl ? ctl.signal : undefined, credentials: 'omit', cache: 'no-store' })
      .then(function (r) {
        clearTimeout(timer);
        return r.text().then(function (t) { var j = {}; try { j = t ? JSON.parse(t) : {}; } catch (e) { j = {}; } return { status: r.status, json: j }; });
      }, function (e) { clearTimeout(timer); throw e; });
  }
  function signedOutElsewhere() { forget(AUTH_KEY); forget(SYNC_KEY); renderAccount(false); walletFollow(); }
  function putSaves(base, data, force) {
    var a = auth();
    if (!a) return Promise.reject(new Error('signed out'));
    if (JSON.stringify(data).length > SAVE_CAP) return Promise.reject(new Error('too-large'));
    return api('POST', '/sync', { base: base, data: data, force: !!force }, a.token);
  }

  var syncing = null, lastSync = 0, syncState = 'ok';
  /** Brings the account's saves in and sends this browser's changes (signed in, device already synced once). */
  function syncNow() {
    if (syncing) return syncing;
    var a = auth(), m = meta();
    if (!a || !m) return Promise.resolve(false);
    syncing = api('GET', '/sync', undefined, a.token).then(function (r) {
      if (r.status === 401) { signedOutElsewhere(); return false; }
      if (r.status !== 200) throw new Error('server');
      var server = r.json || {}, sdata = server.data || {}, sver = Number(server.version) || 0;
      var local = collectSaves();
      var merged = sver === m.version ? local : mergeSaves(local, sdata, m.hashes);
      if (sver !== m.version) { applySaves(merged); refresh(); }
      if (sameSaves(merged, sdata) && sver > 0) { setMeta(sver, merged); return true; }
      if (sver === m.version && unchanged(local, m.hashes)) return true;
      return putSaves(sver, merged).then(function (p) {
        if (p.status === 200) { setMeta(Number(p.json.version) || 0, merged); return true; }
        if (p.status === 409) { syncing = null; return syncNow(); }
        if (p.status === 401) { signedOutElsewhere(); return false; }
        throw new Error('server');
      });
    }).then(function (ok) { syncing = null; lastSync = Date.now(); syncState = ok ? 'ok' : syncState; renderSyncLine(); return ok; },
      function () { syncing = null; syncState = 'offline'; renderSyncLine(); return false; });
    return syncing;
  }

  /** A device's first sync with this account: 'done', or { ask, server, local } when both have progress. */
  function firstSync() {
    var a = auth();
    if (!a) return Promise.resolve('done');
    return api('GET', '/sync', undefined, a.token).then(function (r) {
      if (r.status === 401) { signedOutElsewhere(); throw new Error('unauthorized'); }
      if (r.status !== 200) throw new Error('server');
      var server = r.json || {}, sdata = server.data || {}, sver = Number(server.version) || 0;
      var local = collectSaves();
      var hasServer = sver > 0 && Object.keys(sdata).length > 0;
      if (!hasServer) return useDevice(local, sver);
      var progress = Object.keys(local).some(function (k) { return k !== 'allfun.home.v1'; });
      if (!progress || sameSaves(local, sdata)) { useAccount(sver, sdata); return 'done'; }
      return { ask: true, server: server, local: local };
    });
  }
  function useAccount(version, data) { applySaves(data); setMeta(version, data); refresh(); }
  function useDevice(local, version) {
    if (!Object.keys(local).length) { setMeta(version, {}); return Promise.resolve('done'); }
    return putSaves(version, local, true).then(function (p) {
      if (p.status !== 200) throw new Error(p.json && p.json.error || 'server');
      setMeta(Number(p.json.version) || 0, local);
      return 'done';
    });
  }

  // ---- the sheet: Sign up / Log in, the choice, the welcome card, the Account view ------------------
  var siRoot = document.getElementById('signin-pop');
  var siPanel = siRoot.querySelector('.si-panel');
  var views = {};
  siRoot.querySelectorAll('.si-view').forEach(function (v) { views[v.dataset.view] = v; });
  var form = siRoot.querySelector('.si-form');
  var tabs = siRoot.querySelectorAll('.si-tab');
  var tab = 'signup', siView = 'join', choice = null, backTo = null;
  var pendingView = null, resetToken = null; // a reset link (/?reset=…) waiting for its new password
  var LABEL = {
    join: ['si-title', 'si-sub'], choose: ['si-choose-title', 'si-choose-sub'], done: ['si-done-title', 'si-done-sub'], account: ['si-acct-title', 'si-acct-sub'],
    forgot: ['si-fp-title', 'si-fp-sub'], sent: ['si-sent-title', 'si-sent-sub'], reset: ['si-rs-title', 'si-rs-sub'], expired: ['si-ex-title', 'si-ex-sub'],
    code: ['si-code-title', 'si-code-sub'],
    nick: ['si-nick-title', 'si-nick-sub'], avatars: ['si-pics-title', 'si-pics-sub'], setup: ['si-setup-title', 'si-setup-sub']
  };
  var si = makeSheet(siRoot, {
    grab: '.cp-grab, .si-logo, .sa-id',
    dock: 'none',
    render: function () {
      clearNotes();
      loadConfig();
      if (pendingView) { showView(pendingView); pendingView = null; }
      else if (siView !== 'choose' && siView !== 'done') showView(isSignedIn() ? 'account' : 'join');
    },
    closed: function () {
      if (siView === 'done') showView(isSignedIn() ? 'account' : 'join');
      if (siView === 'reset' && resetToken) pendingView = 'reset'; // reopened on this page: still there
      if (siView === 'code' && codeEmail && !isSignedIn()) pendingView = 'code'; // the code is still waiting
    },
    fallback: function () { return toggle; }
  });
  // The iPhone keyboard (owner, 18.10: the sheet must fit one screen): while a field of the sheet has the
  // keyboard up, the sheet fills only the part of the screen the keyboard leaves (visualViewport), the
  // welcome steps aside (.kb in shared.css) and the field in use stays in view.
  (function keyboard() {
    var vv = window.visualViewport;
    if (!vv) return;
    var queued = false;
    function fit() {
      queued = false;
      var el = document.activeElement;
      var typing = !siRoot.hidden && !!el && siRoot.contains(el) && /^(INPUT|TEXTAREA)$/.test(el.tagName);
      var covered = window.innerHeight - vv.height;
      var on = typing && covered > 120;
      siRoot.classList.toggle('kb', on);
      siRoot.style.top = on ? Math.round(vv.offsetTop) + 'px' : '';
      siRoot.style.height = on ? Math.round(vv.height) + 'px' : '';
      siRoot.style.bottom = on ? 'auto' : '';
      if (on) {
        var box = el.closest('.si-field') || el;
        setTimeout(function () { if (box.scrollIntoView) box.scrollIntoView({ block: 'nearest' }); }, 0);
      }
    }
    function later() { if (!queued) { queued = true; requestAnimationFrame(fit); } }
    vv.addEventListener('resize', later);
    vv.addEventListener('scroll', later);
    siRoot.addEventListener('focusin', later);
    siRoot.addEventListener('focusout', function () { setTimeout(later, 60); });
  })();
  function clearNotes() {
    siRoot.querySelectorAll('.si-note, .si-err').forEach(function (n) { n.textContent = ''; n.classList.remove('in'); });
    siRoot.querySelectorAll('.si-field.bad').forEach(function (f) { f.classList.remove('bad'); });
  }
  function showView(name) {
    siView = name;
    Object.keys(views).forEach(function (k) { views[k].hidden = k !== name; });
    siPanel.setAttribute('aria-labelledby', LABEL[name][0]);
    siPanel.setAttribute('aria-describedby', LABEL[name][1]);
    siRoot.classList.toggle('si-is-join', name === 'join');
    if (name === 'account') renderAcct();
    views[name].classList.remove('in'); void views[name].offsetWidth; views[name].classList.add('in');
    siPanel.scrollTop = 0;
    var body = siRoot.querySelector('.si-body'); if (body) body.scrollTop = 0;
  }
  function note(where, text) {
    var n = where.querySelector('.si-note');
    if (!n) return;
    n.classList.remove('in'); n.textContent = ''; void n.offsetWidth; n.classList.add('in');
    setTimeout(function () { n.textContent = text; }, 30);
  }
  function fail(where, text, field) {
    var e = where.querySelector('.si-err');
    if (e) { e.textContent = text; e.classList.remove('in'); void e.offsetWidth; e.classList.add('in'); }
    if (field) { var f = field.closest('.si-field'); if (f) f.classList.add('bad'); field.focus({ preventScroll: true }); }
  }
  function busy(btn, on, text) {
    btn.disabled = on;
    btn.classList.toggle('busy', on);
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
    if (text) btn.querySelector('.si-submit-tx').textContent = text;
  }
  var NET = 'Can’t reach AllFun Games right now. Check your connection and try again.';
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v) && v.length <= 254; }

  function setTab(name, focus) {
    tab = name;
    tabs.forEach(function (t) {
      var on = t.dataset.tab === name;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus({ preventScroll: true });
    });
    siRoot.querySelector('.si-tabs').classList.toggle('login', name === 'login');
    siRoot.classList.toggle('si-login', name === 'login'); // the perks are for signing up
    form.setAttribute('aria-labelledby', name === 'login' ? 'si-tab-login' : 'si-tab-signup');
    form.password.setAttribute('autocomplete', name === 'login' ? 'current-password' : 'new-password');
    form.password.placeholder = name === 'login' ? 'Your password' : 'At least 8 characters';
    form.querySelector('.si-help-up').hidden = name === 'login';
    showForgot();
    form.querySelector('.si-submit-tx').textContent = name === 'login' ? 'Log in' : 'Sign up free';
    document.getElementById('si-title').textContent = name === 'login' ? 'Welcome back' : 'Join AllFun Games';
    document.getElementById('si-sub').textContent = name === 'login' ? 'Log in to bring your progress here.' : 'One free account for every game.';
    clearNotes();
  }
  tabs.forEach(function (t) {
    t.addEventListener('click', function () { setTab(t.dataset.tab); });
    t.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); setTab(tab === 'login' ? 'signup' : 'login', true); }
    });
  });
  // Show / hide a password.
  siRoot.addEventListener('click', function (e) {
    var eye = e.target.closest('.si-eye');
    if (!eye) return;
    var input = eye.parentNode.querySelector('input');
    var show = input.type === 'password';
    input.type = show ? 'text' : 'password';
    eye.setAttribute('aria-pressed', show ? 'true' : 'false');
    eye.setAttribute('aria-label', show ? 'Hide password' : 'Show password');
    eye.classList.toggle('on', show);
  });
  siRoot.addEventListener('input', function (e) {
    var f = e.target.closest && e.target.closest('.si-field');
    if (f) f.classList.remove('bad');
  });

  // ---- Forgot password (18.10): an email with a one-time link, when the server can send email ---------
  // GET /api/auth/config says so ({ resetByEmail }); until it answers the Log in tab shows neither line,
  // and without it (no email set up, or offline) it keeps "Forgot it? Write to support@allfun.games".
  var resetByEmail = null, cfgLoading = null;
  function loadConfig() {
    if (resetByEmail !== null || cfgLoading) return cfgLoading;
    cfgLoading = api('GET', '/auth/config').then(function (r) {
      resetByEmail = r.status === 200 && !!(r.json && r.json.resetByEmail);
      // Sign in with Google is on when the server has our client ID (GOOGLE below); otherwise "Soon", as before.
      if (r.status === 200 && r.json && typeof r.json.google === 'string' && /^[0-9]+-[a-z0-9]+\.apps\.googleusercontent\.com$/.test(r.json.google)) googleOn(r.json.google);
    }, function () { resetByEmail = false; }).then(function () { cfgLoading = null; showForgot(); });
    return cfgLoading;
  }
  function showForgot() {
    var login = tab === 'login';
    form.querySelector('.si-help-in').hidden = !login || resetByEmail !== false;
    form.querySelector('.si-forgot-row').hidden = !login || resetByEmail !== true;
  }
  var fpForm = views.forgot.querySelector('.si-fp-form');
  var rsForm = views.reset.querySelector('.si-rs-form');
  var sentTo = '';
  function fixStop(msg) { msg = String(msg || 'Something went wrong. Try again'); return msg + (/[.!?]$/.test(msg) ? '' : '.'); }
  function openForgot(email) {
    fpForm.reset();
    var e = String(email || '').trim();
    if (e) fpForm.email.value = e;
    showView('forgot');
    (validEmail(e) ? fpForm.querySelector('.si-submit') : fpForm.email).focus({ preventScroll: true });
  }
  function backToLogin() {
    setTab('login');
    showView('join');
    if (sentTo && !form.email.value) form.email.value = sentTo;
    (form.email.value ? form.password : form.email).focus({ preventScroll: true });
  }
  siRoot.addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]');
    if (!b) return;
    if (b.dataset.act === 'forgot') openForgot(siView === 'join' ? form.email.value : sentTo);
    else if (b.dataset.act === 'to-login') backToLogin();
    else if (b.dataset.act === 'again') openForgot(sentTo);
  });
  fpForm.addEventListener('submit', function (e) {
    e.preventDefault();
    clearNotes();
    var email = fpForm.email.value.trim();
    if (!validEmail(email)) return fail(views.forgot, 'Enter a valid email address.', fpForm.email);
    var btn = fpForm.querySelector('.si-submit');
    busy(btn, true, 'Sending…');
    api('POST', '/auth/forgot', { email: email }).then(function (r) {
      busy(btn, false, 'Send reset link');
      if (r.status !== 200) return fail(views.forgot, fixStop(r.json && r.json.error), r.json && r.json.code === 'bad-email' ? fpForm.email : null);
      sentTo = email;
      views.sent.querySelector('[data-sent-to]').textContent = email;
      document.getElementById('si-sent-sub').textContent = (r.json && r.json.message) || 'If an account exists for that email, we’ve sent a reset link.';
      showView('sent');
      views.sent.querySelector('.si-submit').focus({ preventScroll: true });
    }, function () { busy(btn, false, 'Send reset link'); fail(views.forgot, NET); });
  });

  // The link in the email: /?reset=<token> opens "Choose a new password" (see signinFromAddress).
  function openReset(token) {
    resetToken = token;
    rsForm.reset();
    views.reset.querySelector('[data-rs-email]').textContent = 'your AllFun Games account';
    rsForm.username.value = '';
    pendingView = 'reset';
    if (si.isOpen()) { showView('reset'); pendingView = null; } else si.open();
    // Is the link still good? (An old or used one goes straight to "expired"; offline, the form stays.)
    api('POST', '/auth/reset-check', { token: token }).then(function (r) {
      if (resetToken !== token) return;
      if (r.status === 200 && r.json && r.json.email) {
        views.reset.querySelector('[data-rs-email]').textContent = r.json.email;
        rsForm.username.value = r.json.email;
      } else if (r.json && r.json.code === 'bad-token') expired();
    }, function () { /* offline: the save says so */ });
  }
  function expired() {
    resetToken = null;
    pendingView = null;
    showView('expired');
    views.expired.querySelector('.si-ex-go').focus({ preventScroll: true });
  }
  rsForm.addEventListener('submit', function (e) {
    e.preventDefault();
    clearNotes();
    var pw = rsForm.password.value, again = rsForm.confirm.value;
    if (pw.length < 8) return fail(views.reset, 'Use at least 8 characters for your password.', rsForm.password);
    if (pw !== again) return fail(views.reset, 'The two passwords don’t match.', rsForm.confirm);
    if (!resetToken) return expired();
    var btn = rsForm.querySelector('.si-submit');
    busy(btn, true, 'Saving…');
    api('POST', '/auth/reset', { token: resetToken, password: pw }).then(function (r) {
      if (r.status !== 200) {
        busy(btn, false, 'Save new password');
        if (r.json && r.json.code === 'bad-token') return expired();
        return fail(views.reset, fixStop(r.json && r.json.error), rsForm.password);
      }
      resetToken = null;
      signedIn(r.json.token, r.json.account);
      rsForm.reset();
      // Signed in: bring the progress in, as after logging in.
      return firstSync().then(function (res) {
        busy(btn, false, 'Save new password');
        if (res && res.ask) return askChoice(res, false, true);
        welcome(false, false, true);
      }, function () { busy(btn, false, 'Save new password'); welcome(false, true, true); });
    }, function () { busy(btn, false, 'Save new password'); fail(views.reset, NET); });
  });

  function signedIn(token, account) {
    var rec = { uid: account.uid, email: account.email, token: token, since: account.since || Date.now() };
    // An account made with Google has no password (`nopw`): the Account view offers "Set a password" and
    // confirms deleting with Google (GOOGLE below). Accounts with a password keep the record as before.
    if (account.password === false) rec.nopw = true;
    write(AUTH_KEY, rec);
    forget(SYNC_KEY);
    renderAccount(true);
    walletFollow();
    refBannerHide();
  }
  // The shared coin wallet (assets/wallet.js): signed in, this browser's coins go to the account's wallet
  // (and its Backgammon joins it); signed out, the browser keeps a copy. It shows wherever coins show.
  function walletFollow() { if (window.AllFunWallet) window.AllFunWallet.refresh().then(renderCoins, renderCoins); }
  function renderCoins() {
    var W = window.AllFunWallet;
    if (!W) return;
    var n = W.balance();
    document.querySelectorAll('.af-coins').forEach(function (el) { el.textContent = fmt(n); });
    var line = views.account && views.account.querySelector('.sa-coins');
    if (line) line.hidden = false;
  }
  if (window.AllFunWallet) window.AllFunWallet.onChange(renderCoins);
  // The header's coin chip: the balance and its spoken label, now and on every change (no wallet script: no chip).
  // The number is also kept (af.navcoins, this browser only) for the page's header script to show before wallet.js
  // has run, in the rare case it cannot work the balance out itself (scripts/build-site.mjs NAV_SCRIPT).
  function renderNavCoins() {
    var W = window.AllFunWallet;
    document.querySelectorAll('.nav-coins').forEach(function (b) {
      if (!W) { b.hidden = true; return; }
      var n = fmt(W.balance());
      var t = b.querySelector('.ncn-n');
      if (t && t.textContent !== n) t.textContent = n;
      b.setAttribute('aria-label', 'Your coins: ' + n);
      b.hidden = false;
      try { if (localStorage.getItem('af.navcoins') !== n) localStorage.setItem('af.navcoins', n); } catch (e) { /* storage blocked */ }
    });
  }
  if (window.AllFunWallet) window.AllFunWallet.onChange(renderNavCoins);
  renderNavCoins();
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    clearNotes();
    var email = form.email.value.trim(), pw = form.password.value;
    if (!validEmail(email)) return fail(views.join, 'Enter a valid email address.', form.email);
    if (tab === 'signup' && pw.length < 8) return fail(views.join, 'Use at least 8 characters for your password.', form.password);
    if (!pw) return fail(views.join, 'Enter your password.', form.password);
    var btn = form.querySelector('.si-submit');
    var label = tab === 'login' ? 'Log in' : 'Sign up free';
    busy(btn, true, tab === 'login' ? 'Logging in…' : 'Creating your account…');
    var made = tab === 'signup';
    api('POST', made ? '/auth/register' : '/auth/login', { email: email, password: pw }).then(function (r) {
      busy(btn, false, label);
      // Sign-up (and logging in before the email was verified): the account opens with the code from the email.
      if ((made && r.status === 200 && r.json && r.json.verify) || (r.status === 403 && r.json && r.json.verify)) {
        form.password.value = '';
        return openCode((r.json && r.json.email) || email, made ? 'signup' : 'login', r.json && r.json.ticket);
      }
      if (r.status !== 200 || !r.json || !r.json.token) {
        var msg = (r.json && r.json.error) || 'Something went wrong. Try again.';
        if (r.json && (r.json.code === 'wrong' || r.json.code === 'weak-password')) return fail(views.join, fixStop(msg), form.password);
        if (r.json && r.json.code === 'bad-email') return fail(views.join, fixStop(msg), form.email);
        return fail(views.join, fixStop(msg));
      }
      busy(btn, true, label);
      signedIn(r.json.token, r.json.account);
      form.password.value = '';
      return firstSync().then(function (res) {
        busy(btn, false, label);
        if (res && res.ask) return askChoice(res, false);
        welcome(false);
      }, function () { busy(btn, false, label); welcome(false, true); });
    }, function () { busy(btn, false, label); fail(views.join, NET); });
  });

  // ---- The 6-digit code (18.10): the email is verified before the account opens ----------------------
  // Owner: "there must be email address verification". After Sign up (or a log-in whose email was never
  // verified) the server mails a code; it is typed (or pasted, or offered by iOS above the keyboard) here.
  // Only then is this browser signed in, synced, and given the sign-up bonus (the games' claimSignupBonus()
  // needs allfun.auth.v1, which is written only after the code). Codes: 15 minutes, 5 tries, 1 a minute.
  var codeForm = views.code.querySelector('.si-code-form');
  var codeIn = codeForm.code;
  var resendBtn = views.code.querySelector('.si-resend');
  // codeTicket: the server's ticket for THIS sign-up (security review, 18.10): the code it sends back opens
  // the account with the password typed here, never with one somebody else typed for the same email.
  var codeEmail = '', codeTicket = '', codeFrom = 'signup', codeTried = '', codeBusy = false, resendAt = 0, resendTimer = 0;
  var RESEND_S = 60;
  function openCode(email, from, ticket) {
    codeEmail = String(email || '').trim().toLowerCase();
    codeTicket = typeof ticket === 'string' ? ticket : '';
    codeFrom = from || 'signup';
    codeTried = '';
    codeForm.reset();
    codeForm.username.value = codeEmail;
    views.code.querySelector('[data-code-to]').textContent = codeEmail;
    startResend(RESEND_S);
    pendingView = null;
    showView('code');
    codeIn.focus({ preventScroll: true });
  }
  function renderResend() {
    var left = Math.max(0, Math.ceil((resendAt - Date.now()) / 1000));
    var tx = resendBtn.querySelector('.si-resend-tx');
    resendBtn.disabled = left > 0;
    resendBtn.classList.toggle('wait', left > 0);
    var sec = left % 60;
    tx.textContent = left > 0 ? 'Send a new code in ' + Math.floor(left / 60) + ':' + (sec < 10 ? '0' : '') + sec : 'Send a new code';
    if (left <= 0 && resendTimer) { clearInterval(resendTimer); resendTimer = 0; }
  }
  function startResend(seconds) {
    resendAt = Date.now() + seconds * 1000;
    if (resendTimer) clearInterval(resendTimer);
    resendTimer = setInterval(renderResend, 500);
    renderResend();
  }
  function digits(v) { return String(v || '').replace(/\D/g, '').slice(0, 6); }
  codeIn.addEventListener('input', function () {
    var d = digits(codeIn.value);
    if (codeIn.value !== d) codeIn.value = d;
    if (d.length < 6) { codeTried = ''; return; }
    if (!codeBusy && d !== codeTried) submitCode(); // all 6 digits (typed, pasted or autofilled): go
  });
  codeForm.addEventListener('submit', function (e) { e.preventDefault(); submitCode(); });
  function submitCode() {
    if (codeBusy) return;
    clearNotes();
    var code = digits(codeIn.value);
    if (code.length !== 6) return fail(views.code, 'Enter the 6-digit code from the email.', codeIn);
    if (!codeEmail) return backFromCode();
    var btn = codeForm.querySelector('.si-submit');
    codeBusy = true; codeTried = code;
    busy(btn, true, 'Checking…');
    var vbody = { email: codeEmail, code: code };
    if (codeTicket) vbody.ticket = codeTicket;
    var WV = window.AllFunWallet;
    inviteFields(vbody);
    api('POST', '/auth/verify', vbody).then(function (r) {
      if (r.status !== 200 || !r.json || !r.json.token) {
        codeBusy = false;
        busy(btn, false, 'Verify');
        fail(views.code, fixStop(r.json && r.json.error), codeIn);
        codeIn.select();
        return;
      }
      // Verified: signed in exactly as after signing up (sync, the welcome card with the gifts, the bonus).
      codeEmail = ''; codeTicket = '';
      if (resendTimer) { clearInterval(resendTimer); resendTimer = 0; }
      var invited = r.json.invited === true;
      signedIn(r.json.token, r.json.account);
      // The sign-up bonus the welcome card shows is paid now (once per account: the server checks), not only
      // when a game opens next.
      if (WV && WV.claimSignup) WV.claimSignup('site').catch(function () {});
      // Came through a friend's link and the server paid the invite: a celebration as the welcome card shows.
      var cheer = function () { if (invited) setTimeout(function () { wlToast('+' + fmt((window.AllFunWallet && window.AllFunWallet.INVITE_COINS) || 1000) + ' coins from your friend’s invite', true); }, reduce ? 0 : 650); };
      return firstSync().then(function (res) {
        codeBusy = false;
        busy(btn, false, 'Verify');
        cheer();
        if (res && res.ask) return askChoice(res, true);
        welcome(true);
      }, function () { codeBusy = false; busy(btn, false, 'Verify'); cheer(); welcome(true, true); });
    }, function () { codeBusy = false; busy(btn, false, 'Verify'); fail(views.code, NET); });
  }
  /**
   * A friend's invite link (`?ref=`, kept by the wallet for 30 days), this browser's wallet id and the wallet
   * this browser used before (`from`): the server decides the invite when the account opens (+1,000 each, or
   * refused as a self-invite). Added to the body of /auth/verify and /auth/google.
   */
  function inviteFields(body) {
    var WV = window.AllFunWallet;
    if (!WV) return body;
    try {
      var iref = WV.incomingRef();
      if (iref && iref.code) body.ref = iref.code;
      body.gid = WV.gid();
      var prev = WV.previousWallet ? WV.previousWallet() : null;
      if (prev) body.from = prev;
    } catch (e) { /* an older wallet script: sign up without it */ }
    return body;
  }
  function backFromCode() {
    var email = codeEmail;
    codeEmail = '';
    if (resendTimer) { clearInterval(resendTimer); resendTimer = 0; }
    setTab(codeFrom === 'login' ? 'login' : 'signup');
    showView('join');
    if (email) form.email.value = email;
    form.email.focus({ preventScroll: true });
    form.email.select();
  }
  views.code.addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]');
    if (!b) return;
    if (b.dataset.act === 'other-email') { backFromCode(); return; }
    if (b.dataset.act !== 'resend' || resendBtn.disabled || !codeEmail) return;
    clearNotes();
    resendBtn.classList.add('busy'); resendBtn.disabled = true;
    api('POST', '/auth/resend', codeTicket ? { email: codeEmail, ticket: codeTicket } : { email: codeEmail }).then(function (r) {
      resendBtn.classList.remove('busy');
      if (r.status !== 200) { renderResend(); return fail(views.code, fixStop(r.json && r.json.error)); }
      codeForm.code.value = ''; codeTried = '';
      startResend(RESEND_S);
      note(views.code, 'A new code is on its way. The older one no longer works.');
      codeIn.focus({ preventScroll: true });
    }, function () { resendBtn.classList.remove('busy'); renderResend(); fail(views.code, NET); });
  });

  // Both this device and the account have progress: which one to keep (the account's by default).
  function when(ms) {
    if (!ms) return '';
    var d = new Date(ms), now = new Date();
    var day = dateKey(d) === dateKey(now) ? 'today' : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    return day + ', ' + d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  }
  function gameCount(data) {
    var n = 0;
    Object.keys(data).forEach(function (k) { var m = /^allfun\.([a-z]+)\./.exec(k); if (m && GAMES[m[1]]) n += 1; });
    return n;
  }
  function askChoice(res, made, reset) {
    choice = { server: res.server, local: res.local, pick: 'account', made: made, reset: !!reset };
    var sn = gameCount(res.server.data || {}), ln = gameCount(res.local);
    views.choose.querySelector('[data-acct-when]').textContent = (sn ? plural(sn, 'game', 'games') + ' · ' : '') + 'saved ' + when(res.server.updatedAt);
    views.choose.querySelector('[data-dev-what]').textContent = (ln ? plural(ln, 'game', 'games') + ' on this device · ' : '') + 'replaces the account’s';
    pick('account');
    showView('choose');
    var first = views.choose.querySelector('.si-opt.on');
    if (first) first.focus({ preventScroll: true });
  }
  function pick(which) {
    if (choice) choice.pick = which;
    views.choose.querySelectorAll('.si-opt').forEach(function (o) {
      var on = o.dataset.pick === which;
      o.classList.toggle('on', on);
      o.setAttribute('aria-checked', on ? 'true' : 'false');
      o.tabIndex = on ? 0 : -1;
    });
  }
  views.choose.addEventListener('click', function (e) {
    var o = e.target.closest('.si-opt');
    if (o) { pick(o.dataset.pick); return; }
    var go = e.target.closest('[data-act="pick"]');
    if (!go || !choice) return;
    var c = choice;
    busy(go, true);
    var done = c.pick === 'account'
      ? Promise.resolve(useAccount(Number(c.server.version) || 0, c.server.data || {}))
      : useDevice(collectSaves(), Number(c.server.version) || 0);
    done.then(function () { busy(go, false); choice = null; welcome(c.made, false, c.reset); },
      function () { busy(go, false); fail(views.choose, NET); });
  });
  views.choose.addEventListener('keydown', function (e) {
    if ((e.key === 'ArrowDown' || e.key === 'ArrowUp') && e.target.closest('.si-opt')) {
      e.preventDefault();
      pick(choice && choice.pick === 'account' ? 'device' : 'account');
      views.choose.querySelector('.si-opt.on').focus({ preventScroll: true });
    }
  });

  // The welcome card after signing up / in, and the way back to the game that sent the player here.
  function welcome(made, offline, reset) {
    var game = backTo && GAMES[backTo.slice(1, -1)];
    document.getElementById('si-done-title').textContent = reset ? 'Password changed ✓' : made ? 'You’re in!' : 'Welcome back!';
    document.getElementById('si-done-sub').textContent = offline ? 'Signed in. Your progress will sync when AllFun Games can be reached.'
      : reset ? 'You’re signed in. Your progress is here, and saved to your account.'
      : made ? 'Your progress is saved to your account.' : 'Your progress is here, and saved to your account.';
    views.done.querySelector('.si-gifts').hidden = !made;
    var back = views.done.querySelector('.si-back');
    back.hidden = !game;
    views.done.querySelector('.si-play').hidden = !!game;
    if (game) {
      back.href = backTo;
      back.querySelector('.si-submit-tx').textContent = 'Back to ' + game.name;
    }
    showView('done');
    (game ? back : views.done.querySelector('.si-play')).focus({ preventScroll: true });
    if (game) {
      // Straight back to the game after a moment (the button goes at once).
      var target = backTo;
      setTimeout(function () { if (siView === 'done' && si.isOpen()) location.href = target; }, 2200);
    }
  }

  // The Account view.
  function renderSyncLine() {
    var sub = views.account && views.account.querySelector('.sa-st-sub');
    var box = views.account && views.account.querySelector('.sa-status');
    if (!sub || !box) return;
    var m = read(SYNC_KEY);
    box.dataset.state = syncState;
    sub.textContent = syncState === 'offline' ? 'Offline — saved on this device, it syncs when AllFun Games can be reached'
      : syncing ? 'Syncing…' : m && m.at ? 'Last synced ' + when(m.at) : 'Synced on every device you sign in on';
  }
  function renderAcct() {
    var a = auth();
    if (!a) return;
    var email = String(a.email || '');
    views.account.querySelector('.sa-email').textContent = email;
    views.account.querySelector('.sa-init').textContent = (email.charAt(0) || 'A').toUpperCase();
    renderCoins();
    views.account.querySelectorAll('.sa-more').forEach(function (f) { f.hidden = true; f.reset(); });
    views.account.querySelectorAll('[data-open]').forEach(function (b) { if (b.classList.contains('sa-row')) b.setAttribute('aria-expanded', 'false'); });
    renderSyncLine();
  }
  views.account.addEventListener('click', function (e) {
    var open = e.target.closest('[data-open]');
    if (open) {
      var f = document.getElementById('sa-' + open.dataset.open);
      var row = views.account.querySelector('.sa-row[data-open="' + open.dataset.open + '"]');
      var show = f.hidden;
      views.account.querySelectorAll('.sa-more').forEach(function (x) { x.hidden = true; });
      views.account.querySelectorAll('.sa-row[data-open]').forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
      clearNotes();
      f.hidden = !show;
      row.setAttribute('aria-expanded', show ? 'true' : 'false');
      if (show) { f.reset(); f.querySelector('input').focus({ preventScroll: true }); f.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' }); }
      else row.focus({ preventScroll: true });
      return;
    }
    var out = e.target.closest('[data-act="signout"]');
    if (out) {
      out.classList.add('busy'); out.disabled = true;
      var a = auth();
      // Send the last changes first, then end the session (both quietly when offline).
      syncNow().then(function () { return a ? api('POST', '/auth/logout', {}, a.token).catch(function () {}) : null; }).then(function () {
        out.classList.remove('busy'); out.disabled = false;
        forget(AUTH_KEY); forget(SYNC_KEY);
        renderAccount(false);
        walletFollow();
        setTab('login');
        showView('join');
        note(views.join, 'Signed out. Your progress stays saved in your account, and on this device.');
      });
    }
  });
  document.getElementById('sa-pw').addEventListener('submit', function (e) {
    e.preventDefault();
    var f = e.target, a = auth();
    clearNotes();
    if (!f.current.value) return fail(f, 'Enter your current password.', f.current);
    if (f.password.value.length < 8) return fail(f, 'Use at least 8 characters for the new password.', f.password);
    var btn = f.querySelector('.si-submit');
    busy(btn, true);
    api('POST', '/auth/password', { current: f.current.value, password: f.password.value }, a && a.token).then(function (r) {
      busy(btn, false);
      if (r.status === 401) { signedOutElsewhere(); showView('join'); return; }
      if (r.status !== 200) return fail(f, (r.json && r.json.error || 'Something went wrong') + '.', r.json && r.json.code === 'wrong-password' ? f.current : f.password);
      f.hidden = true; f.reset();
      views.account.querySelector('.sa-row[data-open="pw"]').setAttribute('aria-expanded', 'false');
      note(views.account, 'Password changed. Other devices were signed out.');
    }, function () { busy(btn, false); fail(f, NET); });
  });
  document.getElementById('sa-del').addEventListener('submit', function (e) {
    e.preventDefault();
    var f = e.target, a = auth();
    clearNotes();
    if (!f.password.value) return fail(f, 'Enter your password to confirm.', f.password);
    var btn = f.querySelector('.si-submit');
    busy(btn, true);
    api('POST', '/auth/delete', { password: f.password.value }, a && a.token).then(function (r) {
      busy(btn, false);
      if (r.status === 401) { signedOutElsewhere(); showView('join'); return; }
      if (r.status !== 200) return fail(f, (r.json && r.json.error || 'Something went wrong') + '.', f.password);
      forget(AUTH_KEY); forget(SYNC_KEY);
      renderAccount(false);
      walletFollow();
      setTab('signup');
      showView('join');
      note(views.join, 'Your account and its saved progress are deleted. This device keeps its own copy.');
    }, function () { busy(btn, false); fail(f, NET); });
  });

  // Google, Apple and Facebook: soon (the owner makes the developer keys). Google is live once the server has
  // its client ID (GOOGLE below): then a tap on its place before Google's button has loaded says why.
  siRoot.querySelector('.si-social').addEventListener('click', function (e) {
    var b = e.target.closest('.si-btn');
    if (!b) return;
    if (b.dataset.provider === 'Google' && gId) { googleTapEarly(); return; }
    siRoot.querySelectorAll('.si-btn.tapped').forEach(function (o) { o.classList.remove('tapped'); });
    void b.offsetWidth;
    b.classList.add('tapped');
    note(views.join, b.dataset.provider + ' sign-in is coming soon. Use your email for now — it takes a few seconds.');
  });


  // ==== GOOGLE: Sign in with Google (22.10) ========================================================
  // Owner (00.1א, item 2): Google first, then Facebook. On only when the server has our Google client ID
  // (GET /api/auth/config → `google`); without it the button stays "Soon" and nothing of Google loads. Google's
  // own script (accounts.google.com/gsi/client) is loaded only then, when the sheet opens — never on page load.
  // Its button (Google's, as their branding rules ask) takes the Google place, across the row; Apple and
  // Facebook stay "Soon" under it. The ID token it gives goes to POST /api/auth/google (server/src/google.ts):
  // an existing account signs in, otherwise a new one opens exactly as after the email code (the nickname step,
  // the sign-up bonus, a friend's invite, this browser's coins). An account made with Google has no password:
  // the Account view's "Set a password" and "Delete account" are confirmed with Google instead.
  // Backgammon's own Google button hands its token over in sessionStorage (`allfun.google.v1`) and opens
  // /?google=1&back=/backgammon/, which finishes here (signinFromAddress).
  var gId = null, gsiReady = null, gBusy = false;
  var gCell = siRoot.querySelector('.si-btn[data-provider="Google"]');
  var gJoinHost = document.createElement('div');
  gJoinHost.className = 'si-gsi';
  function googleOn(id) {
    if (gId) return;
    gId = id;
    siRoot.classList.add('si-g-on');
    if (gCell) {
      var soon = gCell.querySelector('.si-soon');
      if (soon) soon.remove();
      gCell.setAttribute('aria-label', 'Continue with Google');
      gCell.parentNode.insertBefore(gJoinHost, gCell.nextSibling);
    }
    if (si.isOpen() && siView === 'join') gJoin();
    if (si.isOpen() && siView === 'account') renderGoogleAcct();
  }
  function needGsi() {
    if (gsiReady) return gsiReady;
    gsiReady = new Promise(function (resolve, reject) {
      function ready() {
        var id = window.google && window.google.accounts && window.google.accounts.id;
        if (!id) { gsiReady = null; return reject(new Error('gsi')); }
        id.initialize({ client_id: gId, callback: googleCredential, ux_mode: 'popup', auto_select: false, cancel_on_tap_outside: true });
        resolve(id);
      }
      if (window.google && window.google.accounts && window.google.accounts.id) return ready();
      var tag = document.createElement('script');
      tag.src = 'https://accounts.google.com/gsi/client';
      tag.async = true;
      tag.onload = ready;
      tag.onerror = function () { gsiReady = null; reject(new Error('gsi')); };
      document.head.appendChild(tag);
    });
    return gsiReady;
  }
  /** Google's button in `host`, as wide as its place (200–400 px, Google's limits), 40 px or 32 px high. */
  function gRender(host, tall) {
    return needGsi().then(function (id) {
      var w = Math.max(200, Math.min(400, Math.round(host.getBoundingClientRect().width || 300)));
      if (host.dataset.w === String(w) && host.firstElementChild) return;
      host.textContent = '';
      host.dataset.w = String(w);
      id.renderButton(host, { type: 'standard', theme: 'filled_black', size: tall === false ? 'medium' : 'large', text: 'continue_with', shape: 'pill', logo_alignment: 'left', width: w });
      // The placeholder under it steps aside once Google's button is there (its frame loads a moment later).
      var tries = 0;
      (function shown() {
        if (host.firstElementChild && host.offsetHeight > 20) { host.classList.add('in'); return; }
        if ((tries += 1) < 50) setTimeout(shown, 100);
      })();
    });
  }
  function gJoin() {
    if (!gId || !gCell) return;
    gRender(gJoinHost, gCell.offsetHeight >= 39).catch(function () { /* the placeholder stays; a tap says why */ });
  }
  function googleTapEarly() {
    note(views.join, gsiReady ? 'Google is getting ready — one moment.' : 'Google sign-in couldn’t load. Check your connection, or use your email.');
    gJoin();
  }
  var gWide = 0;
  window.addEventListener('resize', function () {
    if (!gId || !si.isOpen() || Math.abs(window.innerWidth - gWide) < 8) return;
    gWide = window.innerWidth;
    if (siView === 'join') gJoin();
  });
  /** Google's button gave a token: what it is for depends on what the sheet shows. */
  function googleCredential(response) {
    var cred = response && response.credential;
    if (typeof cred !== 'string' || !cred) return;
    if (siView === 'account' && isSignedIn()) {
      var pwf = document.getElementById('sa-pw'), delf = document.getElementById('sa-del');
      if (delf && !delf.hidden) return googleDelete(cred, delf);
      if (pwf && !pwf.hidden) return googleSetPassword(cred, pwf);
      return;
    }
    googleSignin(cred);
  }
  function googleSignin(cred) {
    if (gBusy) return;
    gBusy = true;
    clearNotes();
    if (siView !== 'join') showView('join');
    siRoot.classList.add('si-g-busy');
    note(views.join, 'Signing you in with Google…');
    var done = function () { gBusy = false; siRoot.classList.remove('si-g-busy'); };
    api('POST', '/auth/google', inviteFields({ credential: cred })).then(function (r) {
      if (r.status !== 200 || !r.json || !r.json.token) {
        done();
        clearNotes();
        return fail(views.join, fixStop((r.json && r.json.error) || 'Google sign-in didn’t work. Try again.'));
      }
      var made = r.json.created === true, invited = r.json.invited === true;
      signedIn(r.json.token, r.json.account);
      // A new account: the sign-up bonus, as after the email code (once per account: the server checks).
      var WV = window.AllFunWallet;
      if (made && WV && WV.claimSignup) WV.claimSignup('site').catch(function () {});
      var cheer = function () { if (invited) setTimeout(function () { wlToast('+' + fmt((window.AllFunWallet && window.AllFunWallet.INVITE_COINS) || 1000) + ' coins from your friend’s invite', true); }, reduce ? 0 : 650); };
      return firstSync().then(function (res) {
        done();
        cheer();
        if (res && res.ask) return askChoice(res, made);
        welcome(made);
      }, function () { done(); cheer(); welcome(made, true); });
    }, function () { done(); clearNotes(); fail(views.join, NET); });
  }
  // The Account view of an account with no password (made with Google).
  function acctNoPw() { var a = auth(); return !!(a && a.nopw); }
  function setNoPw(on) {
    var a = read(AUTH_KEY);
    if (!a) return;
    if (on) a.nopw = true; else delete a.nopw;
    write(AUTH_KEY, a);
  }
  var pwHost = document.createElement('div'), delHost = document.createElement('div');
  pwHost.className = delHost.className = 'sa-gsi';
  (function () {
    var pwf = document.getElementById('sa-pw'), delf = document.getElementById('sa-del');
    pwf.insertBefore(pwHost, pwf.querySelector('.si-err'));
    delf.insertBefore(delHost, delf.querySelector('.si-err'));
  })();
  function renderGoogleAcct() {
    var nopw = acctNoPw();
    views.account.classList.toggle('sa-nopw', nopw);
    var row = views.account.querySelector('.sa-row[data-open="pw"] > span:not(.sa-ic)');
    if (row) row.textContent = nopw ? 'Set a password' : 'Change password';
    var pwNote = views.account.querySelector('#sa-pw .sa-gnote'), delNote = views.account.querySelector('#sa-del .sa-gnote');
    pwNote.textContent = !nopw ? '' : gId ? 'Your account signs in with Google. Choose a password to log in with your email too, then confirm it’s you with Google.'
      : 'Your account signs in with Google. To add a password, sign out and use “Forgot password?” on Log in — we’ll email you a link.';
    delNote.textContent = !nopw ? '' : gId ? 'Confirm it’s you with Google to delete it.' : 'Write to support@allfun.games to delete it.';
    pwHost.hidden = delHost.hidden = !nopw || !gId;
  }
  function deletedHere() {
    forget(AUTH_KEY); forget(SYNC_KEY);
    renderAccount(false);
    walletFollow();
    setTab('signup');
    showView('join');
    note(views.join, 'Your account and its saved progress are deleted. This device keeps its own copy.');
  }
  function googleSetPassword(cred, f) {
    clearNotes();
    var a = auth();
    if (f.password.value.length < 8) return fail(f, 'Use at least 8 characters for the new password, then confirm with Google.', f.password);
    api('POST', '/auth/password', { google: cred, password: f.password.value }, a && a.token).then(function (r) {
      if (r.status === 401 && r.json && r.json.code === 'unauthorized') { signedOutElsewhere(); showView('join'); return; }
      if (r.status === 409 && r.json && r.json.code === 'has-password') { setNoPw(false); renderAcct(); renderGoogleAcct(); return fail(views.account, 'Your account already has a password — change it with the current one.'); }
      if (r.status !== 200) return fail(f, fixStop(r.json && r.json.error), f.password);
      setNoPw(false);
      f.hidden = true; f.reset();
      renderAcct(); renderGoogleAcct();
      note(views.account, 'Password set. You can log in with your email too. Other devices were signed out.');
    }, function () { fail(f, NET); });
  }
  function googleDelete(cred, f) {
    clearNotes();
    var a = auth();
    api('POST', '/auth/delete', { google: cred }, a && a.token).then(function (r) {
      if (r.status === 401 && r.json && r.json.code === 'unauthorized') { signedOutElsewhere(); showView('join'); return; }
      if (r.status !== 200) return fail(f, fixStop(r.json && r.json.error));
      deletedHere();
    }, function () { fail(f, NET); });
  }
  // Opening "Set a password" / "Delete account" of such an account shows Google's button in the form.
  views.account.addEventListener('click', function (e) {
    var open = e.target.closest('[data-open]');
    if (!open || !gId || !acctNoPw()) return;
    var host = open.dataset.open === 'pw' ? pwHost : open.dataset.open === 'del' ? delHost : null;
    var f = host && host.parentNode;
    if (host && f && !f.hidden) gRender(host, true).catch(function () { fail(f, 'Google sign-in couldn’t load. Check your connection.'); });
  });
  // The forms' own buttons are hidden for such an account (Google's button confirms); Enter only explains.
  ['sa-pw', 'sa-del'].forEach(function (id) {
    document.getElementById(id).addEventListener('submit', function (e) {
      if (!acctNoPw()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      clearNotes();
      if (id === 'sa-pw' && e.target.password.value.length < 8) return fail(e.target, 'Use at least 8 characters for the new password.', e.target.password);
      fail(e.target, gId ? 'Now confirm with Google, just below.' : 'Write to support@allfun.games.');
    }, true);
  });
  // Is this still an account without a password? (Set on another device, or a reset link.) Quietly, when Account opens.
  function refreshNoPw() {
    var a = auth();
    if (!a) return;
    api('GET', '/auth/me', undefined, a.token).then(function (r) {
      if (r.status !== 200 || !r.json || !r.json.account || typeof r.json.account.password !== 'boolean') return;
      var nopw = r.json.account.password === false;
      if (nopw !== acctNoPw() && auth() && auth().token === a.token) { setNoPw(nopw); if (siView === 'account') renderGoogleAcct(); }
    }, function () {});
  }
  var gBaseShow = showView;
  showView = function (name) {
    gBaseShow(name);
    if (name === 'join' && gId) { gWide = window.innerWidth; gJoin(); }
    if (name === 'account') { renderGoogleAcct(); refreshNoPw(); }
  };
  /** Backgammon's Google button: its token, handed over in this tab's sessionStorage (5 minutes at most), once. */
  function googleHandoff() {
    var got = null;
    try {
      var raw = window.sessionStorage.getItem('allfun.google.v1');
      window.sessionStorage.removeItem('allfun.google.v1');
      var h = raw ? JSON.parse(raw) : null;
      if (h && typeof h.c === 'string' && h.c.length > 20 && Date.now() - Number(h.at) < 5 * 60 * 1000) got = h.c;
    } catch (e) { /* storage blocked */ }
    return got;
  }

  function openSignin(from, which) {
    if (!isSignedIn() && which) setTab(which);
    si.open(from);
  }
  // The footer's Sign in is a link to "/#signin" on Privacy, Terms and Contact (it still works without
  // this script); here it opens the sheet in place.
  document.querySelectorAll('.nav-signin, .ft-acct').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); openSignin(b); });
  });
  var menuAcct = document.querySelector('.m-acct');
  if (menuAcct) menuAcct.addEventListener('click', function () { closeMenu(); openSignin(toggle); });
  // A link to "#signin" (or "/#signin" from another page) opens the sheet on arrival; so do
  // "/?signup=1" and "/?login=1" (the games' sign-up card), with "&back=/<slug>/" to return to the game.
  function signinFromAddress() {
    var q = new URLSearchParams(location.search);
    var reset = q.get('reset');
    if (reset !== null) {
      // The token never stays in the address bar (history, screenshots, sharing the page).
      q.delete('reset');
      var left = q.toString();
      try { history.replaceState(null, '', location.pathname + (left ? '?' + left : '') + location.hash); } catch (e) { /* keep it */ }
      if (/^[A-Za-z0-9_-]{20,100}$/.test(reset)) { openReset(reset); return; }
      pendingView = 'expired';
      si.open();
      return;
    }
    var which = q.get('signup') === '1' ? 'signup' : q.get('login') === '1' ? 'login' : null;
    var hash = location.hash === '#signin';
    var viaGoogle = q.get('google') === '1';
    if (!which && !hash && !viaGoogle) return;
    var back = q.get('back');
    backTo = back && /^\/[a-z]{1,20}\/$/.test(back) && GAMES[back.slice(1, -1)] ? back : null;
    ['signup', 'login', 'back', 'google'].forEach(function (k) { q.delete(k); });
    var rest = q.toString();
    try { history.replaceState(null, '', location.pathname + (rest ? '?' + rest : '')); } catch (e) { /* keep it */ }
    // Backgammon's Google button (GOOGLE above): its token finishes the sign-in here.
    var cred = viaGoogle && !isSignedIn() ? googleHandoff() : null;
    openSignin(null, which || 'signup');
    if (cred) googleSignin(cred);
  }
  signinFromAddress();
  window.addEventListener('hashchange', signinFromAddress);
  window.AllFunAccount = { signedIn: isSignedIn, sync: syncNow, open: function (which) { openSignin(null, which); } }; // for testing in the browser

  // ==== PROFILE: nickname and picture (21.10) ======================================================
  // Owner, 21.10: "once registered, players can change NICK NAME / add a profile picture. If the name is taken
  // it can't be used. Changing the name after registration costs 40 coins or a free video. Changing the profile
  // picture is always free; for now only icons." The server decides (server/src/nicknames.ts:
  // GET/POST /api/me/profile, POST /api/me/rename-video, GET /api/names/check); the rules and the pictures are
  // games/shared/nickname.ts and avatars.ts, which this page loads as /assets/avatars.js (window.AllFunAvatars)
  // the first time it needs them. In the sign-in sheet: the Account view's header is the profile card (big
  // picture, nickname, Edit), and three views — "nick" (the editor with live availability and the price),
  // "avatars" (the picker, saved on tap) and "setup" (once, right after signing up). The nickname and picture
  // are kept in allfun.auth.v1 (`nick`, `av`: device-only) so the games show them at once (games/shared/member.ts).
  // With no server the card stays as it was (email and coins only).
  var AV_SRC = (function () {
    var me = document.currentScript && document.currentScript.src;
    return me ? me.replace(/shared\.js(\?[^#]*)?$/, 'avatars.js$1') : '/assets/avatars.js';
  })();
  var avWaiting = null;
  function needAvatars() {
    if (window.AllFunAvatars) return Promise.resolve(window.AllFunAvatars);
    if (!avWaiting) {
      avWaiting = new Promise(function (resolve, reject) {
        var tag = document.createElement('script');
        tag.src = AV_SRC;
        tag.async = true;
        tag.onload = function () { if (window.AllFunAvatars) resolve(window.AllFunAvatars); else reject(new Error('avatars')); };
        tag.onerror = function () { avWaiting = null; reject(new Error('avatars')); };
        document.head.appendChild(tag);
      });
    }
    return avWaiting;
  }
  var PF_COINS = 40; // games/shared/nickname.ts RENAME_COINS (the server's answer says so too)
  var pf = { name: null, avatar: null, price: 0, loaded: false, online: false };
  var pfListeners = [];
  function pfHere() { var a = auth(); return a ? { name: typeof a.nick === 'string' ? a.nick : null, avatar: typeof a.av === 'string' ? a.av : null } : { name: null, avatar: null }; }
  /** Keeps the nickname and picture with this browser's sign-in (device-only), for the games and the header. */
  function pfRemember() {
    var a = auth();
    if (!a) return;
    var next = {};
    Object.keys(a).forEach(function (k) { next[k] = a[k]; });
    if (pf.name) next.nick = pf.name; else delete next.nick;
    if (pf.avatar) next.av = pf.avatar; else delete next.av;
    write(AUTH_KEY, next);
  }
  function pfChanged() {
    pfRemember();
    pfPaintAll();
    pfListeners.slice().forEach(function (fn) { try { fn({ name: pf.name, avatar: pf.avatar }); } catch (e) { /* a listener's own problem */ } });
  }
  /** The profile from the server (and the card follows). Quiet when offline: what this browser kept stays. */
  function pfLoad() {
    var a = auth();
    if (!a) return Promise.resolve(null);
    var here = pfHere();
    if (!pf.loaded) { pf.name = here.name; pf.avatar = here.avatar; pf.price = here.name ? PF_COINS : 0; }
    return api('GET', '/me/profile', undefined, a.token).then(function (r) {
      if (r.status === 401) { signedOutElsewhere(); return null; }
      if (r.status !== 200 || !r.json || !r.json.profile) return null;
      var p = r.json.profile;
      if (typeof r.json.price === 'number') PF_COINS = r.json.price;
      pf.name = typeof p.name === 'string' ? p.name : null;
      pf.avatar = typeof p.avatar === 'string' ? p.avatar : null;
      pf.price = Number(p.price) || 0;
      pf.loaded = true; pf.online = true;
      pfChanged();
      return pf;
    }, function () { return null; });
  }
  function pfFace(node, id, initial) {
    var A = window.AllFunAvatars;
    var svg = id && A ? A.avatarSvg(id) : '';
    node.classList.toggle('has-art', !!svg);
    // The letter stays in the node (hidden under a picture): the Account view's own code writes to .sa-init.
    var b = document.createElement('b');
    b.className = node.classList.contains('sa-av') ? 'sa-init' : 'pf-init';
    b.textContent = initial || '';
    node.innerHTML = svg;
    node.appendChild(b);
  }
  function pfInitial() {
    var a = auth();
    var from = pf.name || (a && a.email) || '';
    var c = String(from).trim().charAt(0).toUpperCase();
    return /[A-Z0-9]/.test(c) ? c : (c || 'A');
  }
  /** The disc's own colours tint the card behind it (CSS --pa / --pb). */
  function pfTint(node, id) {
    var A = window.AllFunAvatars, art = id && A ? A.avatarArt(id) : null;
    if (art) { node.style.setProperty('--pa', art.a); node.style.setProperty('--pb', art.b); }
    else { node.style.removeProperty('--pa'); node.style.removeProperty('--pb'); }
  }
  function pfPaintAll() {
    if (!views.account) return;
    // The pictures come with assets/avatars.js: fetched the first time one is needed, then painted.
    if (pf.avatar && !window.AllFunAvatars) needAvatars().then(pfPaintAll, function () {});
    var card = views.account.querySelector('.pf-card');
    var face = card.querySelector('[data-pf-face]');
    pfFace(face, pf.avatar, pfInitial());
    pfTint(card, pf.avatar);
    var title = card.querySelector('#si-acct-title');
    title.textContent = pf.name || 'Your account';
    card.classList.toggle('pf-named', !!pf.name);
    card.querySelector('.pf-acts').hidden = !pf.online;
    card.querySelector('.pf-av').disabled = !pf.online;
    card.querySelector('[data-pf-nick-btn]').textContent = pf.name ? 'Edit nickname' : 'Choose a nickname';
    pfPaintNav();
  }
  // The header's and the dock's round button: the member's picture when there is one (else as before: the
  // email's first letter, or a plush picked in Plush Pluck).
  function pfPaintNav() {
    var on = isSignedIn() && !!pf.avatar && !!window.AllFunAvatars;
    document.querySelectorAll('.nav-signin .av, .dock-av').forEach(function (n) {
      var old = n.querySelector('.af-avatar');
      if (old) old.remove();
      n.classList.toggle('has-art', on);
      if (on) n.insertAdjacentHTML('afterbegin', window.AllFunAvatars.avatarSvg(pf.avatar));
    });
  }
  var pfBaseRender = renderAccount;
  renderAccount = function (on) { pfBaseRender(on); if (on) pfPaintNav(); else document.querySelectorAll('.nav-signin .af-avatar, .dock-av .af-avatar').forEach(function (s) { s.parentNode.classList.remove('has-art'); s.remove(); }); };
  views.account.addEventListener('click', function (e) {
    var go = e.target.closest('[data-pf-go]');
    if (go && !go.disabled) pfOpen(go.dataset.pfGo);
  });
  function pfOpen(view) {
    if (!isSignedIn()) { showView('join'); return; }
    if (view === 'account') { showView('account'); pfLoad(); return; }
    if (view === 'nick') return pfOpenNick();
    if (view === 'avatars') return pfOpenPics();
  }
  [views.nick, views.avatars].forEach(function (v) {
    v.querySelector('.pf-back').addEventListener('click', function () { showView('account'); var b = views.account.querySelector('.pf-av'); if (b) b.focus({ preventScroll: true }); });
  });

  // ---- the nickname field: what is typed, checked as it is typed --------------------------------------
  // States: idle (the rules), checking, available, yours, taken, not-allowed, invalid, offline.
  function nickField(view) {
    var input = view.querySelector('input[name="nick"]');
    var count = view.querySelector('.pf-count');
    var status = view.querySelector('.pf-status');
    var text = status.querySelector('.pf-st-tx');
    var RULES = text.textContent;
    var seq = 0, timer = 0, state = 'idle', checked = '';
    function set(next, words) {
      state = next;
      status.dataset.state = next;
      text.textContent = words;
      var f = input.closest('.si-field');
      f.classList.toggle('bad', next === 'taken' || next === 'not-allowed' || next === 'invalid');
      f.classList.toggle('good', next === 'available');
      field.onstate(next);
    }
    function norm(v) { return String(v || '').trim().replace(/\s+/g, ' '); }
    function check() {
      var name = norm(input.value);
      count.textContent = Array.from(input.value).length + '/16';
      clearTimeout(timer);
      if (!name) return set('idle', RULES);
      if (pf.name && name === pf.name) return set('yours', 'This is your nickname');
      var A = window.AllFunAvatars;
      var local = A && A.nickProblem(name);
      if (local) return set(local.code, local.code === 'not-allowed' ? 'Please choose another name' : local.message);
      set('checking', 'Checking…');
      var mine = ++seq;
      timer = setTimeout(function () {
        var a = auth();
        api('GET', '/names/check?name=' + encodeURIComponent(name), undefined, a && a.token).then(function (r) {
          if (mine !== seq) return;
          var st = r.json && r.json.status;
          checked = name;
          if (r.status !== 200) return set('offline', (r.json && r.json.error) || 'Can’t check right now — try again');
          if (st === 'available') set('available', 'Available');
          else if (st === 'yours') set('yours', 'This is your nickname');
          else if (st === 'taken') set('taken', 'Taken — try another');
          else if (st === 'not-allowed') set('not-allowed', 'Please choose another name');
          else set('invalid', (r.json && r.json.message) || 'Choose another nickname');
        }, function () { if (mine === seq) set('offline', 'Can’t reach AllFun Games — check your connection'); });
      }, 320);
    }
    input.addEventListener('input', check);
    var field = {
      input: input,
      value: function () { return norm(input.value); },
      state: function () { return state; },
      fresh: function () { return checked === norm(input.value); },
      fill: function (v) { input.value = v || ''; check(); },
      mark: function (st, words) { set(st, words); },
      onstate: function () {}
    };
    needAvatars().then(check, function () {});
    return field;
  }

  // ---- the editor ("nick") ------------------------------------------------------------------------
  var nickView = views.nick;
  var nickForm = nickView.querySelector('.pf-form');
  var nick = nickField(nickView);
  var payBox = nickView.querySelector('.pf-pay'), freeBox = nickView.querySelector('.pf-free');
  var nickBtn = nickForm.querySelector('.si-submit');
  var pay = 'coins', videoBusy = false;
  function balance() { return window.AllFunWallet ? Number(window.AllFunWallet.balance()) || 0 : 0; }
  function pfTag() {
    var shown = nick.value() || pf.name || 'Your nickname';
    nickView.querySelector('[data-pf-tag]').textContent = shown;
    pfFace(nickView.querySelector('.pf-tag-av'), pf.avatar, shown.charAt(0).toUpperCase());
    pfTint(nickView.querySelector('.pf-tag'), pf.avatar);
  }
  function renderPay() {
    var first = !pf.name;
    freeBox.hidden = !first;
    payBox.hidden = first;
    var have = balance(), short = have < PF_COINS;
    var coinsOpt = payBox.querySelector('[data-pay="coins"]');
    coinsOpt.querySelector('b').textContent = PF_COINS + ' coins';
    coinsOpt.querySelector('[data-pf-bal]').textContent = short ? 'You have ' + fmt(have) + ' — not enough' : 'You have ' + fmt(have);
    coinsOpt.classList.toggle('short', short);
    if (short && pay === 'coins' && ADS_LIVE) pay = 'video';
    if (!ADS_LIVE) {
      // Ads off: no video way to pay, the coins are the one option (the button waits for enough coins).
      pay = 'coins';
      var vidOpt = payBox.querySelector('[data-pay="video"]');
      if (vidOpt) vidOpt.remove();
      payBox.style.gridTemplateColumns = '1fr';
    }
    payBox.querySelectorAll('.pf-opt').forEach(function (o) {
      var on = o.dataset.pay === pay;
      o.classList.toggle('on', on);
      o.setAttribute('aria-checked', on ? 'true' : 'false');
      o.tabIndex = on ? 0 : -1;
    });
    renderNickBtn();
  }
  function renderNickBtn() {
    if (videoBusy) return;
    var st = nick.state();
    var changed = !!nick.value() && nick.value() !== pf.name;
    var label = !pf.name ? 'Save nickname' : pay === 'video' ? 'Watch the video & save' : 'Pay ' + PF_COINS + ' coins & save';
    nickBtn.querySelector('.si-submit-tx').textContent = label;
    nickBtn.disabled = !changed || st === 'taken' || st === 'not-allowed' || st === 'invalid' || st === 'checking' || st === 'idle' ||
      (!ADS_LIVE && !!pf.name && balance() < PF_COINS);
    nickBtn.classList.toggle('pf-video', !!pf.name && pay === 'video');
  }
  nick.onstate = function () { pfTag(); renderNickBtn(); };
  payBox.addEventListener('click', function (e) {
    var o = e.target.closest('.pf-opt');
    if (!o) return;
    if (o.dataset.pay === 'coins' && o.classList.contains('short')) { fail(nickView, 'You have ' + fmt(balance()) + (ADS_LIVE ? ' coins. Watch a video instead — it’s free.' : ' coins. A new nickname costs ' + PF_COINS + '.')); return; }
    pay = o.dataset.pay;
    clearNotes();
    renderPay();
  });
  payBox.addEventListener('keydown', function (e) {
    if (!ADS_LIVE || (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'ArrowUp' && e.key !== 'ArrowDown')) return;
    e.preventDefault();
    var next = pay === 'coins' ? 'video' : 'coins';
    if (next === 'coins' && balance() < PF_COINS) return;
    pay = next; renderPay();
    payBox.querySelector('[data-pay="' + pay + '"]').focus();
  });
  function pfOpenNick() {
    clearNotes();
    showView('nick');
    pay = balance() >= PF_COINS || !ADS_LIVE ? 'coins' : 'video';
    nick.fill(pf.name || '');
    renderPay();
    pfTag();
    needAvatars().then(pfTag, function () {});
    if (window.AllFunWallet) window.AllFunWallet.refresh().then(renderPay, function () {});
    setTimeout(function () { nick.input.focus({ preventScroll: true }); nick.input.select(); }, reduce ? 0 : 260);
  }
  /**
   * The rewarded video. The site has no ad player of its own yet (H5 Games Ads come after AdSense, HANDOFF
   * 00.1א): like the games' ads.ts placeholder it always completes — here a short countdown on the button, so
   * the player sees something happen. The real ad plugs in here.
   */
  function playVideo(btn) {
    return new Promise(function (resolve) {
      var tx = btn.querySelector('.si-submit-tx'), left = 3;
      btn.classList.add('pf-playing');
      tx.textContent = 'Video playing… ' + left;
      var t = setInterval(function () {
        left -= 1;
        if (left > 0) { tx.textContent = 'Video playing… ' + left; return; }
        clearInterval(t);
        btn.classList.remove('pf-playing');
        resolve(true);
      }, 1000);
    });
  }
  function saveProfile(body) {
    var a = auth();
    return api('POST', '/me/profile', body, a && a.token).then(function (r) {
      if (r.status === 401) { signedOutElsewhere(); showView('join'); throw new Error('signed out'); }
      if (r.status === 200 && r.json && r.json.profile) {
        pf.name = r.json.profile.name || null;
        pf.avatar = r.json.profile.avatar || null;
        pf.price = Number(r.json.profile.price) || 0;
        pf.loaded = true;
        pfChanged();
        if (r.json.charged) walletFollow();
      }
      return r;
    });
  }
  function nickErr(view, field, r) {
    var code = r.json && r.json.code;
    if (code === 'taken') field.mark('taken', 'Taken — try another');
    else if (code === 'not-allowed') field.mark('not-allowed', 'Please choose another name');
    else if (code === 'invalid') field.mark('invalid', fixStop(r.json.error));
    else fail(view, fixStop(r.json && r.json.error));
    if (code === 'taken' || code === 'not-allowed' || code === 'invalid') field.input.focus({ preventScroll: true });
  }
  nickForm.addEventListener('submit', function (e) {
    e.preventDefault();
    if (nickBtn.disabled || videoBusy) return;
    clearNotes();
    var name = nick.value(), first = !pf.name, way = first ? null : pay;
    var body = { name: name };
    var go = function (extra) {
      Object.keys(extra || {}).forEach(function (k) { body[k] = extra[k]; });
      busy(nickBtn, true, 'Saving…');
      return saveProfile(body).then(function (r) {
        busy(nickBtn, false);
        if (r.status !== 200) { nickErr(nickView, nick, r); renderNickBtn(); return; }
        showView('account');
        note(views.account, way === 'coins' ? 'Nickname saved · ' + PF_COINS + ' coins' : way === 'video' ? 'Nickname saved · thanks for watching' : 'Nickname saved. Other players see it in every game.');
      }, function (err) { busy(nickBtn, false); renderNickBtn(); if (!err || err.message !== 'signed out') fail(nickView, NET); });
    };
    if (way === 'video') {
      videoBusy = true;
      nickBtn.disabled = true;
      playVideo(nickBtn).then(function (watched) {
        videoBusy = false;
        if (!watched) { renderNickBtn(); return; }
        var a = auth();
        api('POST', '/me/rename-video', {}, a && a.token).then(function (r) {
          if (r.status !== 200 || !r.json || !r.json.pass) { renderNickBtn(); return fail(nickView, fixStop(r.json && r.json.error)); }
          go({ payment: 'video', pass: r.json.pass });
        }, function () { renderNickBtn(); fail(nickView, NET); });
      });
      return;
    }
    go(way === 'coins' ? { payment: 'coins' } : null);
  });

  // ---- the picture picker ("avatars", and the setup's small grid) -----------------------------------
  // Three groups on one sheet: animals, game pieces, emblems (games/shared/nickname.ts AVATAR_IDS, in order).
  var PF_GROUPS = [['Animals', 12], ['Game pieces', 6], ['Emblems', 12]];
  function buildGrid(box, pick) {
    return needAvatars().then(function (A) {
      if (box.dataset.built) return;
      box.dataset.built = '1';
      var html = '', i = 0, small = box.classList.contains('pf-grid-sm');
      PF_GROUPS.forEach(function (g) {
        if (!small) html += '<p class="pf-group" aria-hidden="true">' + g[0] + '</p>';
        for (var k = 0; k < g[1] && i < A.AVATAR_ART.length; k += 1, i += 1) {
          var art = A.AVATAR_ART[i];
          html += '<button class="pf-pick" type="button" role="radio" aria-checked="false" tabindex="-1" data-id="' + art.id + '" aria-label="' + esc(art.label) + '">' + A.avatarSvg(art.id) + '<i class="pf-tick" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M6 12.5l4 4 8-9"/></svg></i></button>';
        }
      });
      box.innerHTML = html;
      box.addEventListener('click', function (e) {
        var b = e.target.closest('.pf-pick');
        if (b) pick(b.dataset.id, b);
      });
      box.addEventListener('keydown', function (e) {
        var keys = { ArrowRight: 1, ArrowLeft: -1, ArrowDown: 0, ArrowUp: 0 };
        if (!(e.key in keys)) return;
        e.preventDefault();
        var all = Array.prototype.slice.call(box.querySelectorAll('.pf-pick'));
        var at = all.indexOf(document.activeElement);
        var cols = Math.max(1, Math.round(box.clientWidth / (all[0].getBoundingClientRect().width || 48)));
        var step = keys[e.key] || (e.key === 'ArrowDown' ? cols : -cols);
        var next = all[Math.max(0, Math.min(all.length - 1, (at < 0 ? 0 : at) + step))];
        all.forEach(function (x) { x.tabIndex = -1; });
        next.tabIndex = 0;
        next.focus();
      });
    });
  }
  function markGrid(box, id) {
    var any = false;
    box.querySelectorAll('.pf-pick').forEach(function (b) {
      var on = b.dataset.id === id;
      any = any || on;
      b.classList.toggle('on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = on ? 0 : -1;
    });
    if (!any) { var f = box.querySelector('.pf-pick'); if (f) f.tabIndex = 0; }
  }
  var picsGrid = views.avatars.querySelector('[data-pf-grid="pics"]');
  var picSaving = 0;
  function pfOpenPics() {
    clearNotes();
    showView('avatars');
    buildGrid(picsGrid, pickPicture).then(function () {
      markGrid(picsGrid, pf.avatar);
      var on = picsGrid.querySelector('.pf-pick.on') || picsGrid.querySelector('.pf-pick');
      if (on) setTimeout(function () { on.focus({ preventScroll: true }); if (on.scrollIntoView) on.scrollIntoView({ block: 'nearest' }); }, reduce ? 0 : 220);
    }, function () { fail(views.avatars, NET); });
  }
  // Saved at once (free): the tick moves now, the server confirms; a refusal puts the old one back.
  function pickPicture(id, b) {
    var before = pf.avatar;
    if (id === before) return;
    clearNotes();
    pf.avatar = id;
    markGrid(picsGrid, id);
    b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop');
    pfPaintAll();
    var mine = ++picSaving;
    saveProfile({ avatar: id }).then(function (r) {
      if (mine !== picSaving) return;
      if (r.status !== 200) { pf.avatar = before; markGrid(picsGrid, before); pfPaintAll(); fail(views.avatars, fixStop(r.json && r.json.error)); }
    }, function (err) {
      if (mine !== picSaving) return;
      pf.avatar = before; markGrid(picsGrid, before); pfPaintAll();
      if (!err || err.message !== 'signed out') fail(views.avatars, NET);
    });
  }

  // ---- once, right after signing up: "Choose your nickname & avatar" ---------------------------------
  var setupView = views.setup, setupForm = setupView.querySelector('.pf-form');
  var setupNick = nickField(setupView);
  var setupGrid = setupView.querySelector('[data-pf-grid="setup"]');
  var setupBtn = setupForm.querySelector('.si-submit');
  var setupPick = null, setupThen = null;
  function setupHero() {
    var shown = setupNick.value();
    pfFace(setupView.querySelector('.pf-hero'), setupPick, (shown || pfInitial()).charAt(0).toUpperCase());
    pfTint(setupView, setupPick);
  }
  setupNick.onstate = function (st) {
    setupHero();
    setupBtn.disabled = st === 'taken' || st === 'not-allowed' || st === 'invalid' || st === 'checking' || (st === 'idle' && !setupPick);
  };
  /** Shown instead of the welcome card after a sign-up (once: a new account has no nickname); `then` shows it. */
  function pfSetup(then) {
    setupThen = then;
    setupPick = null;
    clearNotes();
    showView('setup');
    setupNick.fill('');
    setupHero();
    buildGrid(setupGrid, function (id, b) {
      setupPick = id;
      markGrid(setupGrid, id);
      b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop');
      setupNick.onstate(setupNick.state());
    }).then(function () { markGrid(setupGrid, null); setupHero(); }, function () { setupDone(); });
    pfLoad();
  }
  function setupDone() { var t = setupThen; setupThen = null; if (t) t(); }
  setupView.querySelector('[data-act="pf-later"]').addEventListener('click', setupDone);
  setupForm.addEventListener('submit', function (e) {
    e.preventDefault();
    if (setupBtn.disabled) return;
    clearNotes();
    var body = {};
    if (setupNick.value()) body.name = setupNick.value();
    if (setupPick) body.avatar = setupPick;
    if (!body.name && !body.avatar) return setupDone();
    busy(setupBtn, true, 'Saving…');
    saveProfile(body).then(function (r) {
      busy(setupBtn, false, 'Save');
      if (r.status !== 200) return nickErr(setupView, setupNick, r);
      setupDone();
    }, function (err) { busy(setupBtn, false, 'Save'); if (!err || err.message !== 'signed out') fail(setupView, NET); });
  });
  var pfWelcome = welcome;
  welcome = function (made, offline, reset) {
    if (made && !offline && !reset && isSignedIn() && !pf.name && siView !== 'setup') return pfSetup(function () { pfWelcome(made, offline, reset); });
    return pfWelcome(made, offline, reset);
  };

  // Signed in (now, on every visit, after signing in): the profile, and the pictures in the background.
  var pfBaseShow = showView;
  showView = function (name) { pfBaseShow(name); if (name === 'account') { pfPaintAll(); pfLoad(); } };
  var pfBaseSignedIn = signedIn;
  signedIn = function (token, account) { pf.loaded = false; pf.name = null; pf.avatar = null; pf.online = false; pfBaseSignedIn(token, account); pfLoad(); };
  if (isSignedIn()) {
    var h = pfHere();
    pf.name = h.name; pf.avatar = h.avatar;
    if (pf.avatar) needAvatars().then(pfPaintNav, function () {});
    setTimeout(function () { pfLoad().then(function () { if (pf.avatar) needAvatars().then(pfPaintAll, function () {}); }); }, 400);
  }
  window.AllFunProfile = {
    /** Opens the sign-in sheet on the profile ('account', 'nick' or 'avatars'). */
    open: function (view) { if (!si.isOpen()) si.open(); if (isSignedIn()) pfOpen(view || 'account'); },
    get: function () { return { name: pf.name, avatar: pf.avatar }; },
    onChange: function (fn) { pfListeners.push(fn); },
    avatars: needAvatars
  };

  // ==== THE WALLET (20.10) =========================================================================
  // Owner, 20.10: one coin economy for the whole site. The header's coin chip ([data-wallet-open]) opens this
  // sheet: the balance (it counts up), what a game costs, and the ways to get coins —
  //  - a guest: the welcome gift still waiting, the day's free games ("2 free games today · N left"), and the
  //    gold card "Sign up so you don't lose your coins · +800" (the sign-up sheet above);
  //  - a member: the day's top-up, "Share AllFun · +120" (3 a day: the system share sheet, or WhatsApp / a
  //    copied link on a computer) and "Invite a friend · +1,000 each" (the link, Copy / Share / WhatsApp, the
  //    friends who joined and the coins earned).
  // "Watch a video · +80" is not here: the site has no video player of its own (the games offer it).
  // With no server (a static copy, offline) the sign-up, share and invite rows stay hidden.
  // Never name Facebook in the reward (Meta's platform policy): the share is a generic "Share AllFun".
  var WL_ICON = {
    share: '<svg viewBox="0 0 24 24"><path d="M12 3.5v11M7.5 8L12 3.5 16.5 8"/><path d="M5 12.5v6a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-6"/></svg>',
    friend: '<svg viewBox="0 0 24 24"><circle cx="9" cy="8.2" r="3.2"/><path d="M3.2 19.5v-.6A4.8 4.8 0 0 1 8 14.1h2a4.8 4.8 0 0 1 4.8 4.8v.6"/><path d="M18.5 8.5v6M15.5 11.5h6"/></svg>',
    calendar: '<svg viewBox="0 0 24 24"><rect x="3.5" y="5" width="17" height="15" rx="3"/><path d="M3.5 10h17M8 3v4M16 3v4"/><path d="M9 14.5l2 2 4-4"/></svg>',
    gift: '<svg viewBox="0 0 24 24"><rect x="4" y="10" width="16" height="10" rx="2"/><path d="M3 7h18v3H3zM12 7v13M12 7c-2-3-5.5-3.5-6-1.5S9 7 12 7zM12 7c2-3 5.5-3.5 6-1.5S15 7 12 7z"/></svg>',
    ticket: '<svg viewBox="0 0 24 24"><path d="M4 7.5A1.5 1.5 0 0 1 5.5 6h13A1.5 1.5 0 0 1 20 7.5v2a2.5 2.5 0 0 0 0 5v2a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 16.5v-2a2.5 2.5 0 0 0 0-5z"/><path d="M14 6.5v11" stroke-dasharray="2 2"/></svg>',
    copy: '<svg viewBox="0 0 24 24"><rect x="8.5" y="8.5" width="11" height="11" rx="2.4"/><path d="M15.5 8.5V6.4a2 2 0 0 0-2-2H6.4a2 2 0 0 0-2 2v7.1a2 2 0 0 0 2 2h2.1"/></svg>',
    chat: '<svg viewBox="0 0 24 24"><path d="M4.5 19.5l1.2-3.6A8 8 0 1 1 8.4 18.6z"/><path class="f" d="M9.3 9.4c.3 2.4 2.5 4.7 5 5.1l1-1.3-1.8-1-1 .8c-.9-.4-1.6-1.1-2-2l.8-1-1-1.8z"/></svg>',
    lock: '<svg viewBox="0 0 24 24"><rect x="5" y="10.5" width="14" height="9.5" rx="2.4"/><path d="M8.3 10.5V8a3.7 3.7 0 0 1 7.4 0v2.5"/></svg>',
    arrow: '<svg viewBox="0 0 24 24"><path d="M5 12h13M13 6l6 6-6 6"/></svg>'
  };
  var WL_COIN = '<i class="wl-c" aria-hidden="true"></i>';
  var SHARE_TEXT = 'AllFun Games: free games, one tap away. Come play with me!';
  var SITE_LINK = 'https://allfun.games/';

  // A short note at the top of the screen with a coin (`big`: a celebration, with sparks).
  var wlToastEl = null, wlToastTimer = 0;
  function wlToast(text, big) {
    if (!wlToastEl) {
      wlToastEl = document.createElement('div');
      wlToastEl.className = 'wl-toast';
      wlToastEl.setAttribute('role', 'status');
      wlToastEl.setAttribute('aria-live', 'polite');
      document.body.appendChild(wlToastEl);
    }
    wlToastEl.classList.remove('show', 'big');
    wlToastEl.innerHTML = '<span class="wl-toast-coin" aria-hidden="true">' + WL_COIN + '<i class="sp s1"></i><i class="sp s2"></i><i class="sp s3"></i><i class="sp s4"></i></span><span class="wl-toast-tx"></span>';
    wlToastEl.querySelector('.wl-toast-tx').textContent = text;
    void wlToastEl.offsetWidth;
    wlToastEl.classList.add('show');
    if (big) wlToastEl.classList.add('big');
    clearTimeout(wlToastTimer);
    wlToastTimer = setTimeout(function () { wlToastEl.classList.remove('show'); }, big ? 5200 : 2800);
  }

  function copyText(text) {
    return new Promise(function (done) {
      var fallback = function () {
        try {
          var t = document.createElement('textarea');
          t.value = text; t.setAttribute('readonly', ''); t.style.cssText = 'position:fixed;opacity:0;left:0;top:0';
          document.body.appendChild(t); t.select();
          var ok = document.execCommand('copy'); t.remove(); done(!!ok);
        } catch (e) { done(false); }
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(function () { done(true); }, fallback);
      else fallback();
    });
  }
  function canShare() { return typeof navigator.share === 'function'; }
  function whatsApp(text) { return 'https://wa.me/?text=' + encodeURIComponent(text); }
  // Opens WhatsApp in a new window; `paid` runs once it has been open (or this page away) for 5 seconds — a
  // tap that is closed again at once does not count.
  function openAway(url, paid) {
    var w = null, t0 = Date.now(), hidAt = 0, away = 0, done = false, timer = 0, end = 0;
    try { w = window.open(url, '_blank'); if (w) w.opener = null; } catch (e) { /* blocked */ }
    function finish() { document.removeEventListener('visibilitychange', vis); clearTimeout(timer); clearTimeout(end); }
    function check() {
      if (done) return;
      var open = false;
      try { open = !!w && !w.closed && Date.now() - t0 >= 5000; } catch (e) { open = false; }
      if (open || away >= 5000) { done = true; finish(); if (paid) paid(); }
    }
    function vis() {
      if (document.visibilityState === 'hidden') hidAt = Date.now();
      else if (hidAt) { away += Date.now() - hidAt; hidAt = 0; check(); }
    }
    document.addEventListener('visibilitychange', vis);
    timer = setTimeout(check, 5100);
    end = setTimeout(finish, 10 * 60 * 1000);
    return !!w;
  }

  // ---- "A friend invited you": a link with ?ref= brought a visitor who has no account ----------------------
  var refBanner = null;
  function refBannerHide() {
    var b = refBanner;
    if (!b) return;
    refBanner = null;
    b.classList.remove('in');
    setTimeout(function () { b.remove(); }, reduce ? 0 : 320);
  }
  (function refArrival() {
    var W = window.AllFunWallet;
    var code = null;
    try { code = W && W.refArrived ? W.refArrived() : null; } catch (e) { code = null; }
    if (!code || isSignedIn() || (W && W.mode() === 'member')) return;
    var coins = fmt((W && W.INVITE_COINS) || 1000);
    refBanner = document.createElement('div');
    refBanner.className = 'wl-ref';
    refBanner.setAttribute('role', 'region');
    refBanner.setAttribute('aria-label', 'Invite');
    refBanner.innerHTML = '<span class="wl-ref-ic" aria-hidden="true">' + WL_ICON.gift + '</span>' +
      '<p class="wl-ref-tx"><b>A friend invited you</b><span class="wl-ref-sep"> — </span><span>sign up and you both get <em>' + coins + ' coins</em></span></p>' +
      '<button class="wl-ref-go" type="button">Sign up</button>' +
      '<button class="wl-ref-x" type="button" aria-label="Dismiss"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button>';
    document.body.appendChild(refBanner);
    refBanner.querySelector('.wl-ref-go').addEventListener('click', function () { openSignin(this, 'signup'); });
    refBanner.querySelector('.wl-ref-x').addEventListener('click', refBannerHide);
    setTimeout(function () { if (refBanner) refBanner.classList.add('in'); }, reduce ? 0 : 450);
  })();

  // ---- the sheet ---------------------------------------------------------------------------------------
  var wlRoot = document.getElementById('wallet-pop');
  var W = window.AllFunWallet;
  var wl = null;
  if (W && wlRoot) (function () {
    var bal = wlRoot.querySelector('[data-wl-bal]');
    var views = { main: wlRoot.querySelector('[data-wl-view="main"]'), invite: wlRoot.querySelector('[data-wl-view="invite"]') };
    var title = document.getElementById('wl-title'), sub = document.getElementById('wl-sub');
    var backBtn = wlRoot.querySelector('.wl-back');
    var view = 'main', shown = null, server = null, inv = null, tick = 0;

    function setBalance(b, gained) {
      var from = shown === null ? Math.floor(b * 0.55) : shown;
      shown = b;
      if (gained > 0) {
        var g = document.createElement('i');
        g.className = 'wl-gain';
        g.textContent = '+' + fmt(gained);
        bal.parentNode.appendChild(g);
        setTimeout(function () { g.remove(); }, 1500);
        var box = bal.parentNode; box.classList.remove('bump'); void box.offsetWidth; box.classList.add('bump');
      }
      if (reduce || from === b || typeof requestAnimationFrame !== 'function') { bal.textContent = fmt(b); return; }
      var t0 = performance.now(), ms = gained > 0 ? 600 : 750;
      (function step() {
        requestAnimationFrame(function (t) {
          var k = Math.min(1, (t - t0) / ms);
          bal.textContent = fmt(Math.round(from + (b - from) * (1 - Math.pow(1 - k, 3))));
          if (k < 1 && shown === b) step(); else if (shown === b) bal.textContent = fmt(b);
        });
      })();
    }

    function line(cls, icon, main, small) {
      return '<p class="wl-line' + (cls ? ' ' + cls : '') + '">' + icon + '<span><b>' + main + '</b>' + (small ? '<small>' + small + '</small>' : '') + '</span></p>';
    }
    function way(key, icon, a, b, label, plus, small) {
      return '<button class="wl-way" type="button" data-wl="' + key + '"><span class="wl-pi" style="--a:' + a + ';--b:' + b + '" aria-hidden="true">' + icon + '</span>' +
        '<b class="wl-wl">' + label + '</b><span class="wl-sr"> · </span><em class="wl-plus">' + WL_COIN + plus + '</em><small class="wl-ws" data-wl-small>' + esc(small) + '</small></button>';
    }
    function topupLine() {
      // The server marks the day used only when it gave coins, and says how many only in that one answer:
      // 'given' and 'used' are the same day for the player.
      var t = W.topupStatus(), to = fmt(t.to);
      if (t.today === 'given' || t.today === 'used') return line('', WL_ICON.calendar, 'Topped up to ' + to + ' today', 'Next top-up tomorrow');
      if (t.today === 'ready') return line('', WL_ICON.calendar, 'Daily top-up ready', 'Back to ' + to + ' when you run low today');
      return line('', WL_ICON.calendar, 'Daily top-up to ' + to, 'Every day, when you run low');
    }
    function shareSmall() { var n = W.sharesLeft(); return n > 0 ? n + ' left today' : 'Back tomorrow'; }
    function inviteSmall() {
      if (inv && inv.friends.length) return plural(inv.friends.length, 'friend', 'friends') + ' joined so far';
      return 'You both get it';
    }

    function renderMain() {
      var member = W.mode() === 'member';
      var returning = !member && W.registered();
      var up = server === true;
      var h = '';
      if (member) h += topupLine();
      else {
        if (W.welcomeDue()) h += line('gold', WL_ICON.gift, 'Welcome gift waiting: +' + fmt(W.SITE_WELCOME), 'It comes with your first coin game');
        if (!returning) {
          var left = W.freeGamesLeft(), per = W.GUEST_FREE_PER_DAY;
          h += left > 0 ? line('', WL_ICON.ticket, per + ' free games today · ' + left + ' left', 'For any arcade or sport game')
            : line('dim', WL_ICON.calendar, per + ' free games today · all played', 'Back tomorrow, or sign up for a daily top-up');
        }
      }
      var rows = [];
      if (member && up) {
        rows.push(way('share', WL_ICON.share, '#4d9aff', '#1a3a9c', 'Share AllFun Games', '+' + fmt(W.SHARE_COINS), shareSmall()));
        rows.push('<div class="wl-split" data-wl-split hidden></div>');
        rows.push(way('invite', WL_ICON.friend, '#ff8fb0', '#a8295a', 'Invite a friend', '+' + fmt(W.INVITE_COINS) + '<small>each</small>', inviteSmall()));
      }
      if (rows.length) h += '<div class="wl-ways">' + rows.join('') + '</div>';
      if (!member && up) {
        h += returning
          ? '<button class="wl-gold" type="button" data-wl="login"><span class="wl-gold-ic" aria-hidden="true">' + WL_ICON.lock + '</span><span class="wl-gold-tx"><b>Log in to your coins</b><small>Your coins and daily top-up are in your account</small></span><span class="wl-gold-go" aria-hidden="true">' + WL_ICON.arrow + '</span></button>'
          : '<button class="wl-gold" type="button" data-wl="signup"><span class="wl-gold-tx"><b>Sign up so you don’t lose your coins</b><small>Free · and a daily top-up to ' + fmt(W.TOPUP_TO) + '</small></span><em class="wl-gold-plus">' + WL_COIN + '+' + fmt(W.SIGNUP_BONUS) + '</em></button>' +
            '<p class="wl-fine">Have an account? <button type="button" data-wl="login">Log in</button></p>';
      }
      h += '<button class="wl-later" type="button" data-close>Close</button>';
      views.main.innerHTML = h;
      paintLive();
    }

    // What changes by the second: the shares left.
    function paintLive() {
      var s = views.main.querySelector('[data-wl="share"]');
      if (s) {
        var none = W.sharesLeft() <= 0;
        if (s.dataset.busy !== '1') s.disabled = none;
        var sm = s.querySelector('[data-wl-small]');
        if (sm && sm.textContent !== shareSmall()) sm.textContent = shareSmall();
      }
      var iv = views.main.querySelector('[data-wl="invite"] [data-wl-small]');
      if (iv && iv.textContent !== inviteSmall()) iv.textContent = inviteSmall();
    }

    function setView(name) {
      view = name;
      views.main.hidden = name !== 'main';
      views.invite.hidden = name !== 'invite';
      backBtn.hidden = name !== 'invite';
      wlRoot.classList.toggle('wl-inv-on', name === 'invite');
      var v = views[name];
      v.classList.remove('in'); void v.offsetWidth; v.classList.add('in');
      if (name === 'invite') {
        title.textContent = 'Invite a friend';
        sub.innerHTML = 'When your friend signs up, you both get <b>' + fmt(W.INVITE_COINS) + ' coins</b>.';
      } else {
        title.textContent = 'Your coins';
        sub.textContent = fmt(W.gamePrice()) + ' coins a game · puzzles & solitaire always free';
      }
      var body = wlRoot.querySelector('.wl-body'); if (body) body.scrollTop = 0;
    }

    function friendRow(f) {
      var d = f.at ? new Date(f.at).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : '';
      var right = f.coins > 0 ? '<em>' + WL_COIN + '+' + fmt(f.coins) + '</em>'
        : '<small class="st-' + esc(f.status) + '">' + (f.status === 'held' ? 'Coming tomorrow' : f.status === 'refused' ? 'Not counted' : 'Checking') + '</small>';
      var ch = (f.label.charAt(0) || '?').toUpperCase();
      return '<li><span class="wl-fav" aria-hidden="true">' + esc(ch) + '</span><span class="wl-fr"><b>' + esc(f.label) + '</b>' + (d ? '<small>Joined ' + esc(d) + '</small>' : '') + '</span>' + right + '</li>';
    }
    function renderInvite(info) {
      if (!info) {
        views.invite.innerHTML = '<p class="wl-empty">Your invite link isn’t ready yet. Try again in a moment.</p><button class="wl-later" type="button" data-wl="main">Back</button>';
        return;
      }
      var link = info.link.replace(/^https?:\/\//, '');
      var n = info.friends.length;
      views.invite.innerHTML =
        '<div class="wl-link"><span class="wl-link-tx" data-wl-url>' + esc(link) + '</span><button type="button" data-wl="copy">' + WL_ICON.copy + '<span>Copy</span></button></div>' +
        '<div class="wl-send">' + (canShare() ? '<button class="wl-btn gold" type="button" data-wl="send">' + WL_ICON.share + 'Share</button>' : '') +
          '<button class="wl-btn wa" type="button" data-wl="wa">' + WL_ICON.chat + 'WhatsApp</button></div>' +
        '<div class="wl-stats"><div><b>' + fmt(n) + '</b><span>' + (n === 1 ? 'friend joined' : 'friends joined') + '</span></div><div><b>' + (info.earned > 0 ? '+' : '') + fmt(info.earned) + '</b><span>coins earned</span></div></div>' +
        (n ? '<ul class="wl-friends">' + info.friends.slice(0, 20).map(friendRow).join('') + '</ul>'
          : '<p class="wl-empty">No friends have joined yet. Your first one is worth <b>+' + fmt(W.INVITE_COINS) + '</b>.</p>') +
        '<p class="wl-fine">Paid when your friend signs up with their own email.</p>' +
        '<button class="wl-later" type="button" data-wl="main">Back</button>';
    }
    function openInvite() {
      setView('invite');
      if (inv) renderInvite(inv);
      else views.invite.innerHTML = '<p class="wl-empty wl-wait"><i class="wl-spin" aria-hidden="true"></i>Getting your link…</p>';
      W.referral().then(function (info) {
        if (info) inv = info;
        if (view === 'invite' && wl.isOpen()) renderInvite(inv);
      });
    }

    function earned(coins, text) {
      if (!(coins > 0)) return;
      // The wallet's change listener (below) counts the balance up with a "+N"; this one only says thanks.
      if (shown !== null && shown !== W.balance() && wl.isOpen()) setBalance(W.balance(), coins);
      wlToast(text);
      paintLive();
    }
    function inviteText() { return 'Join me on AllFun Games: sign up with my link and we both get ' + fmt(W.INVITE_COINS) + ' coins.'; }
    function shareUrl() { return inv ? inv.link : SITE_LINK; }

    function onShare(btn) {
      if (W.sharesLeft() <= 0) return;
      if (canShare()) {
        btn.dataset.busy = '1'; btn.disabled = true;
        // The member's link (asked for when the sheet opened, so the share sheet opens at once on the tap).
        navigator.share({ title: 'AllFun Games', text: SHARE_TEXT, url: shareUrl() }).then(function () {
          earned(W.claimShare('site'), '+' + fmt(W.SHARE_COINS) + ' coins · thanks for sharing!');
        }, function () { /* closed without sharing: nothing */ }).then(function () { delete btn.dataset.busy; paintLive(); });
        return;
      }
      // No share sheet (most computers): WhatsApp, or copy the link (copying pays nothing: nothing was sent yet).
      var split = views.main.querySelector('[data-wl-split]');
      if (!split) return;
      split.innerHTML = '<button type="button" data-wl="wa-share">' + WL_ICON.chat + 'WhatsApp</button><button type="button" data-wl="copy-share">' + WL_ICON.copy + 'Copy link</button>';
      split.hidden = !split.hidden;
    }

    wl = makeSheet(wlRoot, {
      grab: '.cp-grab, .wl-art, .wl-brand',
      render: function () {
        shown = null;
        setView('main');
        renderMain();
        setBalance(W.balance(), 0);
        clearInterval(tick);
        tick = setInterval(paintLive, 1000);
        // The server's word (top-up, shares left) and whether it is there at all.
        W.serverUp().then(function (on) {
          var was = server;
          server = on;
          if (on !== was && view === 'main' && wl.isOpen()) renderMain();
          if (on && W.mode() === 'member') W.referral().then(function (info) { if (info) { inv = info; if (wl.isOpen()) paintLive(); } });
        });
        W.flush().then(function () { if (wl.isOpen() && view === 'main') { renderMain(); if (shown !== W.balance()) setBalance(W.balance(), 0); } });
      },
      closed: function () { clearInterval(tick); setView('main'); },
      fallback: function () { return document.querySelector('.nav-coins'); }
    });
    if (W.mode() === 'member') server = true; // signed in through the server: draw its rows at once

    wlRoot.addEventListener('click', function (e) {
      var t = e.target.closest('[data-wl]');
      if (!t || !wlRoot.contains(t)) return;
      var act = t.dataset.wl;
      if (act === 'main') { setView('main'); renderMain(); wl.panel.focus({ preventScroll: true }); return; }
      if (act === 'share') { onShare(t); return; }
      if (act === 'wa-share') {
        var url = shareUrl();
        openAway(whatsApp(SHARE_TEXT + ' ' + url), function () { earned(W.claimShare('site'), '+' + fmt(W.SHARE_COINS) + ' coins · thanks for sharing!'); });
        var sp = views.main.querySelector('[data-wl-split]'); if (sp) sp.hidden = true;
        return;
      }
      if (act === 'copy-share') { copyText(shareUrl()).then(function (ok) { wlToast(ok ? 'Link copied' : shareUrl()); }); return; }
      if (act === 'invite') { openInvite(); return; }
      if (act === 'copy') {
        if (!inv) return;
        copyText(inv.link).then(function (ok) {
          wlToast(ok ? 'Invite link copied' : inv.link);
          var lb = t.querySelector('span');
          if (ok && lb) { lb.textContent = 'Copied'; setTimeout(function () { lb.textContent = 'Copy'; }, 1600); }
        });
        return;
      }
      if (act === 'send') { if (inv && canShare()) navigator.share({ title: 'AllFun Games', text: inviteText(), url: inv.link }).catch(function () {}); return; }
      if (act === 'wa') { if (inv) openAway(whatsApp(inviteText() + ' ' + inv.link)); return; }
      if (act === 'signup' || act === 'login') {
        wl.close();
        setTimeout(function () { openSignin(document.querySelector('.nav-coins'), act); }, reduce ? 0 : 180);
      }
    });

    W.onChange(function (b) {
      if (!wl.isOpen()) return;
      if (shown !== null && b !== shown) setBalance(b, b > shown ? b - shown : 0);
      if (view === 'main') renderMain();
    });
  })();
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-wallet-open]');
    if (!b || !wl) return;
    e.preventDefault();
    wl.open(b);
  });
  window.AllFunWalletSheet = { open: function () { if (wl) wl.open(); }, close: function () { if (wl) wl.close(); }, isOpen: function () { return !!wl && wl.isOpen(); } }; // for testing in the browser

  // ---- Install AllFun (the footer's card and the menu's small button) -------------------------------
  // Owner, 17.10: "a Download button that saves the site to the home screen, because people get confused".
  // Chrome, Edge and Android hand us an install prompt (beforeinstallprompt): one tap shows the browser's own
  // dialog. iPhone and iPad have no such prompt, so the button opens a short animated guide instead (Share › Add to
  // Home Screen › Add, with Safari 26's ••• menu), and in Facebook / Instagram's built-in browser it first asks to
  // open the page in Safari. Opened from the home screen (or installed here), the buttons hide.
  var INSTALL_KEY = 'allfun.install.v1';
  var installEvt = null;
  var ua = navigator.userAgent || '';
  var isIPad = /iPad/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
  var isIOS = /iPhone|iPod/.test(ua) || isIPad;
  var isAndroid = /Android/.test(ua);
  var inApp = /FBAN|FBAV|FB_IAB|FBIOS|Instagram|Messenger|LinkedInApp|Snapchat|TikTok|musical_ly|BytedanceWebview|Pinterest|Line\/|Twitter|GSA\//.test(ua) ||
    (isIOS && !isIPad && !/Safari\//.test(ua)) || (isAndroid && /; wv\)/.test(ua));
  function standalone() {
    try {
      return navigator.standalone === true || window.matchMedia('(display-mode: standalone)').matches ||
        window.matchMedia('(display-mode: fullscreen)').matches || window.matchMedia('(display-mode: minimal-ui)').matches;
    } catch (e) { return false; }
  }
  function installMode() {
    if (inApp) return 'inapp';
    if (isIOS) {
      if (/CriOS|FxiOS|EdgiOS|OPiOS|YaBrowser|DuckDuckGo/.test(ua)) return 'ios-other';
      if (isIPad) return 'ipad';
      var v = /Version\/(\d+)/.exec(ua);
      return v && Number(v[1]) >= 26 ? 'ios26' : 'ios';
    }
    return isAndroid ? 'android' : 'desktop';
  }
  function renderInstall() {
    var hide = standalone() || (!installEvt && !!(read(INSTALL_KEY) || {}).installed);
    document.querySelectorAll('[data-install]').forEach(function (b) { b.hidden = hide; });
  }
  window.addEventListener('beforeinstallprompt', function (e) {
    e.preventDefault(); // our own button asks, when the visitor taps it
    installEvt = e;
    write(INSTALL_KEY, {}); // installable again: it was removed, or never installed
    renderInstall();
  });
  window.addEventListener('appinstalled', function () {
    installEvt = null;
    write(INSTALL_KEY, { installed: Date.now() });
    renderInstall();
  });
  renderInstall();

  // The guide's pictures: small drawings of the browser's own buttons (iOS blue on dark, like Safari in dark mode).
  var G = {
    share: '<svg viewBox="0 0 24 24"><path d="M8.6 9.4H7.4A2.4 2.4 0 0 0 5 11.8v7.4a2.4 2.4 0 0 0 2.4 2.4h9.2a2.4 2.4 0 0 0 2.4-2.4v-7.4a2.4 2.4 0 0 0-2.4-2.4h-1.2M12 2.8v11.4M8.6 6.2 12 2.8l3.4 3.4"/></svg>',
    add: '<svg viewBox="0 0 24 24"><rect x="4" y="4" width="16" height="16" rx="4.2"/><path d="M12 8.4v7.2M8.4 12h7.2"/></svg>',
    dots: '<svg viewBox="0 0 24 24"><circle cx="5.5" cy="12" r="1.9" class="f"/><circle cx="12" cy="12" r="1.9" class="f"/><circle cx="18.5" cy="12" r="1.9" class="f"/></svg>',
    kebab: '<svg viewBox="0 0 24 24"><circle cx="12" cy="5.5" r="1.9" class="f"/><circle cx="12" cy="12" r="1.9" class="f"/><circle cx="12" cy="18.5" r="1.9" class="f"/></svg>',
    screen: '<svg viewBox="0 0 24 24"><rect x="3" y="4.4" width="18" height="12.6" rx="2.2"/><path d="M8.5 20.4h7M12 7.6v5.8M9.6 11.1 12 13.5l2.4-2.4"/></svg>',
    safari: '<svg viewBox="0 0 24 24"><circle cx="12" cy="12" r="9"/><path d="M15.6 8.4 13.3 13.3 8.4 15.6 10.7 10.7Z" class="f"/></svg>'
  };
  var g = function (k) { return '<i class="ins-g">' + G[k] + '</i>'; };
  var TAP = '<circle class="ins-tap" r="9"/>';
  var ICON_SVG = function (k, x, y, s, cls) {
    return '<g class="' + (cls || '') + '" transform="translate(' + x + ' ' + y + ') scale(' + (s / 24) + ') translate(-12 -12)">' + G[k].replace(/^<svg[^>]*>|<\/svg>$/g, '') + '</g>';
  };
  var at = function (x, y, inner) { return '<g transform="translate(' + x + ' ' + y + ')">' + inner + '</g>'; };
  var D = {
    // Safari on iPhone (iOS 15–18): the address bar above five buttons, Share in the middle.
    ios: '<rect x="1" y="6" width="110" height="52" rx="13" class="bar"/><rect x="12" y="13" width="88" height="15" rx="7.5" class="pill"/><text x="56" y="24" class="url">allfun.games</text>' +
      '<path d="M14 38l-4 5 4 5M30 38l4 5-4 5" class="ic dim"/>' + ICON_SVG('share', 56, 43, 15, 'ic hot') + at(56, 43, TAP) +
      '<path d="M71 38.6q3.6-1.8 7.2 0v9.6q-3.6-1.8-7.2 0zM78.2 38.6q3.6-1.8 7.2 0v9.6q-3.6-1.8-7.2 0z" class="ic dim"/><rect x="92" y="39.5" width="8.5" height="8.5" rx="2" class="ic dim"/><path d="M95 36.5h6.5a1.5 1.5 0 0 1 1.5 1.5v6.5" class="ic dim"/>',
    // Safari 26 on iPhone: back, the address, and ••• (Share lives in that menu).
    ios26: '<rect x="1" y="14" width="110" height="36" rx="18" class="bar"/><path d="M15 26l-5 6 5 6" class="ic dim"/><rect x="24" y="21" width="58" height="22" rx="11" class="pill"/><text x="53" y="35.5" class="url">allfun.games</text>' +
      '<circle cx="96" cy="32" r="11" class="pill"/>' + ICON_SVG('dots', 96, 32, 15, 'ic hot') + at(96, 32, TAP),
    // Safari on iPad: Share near the top right.
    ipad: '<rect x="1" y="12" width="110" height="30" rx="9" class="bar"/><rect x="22" y="18" width="52" height="18" rx="6" class="pill"/><text x="48" y="30.5" class="url">allfun.games</text>' +
      '<rect x="7" y="21" width="9" height="12" rx="2" class="ic dim"/>' + ICON_SVG('share', 86, 26.5, 13, 'ic hot') + at(86, 27, TAP) + '<path d="M97 27h8M101 23v8" class="ic dim"/>',
    // Chrome / Firefox / Edge on iPhone: Share at the right of the address bar.
    iosOther: '<rect x="1" y="12" width="110" height="30" rx="9" class="bar"/><rect x="8" y="18" width="74" height="18" rx="9" class="pill"/><text x="45" y="30.5" class="url">allfun.games</text>' +
      ICON_SVG('share', 96, 26.5, 13, 'ic hot') + at(96, 27, TAP),
    // The share sheet: Add to Home Screen.
    sheet: '<rect x="4" y="2" width="104" height="60" rx="11" class="bar"/><text x="13" y="17.5" class="row dim">Copy</text>' + ICON_SVG('share', 96, 14, 10, 'ic dim') +
      '<rect x="7" y="23" width="98" height="18" rx="6" class="hl"/><text x="12" y="35.2" class="row sm">Add to Home Screen</text>' + ICON_SVG('add', 97, 32, 11, 'ic hot') + at(48, 32, TAP) +
      '<text x="13" y="54.5" class="row dim">Add Bookmark</text>',
    // The last screen: Add at the top right.
    add: '<rect x="4" y="2" width="104" height="60" rx="11" class="bar"/><text x="12" y="17" class="row blue">Cancel</text><text x="98" y="17" class="row blue strong" text-anchor="end">Add</text>' + at(88, 13, TAP) +
      '<image href="/apple-touch-icon.png" x="12" y="28" width="24" height="24"/><rect x="42" y="31" width="58" height="18" rx="5" class="pill"/><text x="48" y="43.5" class="row">AllFun</text>',
    // Android: ⋮ at the top right, Install app, Install.
    android: '<rect x="1" y="12" width="110" height="30" rx="9" class="bar"/><rect x="8" y="18" width="78" height="18" rx="9" class="pill"/><text x="47" y="30.5" class="url">allfun.games</text>' +
      ICON_SVG('kebab', 99, 27, 15, 'ic hot') + at(99, 27, TAP),
    amenu: '<rect x="4" y="2" width="104" height="60" rx="11" class="bar"/><text x="13" y="17.5" class="row dim">New tab</text>' +
      '<rect x="7" y="23" width="98" height="18" rx="6" class="hl"/>' + ICON_SVG('screen', 18, 32, 11, 'ic hot') + '<text x="28" y="35.5" class="row">Install app</text>' + at(60, 32, TAP) +
      '<text x="13" y="54.5" class="row dim">Settings</text>',
    adialog: '<rect x="4" y="4" width="104" height="56" rx="12" class="bar"/><image href="/apple-touch-icon.png" x="12" y="12" width="18" height="18"/><text x="36" y="25" class="row">Install app?</text>' +
      '<text x="56" y="51" class="row blue">Cancel</text><rect x="74" y="39" width="28" height="16" rx="8" class="btnfill"/><text x="88" y="50.5" class="row ink" text-anchor="middle">Install</text>' + at(88, 47, TAP),
    // A computer: the install icon in the address bar.
    desktop: '<rect x="1" y="12" width="110" height="30" rx="9" class="bar"/><rect x="8" y="18" width="96" height="18" rx="9" class="pill"/><text x="44" y="30.5" class="url">allfun.games</text>' +
      ICON_SVG('screen', 93, 27, 12, 'ic hot') + at(93, 27, TAP),
    // An app's own browser (Facebook, Instagram …): ••• at the top right, then Open in browser.
    inapp: '<rect x="1" y="12" width="110" height="30" rx="9" class="bar"/><path d="M10 22l8 8M18 22l-8 8" class="ic dim"/><text x="52" y="30.5" class="url">allfun.games</text>' +
      ICON_SVG('dots', 97, 27, 15, 'ic hot') + at(97, 27, TAP),
    imenu: '<rect x="4" y="2" width="104" height="60" rx="11" class="bar"/><text x="13" y="17.5" class="row dim">Copy link</text>' +
      '<rect x="7" y="23" width="98" height="18" rx="6" class="hl"/>' + ICON_SVG('safari', 18, 32, 11, 'ic hot') + '<text x="28" y="35.5" class="row">Open in browser</text>' + at(62, 32, TAP) +
      '<text x="13" y="54.5" class="row dim">Refresh</text>',
    ibtn: '<rect x="6" y="14" width="100" height="36" rx="12" class="btnfill2"/><text x="56" y="36" class="row strong" text-anchor="middle">Install AllFun</text>' + at(56, 32, TAP)
  };
  var demo = function (k) { return '<svg class="ins-demo" viewBox="0 0 112 64" aria-hidden="true">' + D[k] + '</svg>'; };
  function installSteps(mode) {
    var browser = isAndroid ? 'Chrome' : 'Safari';
    var S = {
      ios: { sub: 'Free, no app store. It opens full screen, like an app.', point: 'Safari’s Share button is just below', px: '50%',
        steps: [['Tap <b>Share</b> ' + g('share') + ' in Safari’s toolbar', 'ios'], ['Scroll down, tap <b>Add to Home Screen</b> ' + g('add'), 'sheet'], ['Tap <b>Add</b>. AllFun Games is on your Home Screen!', 'add']] },
      ios26: { sub: 'Free, no app store. It opens full screen, like an app.', point: 'Safari’s ••• button is just below', px: '88%',
        steps: [['Tap <b>•••</b> next to the address, then <b>Share</b> ' + g('share'), 'ios26'], ['Tap <b>Add to Home Screen</b> ' + g('add') + ' (under <b>More</b> if you don’t see it)', 'sheet'], ['Tap <b>Add</b>. AllFun Games is on your Home Screen!', 'add']] },
      ipad: { sub: 'Free, no app store. It opens full screen, like an app.', up: true,
        steps: [['Tap <b>Share</b> ' + g('share') + ' at the top of Safari', 'ipad'], ['Tap <b>Add to Home Screen</b> ' + g('add'), 'sheet'], ['Tap <b>Add</b>. AllFun Games is on your Home Screen!', 'add']] },
      'ios-other': { sub: 'Free, no app store. It opens full screen, like an app.',
        steps: [['Tap <b>Share</b> ' + g('share') + ' in the address bar', 'iosOther'], ['Tap <b>Add to Home Screen</b> ' + g('add'), 'sheet'], ['Tap <b>Add</b>. AllFun Games is on your Home Screen!', 'add']] },
      inapp: { sub: 'This app’s built-in browser can’t install AllFun Games. Open the page in ' + browser + ' first, it takes a second.', copy: true,
        steps: [['Tap ' + g('dots') + ' at the top right', 'inapp'], ['Choose <b>Open in browser</b> (or <b>Open in ' + browser + '</b>)', 'imenu'], ['There, tap <b>Install AllFun</b> again', 'ibtn']] },
      android: { sub: 'Free, no app store. It opens full screen, like an app.',
        steps: [['Tap <b>⋮</b> ' + g('kebab') + ' at the top right of your browser', 'android'], ['Tap <b>Install app</b> or <b>Add to Home screen</b>', 'amenu'], ['Tap <b>Install</b>. AllFun Games is on your home screen!', 'adialog']] },
      desktop: { sub: 'Free, no app store. AllFun Games gets its own window and icon.',
        steps: [['In Chrome or Edge, click the install icon ' + g('screen') + ' in the address bar', 'desktop'], ['Or open the browser’s menu and choose <b>Install AllFun Games</b>', 'amenu'], ['Safari on a Mac: <b>File › Add to Dock</b>', null]] }
    };
    return S[mode] || S.desktop;
  }
  var insRoot = document.getElementById('install-pop');
  var insMode = 'desktop';
  var ins = makeSheet(insRoot, {
    grab: '.cp-grab, .ins-app',
    render: function () {
      insMode = installMode();
      var d = installSteps(insMode);
      insRoot.dataset.mode = insMode;
      insRoot.querySelector('.ins-sub').textContent = d.sub;
      insRoot.querySelector('.ins-steps').innerHTML = d.steps.map(function (st, i) {
        return '<li class="ins-step" style="--k:' + i + '"><span class="ins-n" aria-hidden="true">' + (i + 1) + '</span><span class="ins-tx">' + st[0] + '</span>' + (st[1] ? demo(st[1]) : '') + '</li>';
      }).join('');
      var point = insRoot.querySelector('.ins-point');
      point.hidden = !d.point;
      point.querySelector('.ins-point-tx').textContent = d.point || '';
      point.style.setProperty('--px', d.px || '50%');
      insRoot.querySelector('.ins-up').hidden = !d.up;
      var copy = insRoot.querySelector('.ins-copy');
      copy.hidden = !d.copy;
      copy.querySelector('span').textContent = 'Copy link';
    },
    fallback: function () { return document.querySelector('.ft-install'); }
  });
  insRoot.querySelector('.ins-copy').addEventListener('click', function () {
    var btn = this, url = location.origin + '/';
    var done = function () { btn.querySelector('span').textContent = 'Link copied'; };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () {});
    else {
      try { var t = document.createElement('textarea'); t.value = url; document.body.appendChild(t); t.select(); document.execCommand('copy'); t.remove(); done(); } catch (e) { /* nothing */ }
    }
  });
  function install(from) {
    if (installEvt) {
      var e = installEvt;
      installEvt = null; // a prompt can be shown once; Chrome sends a new one if it is dismissed
      try {
        e.prompt();
        Promise.resolve(e.userChoice).then(function (c) {
          if (c && c.outcome === 'accepted') write(INSTALL_KEY, { installed: Date.now() });
          renderInstall();
        }, function () {});
      } catch (err) { ins.open(from); }
      return;
    }
    ins.open(from);
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-install]');
    if (!b) return;
    e.preventDefault();
    if (b.classList.contains('m-install')) { closeMenu(); install(toggle); return; }
    install(b);
  });
  window.AllFunInstall = { open: function () { ins.open(); }, mode: installMode }; // for testing in the browser

  // ---- the offline page and the home-screen app: a tiny service worker (sw.js, network first) ---------
  if ('serviceWorker' in navigator && /^https?:$/.test(location.protocol)) {
    window.addEventListener('load', function () { navigator.serviceWorker.register('/sw.js').catch(function () { /* fine: the site works without it */ }); });
  }

  // ---- quick game search (owner, 21.10: "Search" in the dock, in place of Sign in) ------------------------
  // A sheet like the others (a bottom sheet on a phone, a dialog on a computer), with the field at the top. It is
  // focused as the sheet opens, so the phone's keyboard comes straight up. Results come as you type, all on this
  // device (no server): the game's name, its kind and category, and a few everyday words for it (WORDS). Empty: the
  // games played here lately, the popular ones and the categories. A result goes straight to the game; Enter opens
  // the first one (or the one picked with the arrows).
  var WORDS = {
    backgammon: 'tavla shesh besh nardy dice two player online',
    solitaire: 'klondike patience cards',
    spider: 'patience cards solitaire',
    freecell: 'free cell patience cards solitaire',
    hearts: 'cards tricks queen',
    spades: 'cards tricks partner bid',
    tripeaks: 'tri peaks patience cards solitaire',
    domino: 'domino dominos bones tiles',
    blocks: 'block puzzle lines grid',
    sort: 'water color colour tubes liquid pour',
    merge: 'numbers drop join',
    gems: 'jewels jewel match three match 3 swap',
    bubbles: 'bubble pop shooter balls aim',
    checkers: 'draughts dama',
    sudoku: 'numbers logic grid',
    mines: 'mine bombs flags dig logic',
    airhockey: 'hockey puck table',
    fishing: 'fish sea ocean hook',
    tabletennis: 'ping pong paddle',
    pinball: 'flippers bumpers',
    snake: 'worm',
    bricks: 'bricks ball paddle',
    chess: 'checkmate king queen',
    fourinarow: 'four in a row 4 in a row discs connect',
    ginrummy: 'rummy gin cards',
    pyramid: 'patience cards solitaire 13',
    racing: 'cars car race drift kart',
    basketball: 'hoops shoot ball',
    darts: 'dartboard 501 cricket',
    flags: 'geography countries capitals map world quiz',
    suitcase: 'packing travel trip',
    chefpath: 'cooking food chef recipe kitchen',
    chefdeck: 'cooking food chef plate',
    runner: 'endless run runner dash jump',
    trivia: 'quiz questions knowledge',
    tiles: 'match three tiles sea mahjong',
    ludo: 'dice race tokens',
    billiards: 'pool snooker 8 ball 9 ball cue',
    bolts: 'screws nuts pegboard',
    golf: 'putt putting minigolf',
    dice: 'dice roll five',
    royale: 'battle space laser shooter',
    lasso: 'cowboy western rope wild west',
    claw: 'claw machine crane plush prize toys',
    fizzwell: 'climb climbing jump jumping platformer platform well bounce',
    motorush: 'moto motorbike motorcycle bike race racing street city nitro rider riders online',
    strikedistrict: 'fight fighting fighter brawler martial arts kick punch combo 2d anime versus two player',
    skyshot: 'baseball base ball bat batting batter home run homerun slugger swing pitch pitcher ballpark stadium hit derby',
    wordwheel: 'word wheel words letters letter spell spelling anagram anagrams crossword word search wordsearch scramble vocabulary bonus lark daily',
    crazyeights: 'crazy eights 8s eight cards card game switch mau mau last card shedding match suit rank wild'
  };
  var CAT_LABEL = { arcade: 'Arcade', puzzle: 'Puzzle', cards: 'Cards', board: 'Board', sport: 'Sport' };
  var POPULAR = ['backgammon', 'solitaire', 'bubbles', 'billiards', 'blocks', 'fishing', 'chess', 'claw'];
  // The home grid's order (the footer's chips), for ties and for a category's list.
  var ORDER = (function () {
    var o = {}, i = 0;
    document.querySelectorAll('.ft-chip').forEach(function (c) {
      var m = /\bfg-([a-z]+)\b/.exec(c.className);
      if (m && GAMES[m[1]] && !(m[1] in o)) o[m[1]] = i++;
    });
    SLUGS.forEach(function (s) { if (!(s in o)) o[s] = i++; });
    return o;
  })();
  function fold(t) {
    return String(t || '').toLowerCase().normalize('NFKD').replace(/[̀-ͯ]/g, '').replace(/&/g, ' and ')
      .replace(/[’']/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  }
  var INDEX = SLUGS.map(function (slug) {
    var g = GAMES[slug];
    var cats = (CATEGORY[slug] || '').split(' ').filter(Boolean);
    return {
      slug: slug, name: fold(g.name), full: fold(g.full.replace(/^AllFun /, '')), id: fold(slug),
      words: fold(WORDS[slug] || ''), kind: fold(g.kind + ' ' + cats.map(function (c) { return CAT_LABEL[c] || c; }).join(' ')),
      cats: cats
    };
  });
  function hasWord(field, tok) { return (' ' + field).indexOf(' ' + tok) >= 0; }
  // One typo (a letter missing, extra, changed or two swapped) against the start of a word, from 4 letters.
  function near(a, b) {
    if (Math.abs(a.length - b.length) > 1) return false;
    var i = 0, j = 0, edits = 0;
    while (i < a.length && j < b.length) {
      if (a[i] === b[j]) { i++; j++; continue; }
      if (++edits > 1) return false;
      if (a[i + 1] === b[j] && a[i] === b[j + 1]) { i += 2; j += 2; continue; }
      if (a.length > b.length) i++; else if (b.length > a.length) j++; else { i++; j++; }
    }
    return edits + (a.length - i) + (b.length - j) <= 1;
  }
  function fuzzy(field, tok) {
    if (tok.length < 4) return false;
    return field.split(' ').some(function (w) { return near(w.slice(0, tok.length), tok) || near(w, tok); });
  }
  // Every word typed must be found; the name counts most, then the full name, the everyday words and the kind.
  function scoreOf(e, toks, q) {
    var total = 0, via = '';
    for (var k = 0; k < toks.length; k++) {
      var t = toks[k], s = 0;
      if (hasWord(e.name, t)) s = e.name.indexOf(t) === 0 ? 900 : 700;
      else if (t.length > 1 && e.name.indexOf(t) >= 0) s = 450;
      else if (hasWord(e.full, t) || hasWord(e.id, t)) s = 400;
      else if (hasWord(e.words, t)) { s = 300; via = via || t; }
      else if (hasWord(e.kind, t)) s = 220;
      else if (t.length > 2 && (e.words.indexOf(t) >= 0 || e.full.indexOf(t) >= 0)) { s = 160; via = via || t; }
      else if (fuzzy(e.name, t) || fuzzy(e.full, t)) s = 120;
      else if (fuzzy(e.words, t)) { s = 80; via = via || t; }
      if (!s) return null;
      total += s;
    }
    if (e.name === q) total += 2000; else if (e.name.indexOf(q) === 0) total += 600;
    return { score: total, via: via };
  }
  function search(raw) {
    var q = fold(raw);
    if (!q) return [];
    var toks = q.split(' ');
    var out = [];
    INDEX.forEach(function (e) {
      var r = scoreOf(e, toks, q);
      if (r) out.push({ slug: e.slug, score: r.score, via: r.via, words: e.words });
    });
    out.sort(function (a, b) { return b.score - a.score || ORDER[a.slug] - ORDER[b.slug]; });
    return out;
  }
  // The name with the typed words lit (the first place each one starts a word, else anywhere).
  function lit(name, raw) {
    var toks = fold(raw).split(' ').filter(Boolean);
    var low = name.toLowerCase(), marks = [];
    toks.forEach(function (t) {
      var at = -1, re = new RegExp('(^|[^a-z0-9])' + t.replace(/[^a-z0-9]/g, ''));
      var m = re.exec(low);
      if (m) at = m.index + m[1].length; else at = low.indexOf(t);
      if (at >= 0 && t) marks.push([at, at + t.length]);
    });
    marks.sort(function (a, b) { return a[0] - b[0]; });
    var html = '', pos = 0;
    marks.forEach(function (m) {
      if (m[0] < pos) return;
      html += esc(name.slice(pos, m[0])) + '<mark>' + esc(name.slice(m[0], m[1])) + '</mark>';
      pos = m[1];
    });
    return html + esc(name.slice(pos));
  }
  var srRoot = document.getElementById('search-pop');
  var srInput = srRoot.querySelector('.sr-q');
  var srClear = srRoot.querySelector('.sr-clear');
  var srList = srRoot.querySelector('.sr-list');
  var srNone = srRoot.querySelector('.sr-none');
  var srCats = srRoot.querySelector('.sr-cats');
  var srLive = srRoot.querySelector('#sr-live');
  var srCat = '', srActive = 0, srTimer = 0;
  srInput.placeholder = 'Search games';
  var CAT_ICON = {};
  CATS.forEach(function (c) { CAT_ICON[c[0]] = c[2]; });
  function srChips() {
    var list = (favs.length ? ['fav'] : []).concat(['arcade', 'puzzle', 'cards', 'board', 'sport']);
    if (srCat === 'fav' && !favs.length) srCat = '';
    srCats.innerHTML = list.map(function (c) {
      var n = c === 'fav' ? favs.length : catCount(c);
      return '<button class="sr-chip mc-' + c + '" type="button" data-cat="' + c + '" aria-pressed="' + (srCat === c) + '">' +
        '<span class="sr-chip-ic" aria-hidden="true"><svg viewBox="0 0 24 24">' + CAT_ICON[c] + '</svg></span>' +
        '<span>' + (c === 'fav' ? 'Favorites' : CAT_LABEL[c]) + '</span><span class="sr-chip-n">' + n + '</span></button>';
    }).join('');
  }
  function srRow(slug, i, raw, via) {
    var g = GAMES[slug];
    var r = null;
    for (var k = 0; k < played.length; k++) if (played[k].slug === slug) { r = played[k]; break; }
    var sub = r ? statusHTML(r) : esc(g.kind);
    if (via && !r) {
      var w = (' ' + WORDS[slug] + ' ').toLowerCase();
      var at = w.indexOf(' ' + via);
      var word = at >= 0 ? w.slice(at + 1, w.indexOf(' ', at + 1)) : via;
      sub += ' <span class="sr-via">· “' + esc(word) + '”</span>';
    }
    return '<a class="sr-opt t-' + slug + '" role="option" id="sr-o-' + slug + '" href="/' + slug + '/" tabindex="-1" aria-selected="false" style="--k:' + i + '"' +
      ' aria-label="' + esc(g.name) + ', ' + esc(r ? r.line : g.kind) + '">' +
      '<span class="cc-ic sr-ic" aria-hidden="true">' + art(r || { slug: slug }) + '</span>' +
      '<span class="sr-tx"><b>' + (raw ? lit(g.name, raw) : esc(g.name)) + '</b><span class="sr-st">' + sub + '</span></span>' +
      '<span class="sr-go" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M8 5.5v13l10.5-6.5z"/></svg>Play</span></a>';
  }
  function srGroup(title, rows) {
    if (!rows) return '';
    var id = 'sr-g' + (srGroup.n = (srGroup.n || 0) + 1);
    return '<div class="sr-grp" role="group" aria-labelledby="' + id + '"><p class="sr-h" id="' + id + '" role="presentation">' + title + '</p>' + rows + '</div>';
  }
  function srRender(announce) {
    var raw = srInput.value, q = fold(raw), html = '', n = 0, k = 0;
    srClear.hidden = !raw;
    srCats.querySelectorAll('.sr-chip').forEach(function (b) { b.setAttribute('aria-pressed', String(srCat === b.dataset.cat)); });
    if (q) {
      var found = search(raw);
      n = found.length;
      html = srGroup(n === 1 ? '1 game' : n + ' games', found.map(function (f) { return srRow(f.slug, k++, raw, f.via); }).join(''));
      srNone.hidden = !!n;
      if (!n) srNone.querySelector('.sr-none-t').textContent = 'No game called “' + raw.trim().slice(0, 40) + '”';
    } else if (srCat) {
      var inCat = srCat === 'fav' ? favs.slice() : SLUGS.filter(function (s) { return (' ' + CATEGORY[s] + ' ').indexOf(' ' + srCat + ' ') >= 0; })
        .sort(function (a, b) { return ORDER[a] - ORDER[b]; });
      n = inCat.length;
      html = srGroup((srCat === 'fav' ? 'Favorites' : CAT_LABEL[srCat]) + ' · ' + plural(n, 'game', 'games'), inCat.map(function (s) { return srRow(s, k++); }).join(''));
      srNone.hidden = true;
    } else {
      var recent = played.slice(0, 3).map(function (r) { return r.slug; });
      var pop = POPULAR.filter(function (s) { return recent.indexOf(s) < 0; }).slice(0, recent.length ? 5 : 6);
      html = srGroup('Recently played', recent.map(function (s) { return srRow(s, k++); }).join('')) +
        srGroup('Popular', pop.map(function (s) { return srRow(s, k++); }).join(''));
      n = recent.length + pop.length;
      srNone.hidden = true;
    }
    srList.innerHTML = html;
    srMore();
    srList.hidden = !n;
    srMove(0, true);
    if (announce) {
      clearTimeout(srTimer);
      var say = q ? (n ? plural(n, 'game', 'games') + ' found' : 'No games found') : srCat ? plural(n, 'game', 'games') : '';
      srTimer = setTimeout(function () { srLive.textContent = say; }, 350);
    }
  }
  // More chips than fit: the row fades at the edge that still has some.
  function srMore() {
    var over = srCats.scrollWidth > srCats.clientWidth + 2;
    srCats.classList.toggle('fade-r', over && srCats.scrollLeft + srCats.clientWidth < srCats.scrollWidth - 4);
    srCats.classList.toggle('fade-l', over && srCats.scrollLeft > 4);
  }
  srCats.addEventListener('scroll', srMore, { passive: true });
  function srOpts() { return Array.prototype.slice.call(srList.querySelectorAll('.sr-opt')); }
  function srMove(i, quiet) {
    var o = srOpts();
    srActive = o.length ? Math.max(0, Math.min(o.length - 1, i)) : -1;
    o.forEach(function (el, k) { el.setAttribute('aria-selected', String(k === srActive)); el.classList.toggle('on', k === srActive); });
    if (srActive >= 0) {
      srInput.setAttribute('aria-activedescendant', o[srActive].id);
      if (!quiet && o[srActive].scrollIntoView) o[srActive].scrollIntoView({ block: 'nearest' });
    } else srInput.removeAttribute('aria-activedescendant');
  }
  var sr = makeSheet(srRoot, {
    dock: 'search',
    grab: '.cp-grab',
    render: function () { srInput.value = ''; srCat = ''; srChips(); srRender(false); },
    closed: function () { srInput.value = ''; srLive.textContent = ''; srFit(); },
    fallback: function () { return document.querySelector('.dock-search'); }
  });
  function openSearch(from) {
    sr.open(from);
    // In the same tap, so the phone's keyboard comes up (iOS only shows it for a focus inside the tap).
    try { srInput.focus({ preventScroll: true }); } catch (e) { srInput.focus(); }
    srFit();
    srMore();
  }
  srInput.addEventListener('input', function () { if (srInput.value) srCat = ''; srRender(true); });
  srInput.addEventListener('keydown', function (e) {
    var o = srOpts();
    if (e.key === 'ArrowDown') { e.preventDefault(); srMove(srActive + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); srMove(srActive - 1); }
    else if (e.key === 'Enter' && !e.isComposing) { e.preventDefault(); if (o[srActive]) o[srActive].click(); }
  });
  srClear.addEventListener('click', function () { srInput.value = ''; srRender(true); srInput.focus({ preventScroll: true }); });
  srCats.addEventListener('click', function (e) {
    var b = e.target.closest('.sr-chip');
    if (!b) return;
    srCat = srCat === b.dataset.cat ? '' : b.dataset.cat;
    srInput.value = '';
    srRender(true);
    srList.parentNode.scrollTop = 0;
  });
  srNone.addEventListener('click', function (e) {
    var b = e.target.closest('.sr-try');
    if (!b) return;
    srInput.value = b.dataset.q;
    srRender(true);
    srInput.focus({ preventScroll: true });
  });
  srList.addEventListener('pointermove', function (e) {
    var a = e.target.closest('.sr-opt');
    if (a && e.pointerType === 'mouse') srMove(srOpts().indexOf(a), true);
  });
  // A phone: a swipe through the results puts the keyboard away, so more of them show.
  srList.parentNode.addEventListener('touchmove', function () { if (document.activeElement === srInput) srInput.blur(); }, { passive: true });
  // A game was picked and the page changes: the sheet closes as the page goes, so going back finds the page as it was.
  window.addEventListener('pagehide', function () { if (sr.isOpen()) { srRoot.classList.add('quick'); sr.close(); } });
  window.addEventListener('pageshow', function () { srRoot.classList.remove('quick'); });
  // "/" or Ctrl/⌘ K opens it on a computer; Esc closes it wherever the focus went.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && sr.isOpen() && !srRoot.contains(e.target)) { e.preventDefault(); sr.close(); return; }
    var t = e.target, typing = t && (/^(INPUT|TEXTAREA|SELECT)$/.test(t.tagName) || t.isContentEditable);
    if ((e.key === '/' && !typing && !e.metaKey && !e.ctrlKey && !e.altKey) || ((e.metaKey || e.ctrlKey) && (e.key === 'k' || e.key === 'K'))) {
      if (document.body.classList.contains('cp-open') && !sr.isOpen()) return;
      e.preventDefault();
      if (sr.isOpen()) srInput.focus(); else openSearch(document.querySelector('.dock-search'));
    }
  });
  // The phone's keyboard: the sheet fills only the part of the screen the keyboard leaves (visualViewport), so the
  // field and the first results stay in view.
  function srFit() {
    var vv = window.visualViewport;
    var on = !!vv && sr.isOpen() && vv.height < window.innerHeight - 80;
    srRoot.classList.toggle('kb', on);
    srRoot.style.top = on ? Math.round(vv.offsetTop) + 'px' : '';
    srRoot.style.height = on ? Math.round(vv.height) + 'px' : '';
    srRoot.style.bottom = on ? 'auto' : '';
  }
  if (window.visualViewport) {
    var srQueued = false;
    var srLater = function () { if (!srQueued) { srQueued = true; requestAnimationFrame(function () { srQueued = false; srFit(); }); } };
    window.visualViewport.addEventListener('resize', srLater);
    window.visualViewport.addEventListener('scroll', srLater);
  }
  window.AllFunSearch = { open: function () { openSearch(); }, find: function (q) { return search(q).map(function (r) { return r.slug; }); } };

  // ---- signed in or not: the header's Sign in, the menu's card and the footer -----------------------
  // Signed in (an allfun.games account, ACCOUNTS above): the header's button reads "Profile" (owner, 21.10) with the
  // ring filled and a mint dot; the menu and the footer read "Account". Preview: add ?account to the address to see it
  // without an account.
  function renderAccount(on) {
    if (menuAcct) {
      menuAcct.classList.toggle('signed-in', on);
      menuAcct.querySelector('.m-acct-tx b').textContent = on ? 'Account' : 'Sign in';
      menuAcct.querySelector('.m-acct-tx > span').innerHTML = on ? 'Your progress, synced' : 'Save your progress<span class="m-more"> on every device</span>';
    }
    document.querySelectorAll('.nav-signin').forEach(function (b) {
      b.classList.toggle('signed-in', on);
      var t = b.querySelector('.ns-tx'); if (t) t.textContent = on ? 'Profile' : 'Sign in';
    });
    document.querySelectorAll('.ft-acct .ft-pt').forEach(function (t) { t.textContent = on ? 'Account' : 'Sign in'; });
    // Signed in: the avatar shows the email's first letter (the header).
    var a = on && auth();
    var initial = a && typeof a.email === 'string' ? a.email.trim().charAt(0).toUpperCase() : '';
    document.querySelectorAll('.nav-signin .av-i').forEach(function (i) { i.textContent = /^[A-Z0-9]$/.test(initial) ? initial : ''; });
    // A picture chosen in a game (Plush Pluck's "Set as my picture", round 144): allfun.avatar.v1 holds a small round
    // image of a plush from the player's own Prize Shelf. Only an inline WebP/PNG/JPEG may become a background.
    var pic = null;
    try {
      var av = on && JSON.parse(localStorage.getItem('allfun.avatar.v1') || 'null');
      if (av && typeof av.img === 'string' && av.img.length < 60000 && /^data:image\/(webp|png|jpeg);base64,[A-Za-z0-9+\/=]+$/.test(av.img)) pic = av.img;
    } catch (e) { pic = null; }
    document.querySelectorAll('.nav-signin .av').forEach(function (n) {
      n.classList.toggle('has-pic', !!pic);
      n.style.backgroundImage = pic ? 'url("' + pic + '")' : '';
      if (pic) { var i = n.querySelector('.av-i'); if (i) i.textContent = ''; }
    });
  }
  renderAccount(isSignedIn() || /[?&]account(?:[=&]|$)/.test(location.search));
  // Signed in: bring the account's saves in now (a device that never finished its first sync asks
  // which progress to keep), and again when the player comes back to this page from a game.
  function syncOnArrival() {
    if (!isSignedIn()) return;
    if (meta()) { syncNow(); return; }
    firstSync().then(function (res) {
      if (res && res.ask && !si.isOpen()) { si.open(); askChoice(res, false); }
    }, function () { /* offline: next visit */ });
  }
  setTimeout(syncOnArrival, 60);
  window.addEventListener('pageshow', function (e) { if (e.persisted) syncOnArrival(); });
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && isSignedIn() && Date.now() - lastSync > 30000) syncOnArrival();
  });

  // ---- the bottom dock: a pill that follows the page, a bounce on tap -----------------------------
  var dock = document.querySelector('.dock');
  var dockItems = dock ? Array.prototype.slice.call(dock.querySelectorAll('.dock-item')) : [];
  // Games · Continue · Favorites · Search. The pill rides on Games while the games are on screen (home);
  // Continue, Favorites and Search hold it only while their sheet is open.
  var DOCK_INDEX = { library: 0, cont: 1, fav: 2, search: 3 };
  var spyLock = 0;
  function dockSet(key) {
    if (!dock) return;
    var i = key in DOCK_INDEX ? DOCK_INDEX[key] : -1;
    dock.classList.toggle('pill-off', i < 0);
    if (i >= 0) dock.style.setProperty('--i', i);
    dockItems.forEach(function (a, k) {
      if (k === i && key === 'library') a.setAttribute('aria-current', 'location'); else a.removeAttribute('aria-current');
      a.classList.toggle('on', k === i);
    });
  }
  var secLib = document.getElementById('library');
  function spy(force) {
    if (!dock || (!force && Date.now() < spyLock) || document.body.classList.contains('cp-open')) return;
    var line = window.innerHeight * 0.42;
    var key = 'none';
    if (secLib) {
      var r = secLib.getBoundingClientRect();
      if (r.top < line && r.bottom >= line * 0.6) key = 'library';
    }
    dockSet(key);
  }
  if (dock) {
    var spyQueued = false;
    window.addEventListener('scroll', function () {
      if (spyQueued) return;
      spyQueued = true;
      requestAnimationFrame(function () { spyQueued = false; spy(); });
    }, { passive: true });
    window.addEventListener('scrollend', function () { spyLock = 0; spy(); });
    // First measured in the next frame, with the page's other start-up reads (one layout instead of several).
    requestAnimationFrame(function () { spy(true); });
    dock.addEventListener('click', function (e) {
      var a = e.target.closest('.dock-item');
      if (!a) return;
      var ic = a.querySelector('.dock-ic');
      ic.classList.remove('pop');
      void ic.offsetWidth;
      ic.classList.add('pop');
      if (a.classList.contains('has-paused')) { e.preventDefault(); openPop(a); return; }
      if (a.classList.contains('dock-fav')) { fv.open(a); return; }
      if (a.classList.contains('dock-search')) { openSearch(a); return; }
      if (a.dataset.sec) { dockSet(a.dataset.sec); spyLock = Date.now() + 1100; }
    });
    dock.addEventListener('animationend', function (e) { if (e.target.classList.contains('dock-ic')) e.target.classList.remove('pop'); });
  }
  // The dock stays put (owner, 21.10: "always stuck to the bottom, whatever happens"). It is fixed to the bottom in the
  // CSS, with no movement of its own. Here: while a text field has the phone's keyboard up it fades out where it is
  // (body.kb-up; a keyboard can lift a fixed bar into the middle of the screen), and after a rotation or a return from a
  // game (the page restored as it was) it is laid out again, so it can never stay where the old screen had it.
  if (dock) {
    var coarse = window.matchMedia('(pointer: coarse)');
    var kbField = function (el) {
      return !!el && (el.isContentEditable || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT' ||
        (el.tagName === 'INPUT' && !/^(button|submit|reset|checkbox|radio|range|file|image|color|hidden)$/i.test(el.type || '')));
    };
    var kbState = function () { document.body.classList.toggle('kb-up', coarse.matches && kbField(document.activeElement)); };
    document.addEventListener('focusin', kbState);
    document.addEventListener('focusout', function () { setTimeout(kbState, 0); });
    var relayout = function () { dock.style.display = 'none'; void dock.offsetHeight; dock.style.display = ''; };
    window.addEventListener('orientationchange', function () { requestAnimationFrame(relayout); setTimeout(relayout, 400); });
    window.addEventListener('pageshow', function (e) { kbState(); if (e.persisted) requestAnimationFrame(relayout); });

    // iOS 26 (Safari, and Chrome on iPhone, which runs on the same engine): when the browser's bottom bar hides on
    // scroll, a bar fixed to the bottom can stay where the bar's top was ("it floats up", owner 28.10; WebKit bug
    // 297779). The visible area (visualViewport) does reach the screen's foot, so the dock is lowered by the gap
    // between the bottom it is fixed to and the visible bottom — only when that gap opens; 0 everywhere else (a
    // keyboard makes the visible area shorter, never longer, and is handled above). ?vvdebug=1 shows the numbers.
    var vv = window.visualViewport;
    if (vv && coarse.matches) {
      var debug = /[?&]vvdebug=1/.test(location.search) ? document.createElement('pre') : null;
      if (debug) {
        debug.style.cssText = 'position:fixed;left:6px;top:calc(6px + env(safe-area-inset-top,0px));z-index:9999;margin:0;padding:6px 8px;' +
          'font:11px/1.35 ui-monospace,monospace;color:#fff;background:rgba(0,0,0,.78);border-radius:8px;pointer-events:none;white-space:pre';
        document.body.appendChild(debug);
      }
      var lastGap = -1, queued = false;
      var fitDock = function () {
        queued = false;
        var layout = document.documentElement.clientHeight;
        var visible = vv.offsetTop + vv.height;
        var gap = Math.round(visible - Math.min(layout, window.innerHeight));
        gap = gap > 2 && gap < 160 ? gap : 0;
        if (gap !== lastGap) {
          lastGap = gap;
          dock.style.setProperty('--vv-gap', gap + 'px');
        }
        if (debug) {
          var r = dock.getBoundingClientRect();
          debug.textContent = 'innerH ' + window.innerHeight + '  clientH ' + layout + '\nvv.h ' + Math.round(vv.height) + '  vv.top ' +
            Math.round(vv.offsetTop) + '\ndock bottom ' + Math.round(r.bottom) + '  gap ' + gap + '\nscrollY ' + Math.round(window.scrollY);
        }
      };
      var later = function () { if (!queued) { queued = true; requestAnimationFrame(fitDock); } };
      vv.addEventListener('resize', later);
      vv.addEventListener('scroll', later);
      window.addEventListener('scroll', later, { passive: true });
      window.addEventListener('resize', later);
      // First measured in the next frame, with the page's other start-up reads (speed, 29.10: measured here, the browser
      // had to lay out the whole page in the middle of this script; the dock still takes its place in the same frame).
      later();
    }
  }

  // ---- the header's rail on a computer: a lit pill slides under the link the pointer is on ----------
  // and rests on the section in view (Games, Daily, Coming soon on the home page) or the page (Contact).
  (function navRail() {
    var rail = document.getElementById('site-menu');
    if (!rail) return;
    var wide = window.matchMedia('(min-width: 761px)');
    var links = Array.prototype.slice.call(rail.querySelectorAll('a.link.m-item'));
    if (!links.length) return;
    var ind = document.createElement('span');
    ind.className = 'nav-ind';
    ind.setAttribute('aria-hidden', 'true');
    rail.insertBefore(ind, rail.firstChild);
    var onContact = /\/contact(\.html)?$/.test(location.pathname);
    var onBoards = /^\/leaderboards\/?(index\.html)?$/.test(location.pathname);
    var onGuides = /^\/guides\//.test(location.pathname);
    var cur = null, over = null;
    if (onContact) links.forEach(function (l) { if (l.classList.contains('mi-contact')) l.setAttribute('aria-current', 'page'); });
    if (onBoards) links.forEach(function (l) { if (l.classList.contains('mi-lb')) l.setAttribute('aria-current', 'page'); });
    if (onGuides) links.forEach(function (l) { if (l.classList.contains('mi-guides')) l.setAttribute('aria-current', 'page'); });
    function place(el, still) {
      ind.classList.toggle('still', !!still);
      if (!el || !wide.matches) { ind.classList.remove('on'); return; }
      ind.style.width = el.offsetWidth + 'px';
      ind.style.transform = 'translateX(' + el.offsetLeft + 'px)';
      ind.classList.add('on');
      ind.classList.toggle('hover', el !== cur);
    }
    function current() {
      if (onContact) return rail.querySelector('.mi-contact');
      if (onBoards) return rail.querySelector('.mi-lb');
      if (onGuides) return rail.querySelector('.mi-guides');
      if (!onHome) return null;
      var line = window.innerHeight * 0.4, found = null;
      [['library', '.mi-games'], ['daily', '.mi-daily'], ['soon', '.mi-soon']].forEach(function (p) {
        var sec = document.getElementById(p[0]);
        if (!sec) return;
        var r = sec.getBoundingClientRect();
        if (r.top < line && r.bottom > line * 0.5) found = rail.querySelector(p[1]);
      });
      return found;
    }
    function update(still) {
      var c = current();
      if (c !== cur) {
        links.forEach(function (l) { l.classList.toggle('is-on', l === c); });
        cur = c;
      }
      if (!over) place(cur, still);
    }
    links.forEach(function (l) {
      l.addEventListener('pointerenter', function (e) { if (e.pointerType === 'touch') return; over = l; place(l); });
      l.addEventListener('focus', function () { if (l.matches(':focus-visible')) { over = l; place(l); } });
      l.addEventListener('blur', function () { if (over === l) { over = null; place(cur); } });
    });
    rail.addEventListener('pointerleave', function () { over = null; place(cur); });
    var queued = false;
    window.addEventListener('scroll', function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; update(); });
    }, { passive: true });
    window.addEventListener('resize', function () { place(over || cur, true); });
    if (wide.addEventListener) wide.addEventListener('change', function () { place(over || cur, true); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { update(true); place(over || cur, true); });
    requestAnimationFrame(function () { update(true); });
  })();

  // Back from a game (the browser may restore this page as it was) or a save changed in another tab.
  function refresh() {
    played = visibleProgress();
    renderContinue();
    if (!pop.hidden && pop.classList.contains('open') && !listEl.querySelector('.leaving')) renderList();
    favs = getFavs();
    renderFavs();
    hook('refreshed');
    if (fv.isOpen() && !fvList.querySelector('.leaving')) fvRender();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  window.addEventListener('storage', function (e) { if (!e.key || e.key === HOME_KEY || /^(bg|allfun)\./.test(e.key)) { memory = read(HOME_KEY) || memory; refresh(); } });

  // iOS shows :active only when the page listens to touches.
  document.addEventListener('touchstart', function () {}, { passive: true });

  // ---- animations rest while off screen ---------------------------------------------------------
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { en.target.classList.toggle('off', !en.isIntersecting); });
    }, { rootMargin: '60px 0px' });
    // (.ft-dl and .ft-install, the footer's install link and button, move on their own too: speed, 29.10.)
    document.querySelectorAll('.anim, .ft-dl, .ft-install').forEach(function (n) { io.observe(n); });
  }

  // ---- for the page's own script -----------------------------------------------------------------
  window.AllFun = {
    GAMES: GAMES, reduce: reduce, read: read, fmt: fmt, esc: esc, plural: plural, dateKey: dateKey,
    hooks: hooks,                                   // continueRendered, favsRendered, favsBumped, favToggled, favsChanged, favBrowse, refreshed
    setArt: function (f) { art = f; },              // the picture in a sheet's row
    played: function () { return played; },         // the paused games, most recent first
    favs: function () { return favs; },             // the favorites, in the order they were added
    statusHTML: statusHTML, favBtnHTML: favBtnHTML, bump: bump,
    renderContinue: renderContinue, renderFavs: renderFavs, spy: spy,
    openContinue: function (from) { openPop(from); }
  };
})();
